import React, {  Component } from 'react';
import { connect } from 'react-redux';
import { browserHistory } from 'react-router';

import _ from 'lodash';
import moment from 'moment';
import 'moment-timezone';
import { v4 as uuidv4 } from 'uuid'

import Header from './common/Header';
import Footer from '../common/Footer';
import Loader from '../common/loader';

var builder = require('xmlbuilder');

/*Actions*/
import {
	setDefaultADC,
	setSelectedADC,
	checkServicePrices,
	getPriceOrder,
	ajaxRequestInitiated,
	ajaxRequestCompleted,
	saveBackupCartItem,
	savePriceSheets,
	saveApproveReturnsList,
	updateSelectedItems,
	saveSelectedAccountsAllPriceSourcesWithoutFilter,
	resetBrochurePayload,
	selectBrochureCreateOption,
	getSavedBrochures,
	getOrderList,
	saveAccountResponsibility,
	updateSelectedAddress,
	resetPricesToOrder,
	resetLoadIndicatorBySiteNumber,
	saveAllJobSiteAddressList,
	checkForPrices,
	getTokenAccount,
	getDocuments,
	checkItemOrderability,
	saveAvailabilityToCart,
	saveRoleList,
	getOrderDetails,
	resetPricesToCart,
	resetServicesPricesToCart,
	getAccountResponsibility,
	resetAvailabilityToCart,
	resetAvailabilityToList,
	saveLoadIndicatorBySiteNumber,
	updateLoadIndicatorBySiteNumber,
	adminDLCheck,
	checkManageSiteAccess,
	checkAvailabilityGeneric,
	setAvailabilityError,
	savePimDataForList,
	saveRequestReturnList,
	updateHomePageAssetsFromBackup,
	resetErrorsObjectInStore,
	resetBrochureObjectInStore,
	resetExportObjectInStore,
	resetHomePageObjectInStore,
	resetLoadingObjectInStore,
	resetOrderObjectInStore,
	resetPackageObjectInStore,
	resetPriceTagsObjectInStore,
	resetProductObjectInStore,
	resetRegistrationObjectInStore,
	resetResourcesObjectInStore,
	resetSearchKeywordObjectInStore,
	resetUserObjectInStore,
	saveUserDetails,
	saveApprovedAccountDetails,
	saveUserOtherDetails,
	resetCartObjectInStore,
	resetListObjectInStore,
	saveSelectedAccountAndPriceSource,
	getAccountDetails,
	saveAccountDetail,
	getAddressList,
	saveAddressList,
	getRelationShipPartyList,
	getAllTcaList,
	getAllAdjPrcMod,
	getAddressAttributes,
	saveAddressAttributes,
	saveRelationShipPartyList,
	saveAllTcaList,
	saveAllAdjPrcModifier,
	checkForBackOrders,
	checkForBulkOrdersHold,
	saveIsBackOrdersAvailable,
	saveIsBulkOrdersHoldAvailable,
	updateUserASMOrNot,
	checkOtherAccountASM,
	updateUserIsInDLOrNot,
	getLocalUserDetails,
	updateUserAdminOrNot,
	getUsersOfAccount,
	getList,
	getCart,
	checkPricesForSearchResult,
	saveNumberOfParallelCallForProductPrices,
	saveCompletedNumberOfParallelCallForProductPrices,
	getProductNumberKeywordResult,
	saveProductAvailabilityCallCompleted,
	resetProductNumberKeywordResultList,
	resetProductAvailabilityResultList,
	resetProductPricesResultList,
	saveSelectedAccountsAllPriceSources,
	getSelectedAccountsPriceSource,
	getShippingAddresses,
	saveShippingAddresses,
	getOrgAttributes,
	saveOrgAttributes,
	getPIMItemInfo,
	resetShippingAddresses,
	resetSearchKeywordSuggestionList,
	saveGEAccountNumbers,
	validateAccountNumber,
	updateCartOrderPoints,
	addErrorLogToStore,
	getAssets,
	populateLatestHomePageAssets,
	getSalesRepId,
	getSSOFromSalesRepId,
	getCustomerShipToDetails,
	saveCustomerShipToDetails,
	otherCustomerShipToDetailsForOrder,
	addErrorDetailsToStore,
	saveBackOrders,
	saveAvailabilityToList,
	saveProductResultAvailability,
	addressExceptionDispatch,
	postPunchOutData,
	getFileURL,
	checkForPartsPrices,
	/*new brochure change*/
	selectFeatureCreateOption,
	checkPricesForPartsSearchResult,
	clearPartsSearchResult,
	saveSelectedAccountASMDetails,
	setIsDpmAccount
} from '../../redux/actions';

import {
	processPricingResponse,
	processPimDataResponse,
	updateTagging,
	triggerGTMTag,
	checkForTokenAccountByMasterSA
} from '../../redux/util';

import {
	sendRequest
} from '../../redux/api/sendRequest';

import { routes } from '../../redux/api/routes';
const {
	localStorageVar,
	redirectURLCNetVar,
	pageSizeForGettingProductAvailability,
	pageSizeForGettingProductPrices,
	productAPIUrl,
	product,
	users,
	customerAPIUrl,
	resources,
	typeOfEmployeeAccessLevel,
	bootAPIUrl,
} = routes;

/* Dialogs */
import NotificationUpdateConfirmationOverlayDialog from '../dialogs/notificationUpdateConfirmationOverlayDialog';
import GenericOverlayDialog from '../dialogs/genericOverlayDialog';
import AddToBrochureOverlayDialog from '../dialogs/addToBrochureOverlayDialog';
import { ebsLineStatusMapping, FREIGHT_DOCUMENT_SUBCLASSES, INTERNATIONAL_CUSTOMER_SUBCLASSES, INTERNATIONAL_ZIP_CODE, MODIFIERS_EXCLUDED_FROM_VOLUME_DISCOUNT, PNET_APP_QUERY_PARAM, PNET_GOP_BATCH_SIZE, POK_ENABLED_SUBCLASSES } from '../common/partsNetConstants';
import { SHIPPING_METHODS_FOR_DELIVERY_CALENDAR } from '../common/LookUpTable';

const DM_SDS_DELIVERY = 'SDS Delivery';
const DM_HOME_DELIVERY = 'Home Delivery';
const DM_SDS_WILL_CALL = 'SDS Will Call';
const DM_SDS_NEXT_DAY_DELIVERY = 'SDS Next Day Delivery';
const DM_ADC_WILL_CALL = 'ADC Will Call';
// const DM_ADC_LTL = 'ADC LTL';
// const DM_ADC_TRUCKLOAD = 'ADC Truckload';
const DM_OTHER = 'Other Delivery Method';
const LBL_ENTERED = 'Entered';
const LBL_BOOKED = 'Booked';
const LBL_ARRIVED_AT_SDS = 'Arrived at SDS';
// const LBL_PENDNIG = 'Pending';
const LBL_CLOSED = 'Closed';
const LBL_AWAITING_SHIPPING= 'Awaiting Shipping';
const LBL_AWAITING_RETURN = 'Awaiting Return';
// const LBL_NA = '';
const LS_ENTERED = 'ENTERED';
const LS_BOOKED = 'BOOKED';
const LS_SUPPLY_ELIGIBLE = 'SUPPLY_ELIGIBLE';
const LS_SUPPLY_PARTIAL = 'SUPPLY_PARTIAL';
const LS_INTERNAL_REQ_REQUESTED = 'INTERNAL_REQ_REQUESTED';
const LS_INTERNAL_REQ_OPEN = 'INTERNAL_REQ_OPEN';
const LS_INTERNAL_REQ_PARTIAL = 'INTERNAL_REQ_PARTIAL';
const LS_AWAITING_SHIPPING = 'AWAITING_SHIPPING';
const LS_PICKED = 'PICKED';
const LS_PARTIAL_PICKED = 'PARTIAL_PICKED';
const LS_AWAITING_RECEIPT = 'AWAITING_RECEIPT';
const LS_AWAITING_FULFILLMENT = 'AWAITING_FULFILLMENT';
const LS_CLOSED = 'CLOSED';
const LS_AWAITING_RETURN = 'AWAITING_RETURN';

class App extends Component {

	constructor(props) {
		super(props);
		this.state = {
			customZipCode: '',
			customADC: '',
			itemOrderabilityBatchSize: 200,
			showSelectAtleastOneProductDialog: false,
			showWeAreSorryDialog: false,
			showAddToBrochureOverlayDialog: false,
			showSoldToInactiveOverlayDialog: false,
			genericDialogHeading: '',
			genericDialogText: '',
			modalButtons: '',
			isAnyAddressCallInProgress: false,
			lastLoginDate: null,
			totalPricingParallelCalls: 0,
			history: [],
			alreadyReplaceCalled: 0,
			batchSizeForGetItems: 10,
			addressException:false,
			lineStatusMapping: [{
				itemType: 'product',
				lineStatusMappingWithDeliveryMethod: [
					{
						lineStatus: LS_ENTERED,
						deliveryMethod: [
							{
								deliveryMethod: DM_SDS_DELIVERY,
								label: LBL_ENTERED
							}, {
								deliveryMethod: DM_HOME_DELIVERY,
								label: LBL_ENTERED
							}, {
								deliveryMethod: DM_SDS_WILL_CALL,
								label: LBL_ENTERED
							}, {
								deliveryMethod: DM_OTHER,
								label: LBL_ENTERED
							}
						]
					}, {
						lineStatus: LS_BOOKED,
						deliveryMethod: [
							{
								deliveryMethod: DM_SDS_DELIVERY,
								label: LBL_BOOKED
							}, {
								deliveryMethod: DM_HOME_DELIVERY,
								label: LBL_BOOKED
							}, {
								deliveryMethod: DM_SDS_WILL_CALL,
								label: LBL_BOOKED
							}, {
								deliveryMethod: DM_OTHER,
								label: LBL_BOOKED
							}
						]
					}, {
						lineStatus: LS_SUPPLY_ELIGIBLE,
						deliveryMethod: [
							{
								deliveryMethod: DM_SDS_DELIVERY,
								label: LBL_BOOKED
							}, {
								deliveryMethod: DM_HOME_DELIVERY,
								label: LBL_BOOKED
							}, {
								deliveryMethod: DM_SDS_WILL_CALL,
								label: LBL_BOOKED
							}, {
								deliveryMethod: DM_OTHER,
								label: LBL_BOOKED
							}
						]
					}, {
						lineStatus: LS_SUPPLY_PARTIAL,
						deliveryMethod: [
							{
								deliveryMethod: DM_SDS_DELIVERY,
								label: LBL_BOOKED
							}, {
								deliveryMethod: DM_HOME_DELIVERY,
								label: LBL_BOOKED
							}, {
								deliveryMethod: DM_SDS_WILL_CALL,
								label: LBL_BOOKED
							}, {
								deliveryMethod: DM_OTHER,
								label: LBL_BOOKED
							}
						]
					}, {
						lineStatus: LS_INTERNAL_REQ_REQUESTED,
						deliveryMethod: [
							{
								deliveryMethod: DM_SDS_DELIVERY,
								label: LBL_AWAITING_SHIPPING
							}, {
								deliveryMethod: DM_HOME_DELIVERY,
								label: LBL_AWAITING_SHIPPING
							}, {
								deliveryMethod: DM_SDS_WILL_CALL,
								label: LBL_AWAITING_SHIPPING
							}, {
								deliveryMethod: DM_OTHER,
								label: LBL_AWAITING_SHIPPING
							}
						]
					}, {
						lineStatus: LS_INTERNAL_REQ_OPEN,
						deliveryMethod: [
							{
								deliveryMethod: DM_SDS_DELIVERY,
								label: LBL_AWAITING_SHIPPING
							}, {
								deliveryMethod: DM_HOME_DELIVERY,
								label: LBL_AWAITING_SHIPPING
							}, {
								deliveryMethod: DM_SDS_WILL_CALL,
								label: LBL_AWAITING_SHIPPING
							}, {
								deliveryMethod: DM_OTHER,
								label: LBL_AWAITING_SHIPPING
							}
						]
					}, {
						lineStatus: LS_INTERNAL_REQ_PARTIAL,
						deliveryMethod: [
							{
								deliveryMethod: DM_SDS_DELIVERY,
								label: LBL_AWAITING_SHIPPING
							}, {
								deliveryMethod: DM_HOME_DELIVERY,
								label: LBL_AWAITING_SHIPPING
							}, {
								deliveryMethod: DM_SDS_WILL_CALL,
								label: LBL_AWAITING_SHIPPING
							}, {
								deliveryMethod: DM_OTHER,
								label: LBL_AWAITING_SHIPPING
							}
						]
					}, {
						lineStatus: LS_AWAITING_SHIPPING,
						deliveryMethod: [
							{
								deliveryMethod: DM_SDS_DELIVERY,
								label: LBL_ARRIVED_AT_SDS
							}, {
								deliveryMethod: DM_HOME_DELIVERY,
								label: LBL_ARRIVED_AT_SDS
							}, {
								deliveryMethod: DM_SDS_WILL_CALL,
								label: LBL_ARRIVED_AT_SDS
							}, {
								deliveryMethod: DM_OTHER,
								label: LBL_AWAITING_SHIPPING
							}
						]
					}, {
						lineStatus: LS_AWAITING_RECEIPT,
						deliveryMethod: [
							{
								deliveryMethod: DM_SDS_DELIVERY,
								label: LBL_BOOKED
							}, {
								deliveryMethod: DM_HOME_DELIVERY,
								label: LBL_BOOKED
							}, {
								deliveryMethod: DM_SDS_WILL_CALL,
								label: LBL_BOOKED
							}, {
								deliveryMethod: DM_OTHER,
								label: LBL_BOOKED
							}
						]
					}, {
						lineStatus: LS_PICKED,
						deliveryMethod: [
							{
								deliveryMethod: DM_SDS_DELIVERY,
								label: LBL_ARRIVED_AT_SDS
							}, {
								deliveryMethod: DM_HOME_DELIVERY,
								label: LBL_ARRIVED_AT_SDS
							}, {
								deliveryMethod: DM_SDS_WILL_CALL,
								label: LBL_ARRIVED_AT_SDS
							}, {
								deliveryMethod: DM_OTHER,
								label: LBL_AWAITING_SHIPPING
							}
						]
					}, {
						lineStatus: LS_PARTIAL_PICKED,
						deliveryMethod: [
							{
								deliveryMethod: DM_SDS_DELIVERY,
								label: LBL_ARRIVED_AT_SDS
							}, {
								deliveryMethod: DM_HOME_DELIVERY,
								label: LBL_ARRIVED_AT_SDS
							}, {
								deliveryMethod: DM_SDS_WILL_CALL,
								label: LBL_ARRIVED_AT_SDS
							}, {
								deliveryMethod: DM_OTHER,
								label: LBL_AWAITING_SHIPPING
							}
						]
					}, {
						lineStatus: LS_AWAITING_FULFILLMENT,
						deliveryMethod: [
							{
								deliveryMethod: DM_SDS_DELIVERY,
								label: LBL_CLOSED
							}, {
								deliveryMethod: DM_HOME_DELIVERY,
								label: LBL_CLOSED
							}, {
								deliveryMethod: DM_SDS_WILL_CALL,
								label: LBL_CLOSED
							}, {
								deliveryMethod: DM_OTHER,
								label: LBL_CLOSED
							}
						]
					}, {
						lineStatus: LS_CLOSED,
						deliveryMethod: [
							{
								deliveryMethod: DM_SDS_DELIVERY,
								label: LBL_CLOSED
							}, {
								deliveryMethod: DM_HOME_DELIVERY,
								label: LBL_CLOSED
							}, {
								deliveryMethod: DM_SDS_WILL_CALL,
								label: LBL_CLOSED
							}, {
								deliveryMethod: DM_OTHER,
								label: LBL_CLOSED
							}
						]
					}, {
						lineStatus: LS_AWAITING_RETURN,
						deliveryMethod: [
							{
								deliveryMethod: DM_SDS_DELIVERY,
								label: LBL_AWAITING_RETURN
							}, {
								deliveryMethod: DM_HOME_DELIVERY,
								label: LBL_AWAITING_RETURN
							}, {
								deliveryMethod: DM_SDS_WILL_CALL,
								label: LBL_AWAITING_RETURN
							}, {
								deliveryMethod: DM_OTHER,
								label: LBL_AWAITING_RETURN
							}
						]
					}
				]
			}, {
				// NOTE: For now we are not showing any services anywhere in manage order so currently below mapping is not getting used
				itemType: 'service',
				lineStatusMappingWithDeliveryMethod: [
					{
						lineStatus: LS_ENTERED,
						label: LBL_ENTERED
					}, {
						lineStatus: LS_BOOKED,
						label: LBL_BOOKED
					}, {
						lineStatus: LS_AWAITING_RECEIPT,
						label: LBL_BOOKED
					}, {
						lineStatus: LS_AWAITING_FULFILLMENT,
						label: LBL_CLOSED
					}, {
						lineStatus: LS_CLOSED,
						label: LBL_CLOSED
					}
				]
			}],

			// Parallel calls to get orderDetails in batches - Start
			orderNumbers: null,
			batchSize: 10,
			noOfBatches: 0,
			completedNoOfBacthes: 0,
			allBatchesCompleted: false,

			noOfParallelCallsOfOrderDetails: 0,
			completedNoOfParallelCallsOfOrderDetails: 0,
			orderDetailsOfOrderNumbers: [],
			// Parallel calls to get orderDetails in batches - End
			isPOKEnabled: props.state.user && props.state.user.selectedPriceSource && props.state.user.selectedPriceSource.AGREEMENT_TYPE === 'GEA Parts' &&
				POK_ENABLED_SUBCLASSES.includes(props.state.user.selectedPriceSource['Sub Account Classification']),
			isFreightDocumentAvailable: props.state.user && props.state.user.selectedPriceSource && props.state.user.selectedPriceSource.AGREEMENT_TYPE === 'GEA Parts' &&
				FREIGHT_DOCUMENT_SUBCLASSES.includes(props.state.user.selectedPriceSource['Sub Account Classification'])
		}
		this.updateAddressList = this.updateAddressList.bind(this);
		this.saveCustomZipCode = this.saveCustomZipCode.bind(this);
		this.isAnyModelIsRestrictedInSelectedAccount = this.isAnyModelIsRestrictedInSelectedAccount.bind(this);
		this.saveCustomADC = this.saveCustomADC.bind(this);
		this.getAddressListCombinedDataByAccountNumber = this.getAddressListCombinedDataByAccountNumber.bind(this);
		this.isAccountClassificationInExceptionList = this.isAccountClassificationInExceptionList.bind(this);
		this.checkItemOrderabilityInBatches = this.checkItemOrderabilityInBatches.bind(this);
		this.checkAvailabilityGenericInBatches = this.checkAvailabilityGenericInBatches.bind(this);
		this.checkItemOrderabilityInBatches2 = this.checkItemOrderabilityInBatches2.bind(this);
		this.zipCodeChangeConversion = this.zipCodeChangeConversion.bind(this);
		this.checkAvailabilityGeneric = this.checkAvailabilityGeneric.bind(this);
		this.sortyByDisplaySA = this.sortyByDisplaySA.bind(this);
		this.checkAvailabilityAndOrderability = this.checkAvailabilityAndOrderability.bind(this);
		this.checkAvailabilityAndOrderability2 = this.checkAvailabilityAndOrderability2.bind(this);
		this.checkIfAnyActiveSoldAddress = this.checkIfAnyActiveSoldAddress.bind(this);
		this.getItemDescriptionBySKU = this.getItemDescriptionBySKU.bind(this);
		this.getItemsSuggestionDetails = this.getItemsSuggestionDetails.bind(this);
		this.getAttributeBySalesAgreement = this.getAttributeBySalesAgreement.bind(this);
		this.handleCreateBrochure = this.handleCreateBrochure.bind(this);
		/*new brochure single change*/
		this.handleCreateFeature = this.handleCreateFeature.bind(this);
		this.handleDialog = this.handleDialog.bind(this);
		this.getWarehouseCodeDetailsFromBackOrBulkOrder = this.getWarehouseCodeDetailsFromBackOrBulkOrder.bind(this);
		this.getWarehouseCodeDetailsFromBackOrBulkOrderLineLevel = this.getWarehouseCodeDetailsFromBackOrBulkOrderLineLevel.bind(this);
		this.validateFDD = this.validateFDD.bind(this);
		this.isShowGESKU = this.isShowGESKU.bind(this);
		this.showAddNewAddressLink = this.showAddNewAddressLink.bind(this);
		this.checkAvailabilityGroupByDemandClass = this.checkAvailabilityGroupByDemandClass.bind(this);
		this.makePriceOrderServiceCall = this.makePriceOrderServiceCall.bind(this);
		this.makeParallelCalls = this.makeParallelCalls.bind(this);
		this.getAddressFromOrderHeader = this.getAddressFromOrderHeader.bind(this);
		this.isOrderAddressSameAsHeader = this.isOrderAddressSameAsHeader.bind(this);
		this.filterLinesBySalesAgreementSameAsHeader = this.filterLinesBySalesAgreementSameAsHeader.bind(this);
		this.getBrandCategory = this.getBrandCategory.bind(this);
		this.getAgreementType = this.getAgreementType.bind(this);
		this.getSalesAgreementParamForAvailability = this.getSalesAgreementParamForAvailability.bind(this);
		this.getPimDataInBatches = this.getPimDataInBatches.bind(this);
		this.hasRequestReturnAccess = this.hasRequestReturnAccess.bind(this);
		this.setDefaultADC = this.setDefaultADC.bind(this);
		this.checkGroupShipDateByAvailabilityAndDelivery = this.checkGroupShipDateByAvailabilityAndDelivery.bind(this);
		this.getPriceSheets = this.getPriceSheets.bind(this);
		this.checkInventoryFinancingSA = this.checkInventoryFinancingSA.bind(this);
		this.whichTypeOfEmployee = this.whichTypeOfEmployee.bind(this);
		this.isEmployeeHasAccessTo = this.isEmployeeHasAccessTo.bind(this);
		this.checkForOtherAccountASM = this.checkForOtherAccountASM.bind(this);
		this.getOrderShippingDetails = this.getOrderShippingDetails.bind(this);
		this.checkETA = this.checkETA.bind(this);
		this.checkAvailability = this.checkAvailability.bind(this);
		this.checkAvailabilityForOrder = this.checkAvailabilityForOrder.bind(this);
		this.getCombinedAddresses = this.getCombinedAddresses.bind(this);
		this.isAccessToMAPGuidelines = this.isAccessToMAPGuidelines.bind(this);
		this.getSelectedAccountNumber = this.getSelectedAccountNumber.bind(this);
		this.getShipToState = this.getShipToState.bind(this);
		this.getSelectedAccountType = this.getSelectedAccountType.bind(this);
		this.logout = this.logout.bind(this);
		this.getAddressesByCategory = this.getAddressesByCategory.bind(this);
		this.getAddressByCategory = this.getAddressByCategory.bind(this);
		this.getAccountDetailsAndAddressList = this.getAccountDetailsAndAddressList.bind(this);
		this.getLocalUserDetails = this.getLocalUserDetails.bind(this);
		this.checkAndSetIsAdminOrNot = this.checkAndSetIsAdminOrNot.bind(this);
		this.checkForBackOrders = this.checkForBackOrders.bind(this);
		this.checkForBulkOrdersHold = this.checkForBulkOrdersHold.bind(this);
		this.getList = this.getList.bind(this);
		this.getCart = this.getCart.bind(this);
		this.makeParallelCallsForCartPrices = this.makeParallelCallsForCartPrices.bind(this);
		this.makePricingServiceCall = this.makePricingServiceCall.bind(this);
		this.checkAndSetSearchResult = this.checkAndSetSearchResult.bind(this);
		this.getZipCode = this.getZipCode.bind(this);
		this.getState = this.getState.bind(this);
		this.getCountry = this.getCountry.bind(this);
		this.getShippingAddressesDetails = this.getShippingAddressesDetails.bind(this);
		this.getOrgAttributesByAttributeName = this.getOrgAttributesByAttributeName.bind(this);
		this.getLineStatusFromMapping = this.getLineStatusFromMapping.bind(this);
		this.getItemTypeByOrderDetails = this.getItemTypeByOrderDetails.bind(this);
		this.getItemType = this.getItemType.bind(this);
		this.addErrorLog = this.addErrorLog.bind(this);
		this.showErrorsOfPage = this.showErrorsOfPage.bind(this);
		this.fetchHomePageAssets = this.fetchHomePageAssets.bind(this);
		this.validateAccountNumber = this.validateAccountNumber.bind(this);
		this.isResponsibilityExists = this.isResponsibilityExists.bind(this);
		this.getPimDataForCartItem = this.getPimDataForCartItem.bind(this);
		this.getPimDataForListItem = this.getPimDataForListItem.bind(this);
		this.isThisAccountRestricted = this.isThisAccountRestricted.bind(this);
		this.getOrderDetailsInParallelBatches = this.getOrderDetailsInParallelBatches.bind(this);
		this.getDataFromParallelCall = this.getDataFromParallelCall.bind(this);
		this.getOrderDetailsFromParallelCall = this.getOrderDetailsFromParallelCall.bind(this);
		this.getPriceSources = this.getPriceSources.bind(this);
		this.fetchApproveReturnsList = this.fetchApproveReturnsList.bind(this);
		this.resetParallelCallsOrderDetails = this.resetParallelCallsOrderDetails.bind(this);
		this.getSalesAgreementList = this.getSalesAgreementList.bind(this);
		this.isVelocityCustomer = this.isVelocityCustomer.bind(this);
		this.addErrorDetailsToStore = this.addErrorDetailsToStore.bind(this);
		this.isPunchOutAccess = this.isPunchOutAccess.bind(this);
		this.transferCart = this.transferCart.bind(this);
	}
	// getPriceSheets for Dev, QA, Local environment
	getPriceSheets(callback) {
		const self = this;
		self.props.getTokenAccount('requestType=getTokenAccount&accountNumber='+self.getSelectedAccountNumber(), (response) => {
			if(response.status && response.responseObject) {
				if(response.responseObject.length === 0) {
					self.props.savePriceSheets([]);
					callback && callback();
				} else {
					// Do parallel call
					const promises = [];
					response.responseObject.forEach(item => {
						// Get Order Details: getOrderDetails in parallel
						promises.push(
							sendRequest(
								customerAPIUrl,
								resources.mapGuideLines.path,
								'',
								resources.mapGuideLines.method,
								`requestType=priceSheets&tokenAccount=${item.TOKEN_ACCOUNT}&folderName=${item.WCSC_FOLDER_NAME}`
							)
						);
					});
					self.props.ajaxRequestInitiated();
					Promise.all(promises).then((responses) => {
						// logic to combine all responses and then run call back
						if(responses.find(resp => !resp.status)) {
							self.props.ajaxRequestCompleted();
							browserHistory.push('/error');
						} else {
							let responseObject = [];
							if(responses.length > 0) {
								responses.forEach((resp, index) => {
									if(resp.status) {
										if(resp.responseObject && resp.responseObject.length) {
											responseObject.push({
												folderName: response.responseObject[index].WCSC_FOLDER_NAME,
												data: resp.responseObject
											});
										}
									} else {
										browserHistory.push('/error');
									}
								});
							} else {
								responseObject = [];
							}
							self.props.ajaxRequestCompleted();
							self.props.savePriceSheets(responseObject);
							callback && callback();
						}
					});
				}
			} else {
				browserHistory.push('/error');
			}
		});
	}

	// getPriceSheets for Production environment
	// getPriceSheets(callback) {
	// 	const self = this;
	// 	self.props.getDocuments('requestType=priceSheets&accountNumber='+self.getSelectedAccountNumber(), false, (response) => {
	// 		if(response.status && response.responseObject) {
	// 			const priceSheets = [];
	// 			response.responseObject.forEach((item) => {
	// 				const folderName = item.docFolder;
	// 				const index = priceSheets.findIndex(item => item.folderName === folderName);
	// 				if(index >= 0) {
	// 					priceSheets[index].data.push(item);
	// 				} else {
	// 					priceSheets.push({
	// 						folderName,
	// 						data: [item]
	// 					});
	// 				}
	// 			});
	// 			self.props.savePriceSheets(priceSheets);
	// 			callback && callback();
	// 		} else {
	// 			browserHistory.push('/error');
	// 		}
	// 	});
	// }

	resetParallelCallsOrderDetails() {
		this.setState({
			orderDetailsOfOrderNumbers: []
		});
	}

	getOrderDetailsInParallelBatches(orderNumbers, callback) {
		const self = this;
		orderNumbers = _.chunk(orderNumbers, self.state.batchSize);
		self.setState({
			orderNumbers: orderNumbers,	// Order numbers in batch
			noOfBatches: orderNumbers.length,
			allBatchesCompleted: false,
			// orderDetailsOfOrderNumbers: [],
		}, () => {
			// Start parallel calls
			self.startBatchParallelCalls(callback);
		});
	}

	pickTheDateFromString(dateStr, format = 'MM/DD/YYYY') {
		if(dateStr && dateStr.length >= 10) {
			return moment(dateStr.substring(0, 10)).format(format);
		} else {
			return '';
		}
	}

	startBatchParallelCalls(callback) {
		const self = this;
		const { noOfBatches, completedNoOfBacthes } = self.state;
		if (noOfBatches) {
			if(noOfBatches !== completedNoOfBacthes) {
				const currentBatchOrderNumbers = self.state.orderNumbers[completedNoOfBacthes];
				self.setState({
					noOfParallelCallsOfOrderDetails: currentBatchOrderNumbers.length,
					completedNoOfParallelCallsOfOrderDetails: 0,
				}, () => {
					self.makeParallelCallsToGetOrderDetails(currentBatchOrderNumbers, callback);
				});
			} else {
				self.setState({
					// reset all counters
					noOfBatches: 0,
					completedNoOfBacthes: 0,
					noOfParallelCallsOfOrderDetails: 0,
					completedNoOfParallelCallsOfOrderDetails: 0,
					// Set the flag
					allBatchesCompleted: true,
				}, () => {
					callback && callback();
				});
			}
		}
	}

	makeParallelCallsToGetOrderDetails(orderNumbers, callback) {
		const self = this;
		orderNumbers.forEach(orderNumber => {
			self.props.getOrderDetails('orderNumber='+orderNumber+'&requestType=getOrderDetails&accountNumber='+self.getSelectedAccountNumber(), (response) => {
				if(!response.status || !response.responseObject) {
					self.setState({
						errorMessage: response.responseMessage
					})
				} else {
					const { orderDetailsOfOrderNumbers, completedNoOfParallelCallsOfOrderDetails } = self.state;
					orderDetailsOfOrderNumbers.push(response.responseObject);
					self.setState({
						orderDetailsOfOrderNumbers,
						completedNoOfParallelCallsOfOrderDetails: completedNoOfParallelCallsOfOrderDetails + 1,
					}, () => {
						self.callBackAfterGettingOrderDetails(callback);
					});
				}
			});
		});
	}

	getDataFromParallelCall(orderLineId, orderNumber, field, defaultReturnValue) {
		const self = this,
			{ orderDetailsOfOrderNumbers } = self.state;
		const orderDetail = orderDetailsOfOrderNumbers.find(itm => itm.orderNumber === orderNumber);
		const itemDetails = orderDetail ? orderDetail.items.find(itm => orderLineId && itm.lineId === orderLineId.toString()) : null;
		if(itemDetails) {
			return itemDetails[field];
		}
		return defaultReturnValue !== undefined ? defaultReturnValue : "";
  	}

	getOrderDetailsFromParallelCall(orderNumber) {
		const self = this,
			{ orderDetailsOfOrderNumbers } = self.state;
		const orderDetail = orderDetailsOfOrderNumbers.find(itm => itm.orderNumber === orderNumber);
		return orderDetail;
  	}

	callBackAfterGettingOrderDetails(callback) {
		const self = this;
		const { completedNoOfBacthes, noOfParallelCallsOfOrderDetails, completedNoOfParallelCallsOfOrderDetails } = self.state;
		if(noOfParallelCallsOfOrderDetails === completedNoOfParallelCallsOfOrderDetails) {
			self.setState({
				completedNoOfBacthes: completedNoOfBacthes + 1,
			}, () => {
				self.startBatchParallelCalls(callback);
			});
		}
	}

	isAccessToMAPGuidelines() {
		const { user } = this.props.state;
		const { relationShipPartyList } = user;
		if(relationShipPartyList && relationShipPartyList.responseObject && _.find(relationShipPartyList.responseObject, {
			RELATIONSHIP_TYPE: 'MAP GE Appliances Group',
			RELATIONSHIP_STATUS: 'A',
			RELATIONSHIPCODE: 'Map Participating Member Of'
		})) {
			return true;
		}
		return false;
	}

	getPartsSalesAgreements = () => this.props.state.user
		&& this.props.state.user.selectedAccountsAllPriceSources
		&& this.props.state.user.selectedAccountsAllPriceSources.responseObject
		&& this.props.state.user.selectedAccountsAllPriceSources.responseObject.filter(priceSource => priceSource.AGREEMENT_TYPE === 'GEA Parts' && priceSource.STATUS === 'ACTIVE');

	isGEAPartsSalesAgreementSelected = () =>
		this.props.state.user && this.props.state.user.selectedPriceSource && this.props.state.user.selectedPriceSource.AGREEMENT_TYPE === 'GEA Parts';

	handleGetFreightDocument = event => {
		event.preventDefault();
		const subAccountClassification = this.props.state.user.selectedPriceSource['Sub Account Classification'] || '';
		const queryString = `requestType=getDiscountPDF&subClass=${subAccountClassification.split('-').at(-1)}&${PNET_APP_QUERY_PARAM}`;
	
		this.props.getFileURL(resources.freightDocument.path, queryString, freightDocumentURLResponse => {
			if (freightDocumentURLResponse.status) {
				freightDocumentURLResponse.responseObject && window.open(freightDocumentURLResponse.responseObject);
			}
		});
	}

	validateAccountNumber(index, accountNumber, callback) {
		const self = this;

		if(!accountNumber) {
			return;
		}

		let { userDetails, usersOfAccount, approvedAccounts } = self.props.state.user;
		usersOfAccount = usersOfAccount && usersOfAccount.responseObject ? usersOfAccount.responseObject : [];
		usersOfAccount = usersOfAccount.length > 0 ? _.filter(usersOfAccount, ['userId', userDetails.sso]) : [];

		if(usersOfAccount.length > 0) {
			usersOfAccount = usersOfAccount[0].accounts;
		}

		const { registration } = self.props.state;
		const accountDetails = registration.geAccountNumbers[index - 1] || {}
		const alreadyApprovedAccountMessage = [],
			alreadyPendingAccountMessage = [];
		let isAlreadyApproved = false;
		let isAlreadyPending = false;
		usersOfAccount.length > 0 && registration.geAccountNumbers.map((item, index) => {
			if(item.accountNumber === accountNumber) {
				const checkAvailability = _.find(usersOfAccount, ["accountNumber", item.accountNumber]);
				if (checkAvailability && checkAvailability.approvalStatus === "Pending"){
					if(alreadyPendingAccountMessage.indexOf(item.accountNumber) === -1) {
						alreadyPendingAccountMessage.push(item.accountNumber);
						isAlreadyPending = true;
					}
				}
			}
			return null;
		});
		approvedAccounts && approvedAccounts.responseObject && approvedAccounts.responseObject.length > 0 &&
		registration.geAccountNumbers.map((item, index) => {
			if(item.accountNumber === accountNumber) {
				const checkAvailability = _.find(approvedAccounts.responseObject, ["ACCOUNTNUMBER", item.accountNumber]);
				if (checkAvailability && checkAvailability.STATUS === "A"){
					if(alreadyApprovedAccountMessage.indexOf(item.accountNumber) === -1) {
						alreadyApprovedAccountMessage.push(item.accountNumber);
						isAlreadyApproved = true;
					}
				}
			}
			return null;
		});

		const currentAccIsAlreadyApprovedOrPending = usersOfAccount && _.find(usersOfAccount, itm => itm.accountNumber === accountNumber && itm.approvalStatus !== 'Deleted');
		if((isAlreadyApproved || isAlreadyPending || currentAccIsAlreadyApprovedOrPending)  && accountNumber !== ""){
			self.props.saveGEAccountNumbers({
				index,
				...accountDetails,
				value: accountNumber,
				valid: false,
				showLoader: false,
				isAlreadyApproved: currentAccIsAlreadyApprovedOrPending.approvalStatus === 'Approved',
				isAlreadyPending: currentAccIsAlreadyApprovedOrPending.approvalStatus === 'Pending',
			});
			// self.props.disableUpdateButton(false);
			callback && callback();
		} else if(!currentAccIsAlreadyApprovedOrPending && accountNumber !== "") {
			self.props.saveGEAccountNumbers({
				index,
				...accountDetails,
				value: accountNumber,
				valid: null,
				showLoader: true,
				isAlreadyApproved: false,
				isAlreadyPending: false,
			});
			self.props.validateAccountNumber(`accountNumber=${accountNumber}&requestType=getAccountDetails`, response => {
				if(response && response.responseObject && response.responseObject.length > 0){
					self.props.getAddressList(`accountNumber=${accountNumber}&partyId=${response.responseObject[0].PARTYID}&requestType=getAddressList`, false, resp => {
						if(resp.responseMessage != "Got the adress list"){
							self.props.saveGEAccountNumbers({
								index,
								...accountDetails,
								value: accountNumber,
								valid: true,
								accountName: response.responseObject[0].ACCOUNTDESCRIPTION,
								showLoader: false,
								isAlreadyApproved: false,
								isAlreadyPending: false,
							});
							callback && callback();
						}
						if(resp.status && resp.responseObject != false) {
							let isValidAccountNumber = false;
							if (response.responseObject.length > 0 && response.responseObject.find(item => item.STATUS === "A") &&
								resp.responseObject.find(item => item.PURPOSE === 'SOLD_TO' && item.STATUS === 'A' && (!item.PURPOSE_STATUS || item.PURPOSE_STATUS === 'A'))
							) {
								isValidAccountNumber = true;
							};
							self.props.saveGEAccountNumbers({
								index,
								...accountDetails,
								value: accountNumber,
								valid: isValidAccountNumber,
								accountName: isValidAccountNumber?response.responseObject[0].ACCOUNTDESCRIPTION:"",
								showLoader: false,
								isAlreadyApproved: false,
								isAlreadyPending: false,
							});
							callback && callback();
						}else{
							self.props.saveGEAccountNumbers({
						index,
						...accountDetails,
						value: accountNumber,
						valid: false,
						accountName: "",
						showLoader: false,
						isAlreadyApproved: false,
						isAlreadyPending: false,
						soldToSiteAddress: false
					});
					callback && callback();
						}
					});
				} else{
					self.props.saveGEAccountNumbers({
						index,
						...accountDetails,
						value: accountNumber,
						valid: false,
						accountName: "",
						showLoader: false,
						isAlreadyApproved: false,
						isAlreadyPending: false,
					});
					callback && callback();
				}
			});
		} else if(currentAccIsAlreadyApprovedOrPending && accountNumber !== "") {
			self.props.saveGEAccountNumbers({
				index,
				...accountDetails,
				value: accountNumber,
				valid: true,
				showLoader: false,
				isAlreadyApproved: currentAccIsAlreadyApprovedOrPending.approvalStatus === 'Approved',
				isAlreadyPending: currentAccIsAlreadyApprovedOrPending.approvalStatus === 'Pending',
			});
			// self.props.disableUpdateButton(false);
			callback && callback();
		}
	}

	addErrorLog(err) {
		this.props.addErrorLogToStore(err);
	}

	showErrorsOfPage(whichPage) {
		const self = this,
			{ errorsLog } = self.props.state.errors;
		const error = [];
		_.forEach(errorsLog, (item, index) => {
			if(item.location.indexOf(whichPage) !== -1) {
				error.push(<p key={index} className="bold red">{item.errorMessage}</p>);
			}
		});
		return error;
	}

    componentWillUnmount() {
        this.unlisten();
    }

	goBack(event) {
		event && event.preventDefault();
		browserHistory.goBack();
	}

	componentWillMount() {
		const self = this;

		self.unlisten = browserHistory.listen( location =>  {
			let { history, alreadyReplaceCalled } = self.state;
			if (location.action === 'PUSH') {
				history.push(location);
				alreadyReplaceCalled = 0;
			} else if (location.action === 'POP') {
				history.pop();
				alreadyReplaceCalled = 0;
			} else if (location.action === 'REPLACE') {
				// This is specific scenario for my profile pages and its sub pages
				alreadyReplaceCalled += 1;
				if(alreadyReplaceCalled === 2) {
					location.action = 'PUSH';
					history.push(location);
					alreadyReplaceCalled = 0;
				}
			}
			self.setState({
				history,
				alreadyReplaceCalled
			}, () => {
				// console.log("##### postlogin action: ", location.action);
				if (!(location.pathname === '/login' || location.pathname.indexOf('/prelogin') === 0) && (location.action === 'PUSH' || location.action === 'POP')) {
					updateTagging({pathname: window.location.pathname});
				}
			});
		});

		if(self.state.history.length === 0) {
			updateTagging({pathname: window.location.pathname});
		}

		var localStrogeObj = self.getLocalStorageVar(localStorageVar);
		if(localStrogeObj) {
			self.props.saveUserDetails({
				firstName: localStrogeObj.firstName,
				lastName: localStrogeObj.lastName,
				sso: localStrogeObj.sso,
				email: localStrogeObj.email,
				gessouid: localStrogeObj.gessouid,
				typeOfUser: localStrogeObj.typeOfUser,
				validUser: true,
				isASM: localStrogeObj.isASM?localStrogeObj.isASM:null,
				otherASM: localStrogeObj.otherASM?localStrogeObj.otherASM:null,
				isInDL: localStrogeObj.isInDL?localStrogeObj.isInDL:null,
				isSiteManagementAccess: localStrogeObj.isSiteManagementAccess?localStrogeObj.isSiteManagementAccess:null,
				isAdmin: localStrogeObj.isAdmin?localStrogeObj.isAdmin:null,
				jwt: localStrogeObj.jwt,
				entryDN: localStrogeObj.entryDN,
				adminAccess : localStrogeObj.adminAccess,
				manageSiteAccess : localStrogeObj.manageSiteAccess,
				punchOutAccess : localStrogeObj.punchOutAccess,
				punchOutAccNumber : localStrogeObj.punchOutAccNumber,
				punchOutSalesNumber : localStrogeObj.punchOutSalesNumber,
				punchoutRedirectUrl: localStrogeObj.punchoutRedirectUrl,
				punchoutPostUrl: localStrogeObj.punchoutPostUrl,
				punchoutBuyerCookie:localStrogeObj.punchoutBuyerCookie,
				punchoutFromIdentity: localStrogeObj.punchoutFromIdentity,
				punchoutToIdentity: localStrogeObj.punchoutToIdentity,
				punchoutSenderIdentity: localStrogeObj.punchoutSenderIdentity,
				punchoutSenderPassword: localStrogeObj.punchoutSenderPassword,
				punchoutUserAgent: localStrogeObj.punchoutUserAgent,
				payloadID: localStrogeObj.payloadID,
				isNonGEASsoUser: localStrogeObj.isNonGEASsoUser,
				isManRepSsoUser: localStrogeObj.isManRepSsoUser,
				omAccess : localStrogeObj.omAccess,
				isOktaLogin : localStrogeObj.isOktaLogin,
			});

			if (localStrogeObj.customZipCode || localStrogeObj.customADC) {
				self.setState({
					customZipCode: localStrogeObj.customZipCode || '',
					customADC: localStrogeObj.customADC || '',
				});
			}

			//Check if localstorage is having account list, then update store with latest list
			if(localStrogeObj.accountList) {
				self.props.saveApprovedAccountDetails(localStrogeObj.accountList);
			}

			//Check if localstorage is having userOtherDetails, then update store with userOtherDetails
			if(localStrogeObj.userOtherDetails) {
				self.props.saveUserOtherDetails(localStrogeObj.userOtherDetails);
			}

			// self.getLocalUserDetails(localStrogeObj.typeOfUser, localStrogeObj.sso, localStrogeObj.selectedAccount ? localStrogeObj.selectedAccount.ACCOUNTNUMBER : null, false);

			const queryAccountNumberFromSession = sessionStorage.getItem('accountNumberFromQuery');
			let accountNumberFromQuery = queryAccountNumberFromSession;
			if (!accountNumberFromQuery) {
				try {
					const params = new URLSearchParams(window.location.search);
					accountNumberFromQuery = params.get('accountNumber');
				} catch (e) {
					accountNumberFromQuery = null;
				}
			}
			if (accountNumberFromQuery) {
				try {
					sessionStorage.setItem('accountNumberFromQuery', accountNumberFromQuery);
				} catch (e) {
					// ignore storage failures
				}
			}
			
			//check if localstorage is having selected account and selected prices source details then udpate store
			if(localStrogeObj.selectedAccount && localStrogeObj.selectedPriceSource) {
				self.props.saveSelectedAccountAndPriceSource({
					selectedAccount: localStrogeObj.selectedAccount,
					selectedPriceSource: localStrogeObj.selectedPriceSource
				});
				self.getPriceSources(localStrogeObj.selectedAccount.ACCOUNTNUMBER, true)
				// Make service call and get all required details
				self.getAccountDetailsAndAddressList(localStrogeObj.selectedAccount.ACCOUNTNUMBER, true, localStrogeObj);
			} else if (!accountNumberFromQuery) {
				browserHistory.push("/home");
			}

			//Make parallel call for homepage assets and menu items
			self.fetchHomePageAssets();
		} else {
			browserHistory.push("/login");
		}
	}

	UNSAFE_componentWillReceiveProps(nextProps) {
		const currentPriceSource = this.props.state.user.selectedPriceSource;
		const nextPriceSource = nextProps.state.user.selectedPriceSource;
		const currentAccount = this.props.state.user.selectedAccount;
		const nextAccount = nextProps.state.user.selectedAccount;
		const currentRelationShipPartyList = this.props.state.user.relationShipPartyList;
		const nextRelationShipPartyList = nextProps.state.user.relationShipPartyList;
		if ((currentAccount && nextAccount ? currentAccount.ACCOUNTNUMBER !== nextAccount.ACCOUNTNUMBER : nextAccount !== currentAccount) || (nextRelationShipPartyList && currentRelationShipPartyList !== nextRelationShipPartyList)) {
			const isDpmAccount = Boolean(nextAccount && nextAccount.CUSTOMERCLASSCODE === 'DIRECT PROPERTY MGT REPLACEMEN' && nextRelationShipPartyList && nextRelationShipPartyList.responseObject && nextRelationShipPartyList.responseObject.some(relationship =>
				relationship.RELATIONSHIPCODE && relationship.RELATIONSHIPCODE.toUpperCase() === 'FOR BUSINESS PARTNER MEMBER OF' && relationship.RELATIONSHIP_STATUS === 'A'));
			this.props.setIsDpmAccount(isDpmAccount);
		}
		if (((currentAccount && nextAccount ? currentAccount.ACCOUNTNUMBER !== nextAccount.ACCOUNTNUMBER : nextAccount !== currentAccount) && nextPriceSource) || (nextPriceSource && (!currentPriceSource || currentPriceSource.AGREEMENT_TYPE !== nextPriceSource.AGREEMENT_TYPE))) {
			const {selectedAccount: {ACCOUNTNUMBER: nextAccountNumber}, userDetails: {sso}} = nextProps.state.user;

			if (nextPriceSource.AGREEMENT_TYPE === 'GEA Parts') {
					this.props.resetCartObjectInStore();
					this.getCart(sso, nextAccountNumber, true, true);
			} else {
				this.props.resetCartObjectInStore();
				this.getCart(sso, nextAccountNumber, true);
			}
			this.props.clearPartsSearchResult();

			if (currentAccount && currentAccount.ACCOUNTNUMBER === nextAccountNumber && currentPriceSource && nextPriceSource && currentPriceSource.AGREEMENT_TYPE !== nextPriceSource.AGREEMENT_TYPE) {
				if (currentPriceSource.AGREEMENT_TYPE === 'GEA Parts') {
					this.resetShipToAddress();
				}
				browserHistory.replace('/home');
			}
		}

		if (nextPriceSource && (!currentPriceSource || currentPriceSource['Sub Account Classification'] !== nextPriceSource['Sub Account Classification'])) {
			this.setState({
				isPOKEnabled: nextPriceSource.AGREEMENT_TYPE === 'GEA Parts' && POK_ENABLED_SUBCLASSES.includes(nextPriceSource['Sub Account Classification']),
				isFreightDocumentAvailable: nextPriceSource.AGREEMENT_TYPE === 'GEA Parts' && FREIGHT_DOCUMENT_SUBCLASSES.includes(nextPriceSource['Sub Account Classification'])
			});
		}

		const { selectedAddress: nextSelectedAddressString} = nextProps.state.user;
		const nextSelectedAddress = nextSelectedAddressString && JSON.parse(nextSelectedAddressString);
		const isInternationalPartsCustomer = nextPriceSource && (INTERNATIONAL_CUSTOMER_SUBCLASSES.includes(nextPriceSource['Sub Account Classification']) || nextPriceSource['Sub Account Classification'] === 'PARTS-AWD' && nextSelectedAddress && nextSelectedAddress.COUNTRY === 'CA');
		if (nextPriceSource && nextPriceSource.AGREEMENT_TYPE === 'GEA Parts' && nextSelectedAddress && 
			((this.state.isInternationalPartsCustomer && !isInternationalPartsCustomer) || (!this.state.isInternationalPartsCustomer && isInternationalPartsCustomer))) {
				this.setState({
					isInternationalPartsCustomer: !!isInternationalPartsCustomer
				})
		}

		const currentPriceSources = this.props.state.user.selectedAccountsAllPriceSources;
		const nextPriceSources = nextProps.state.user.selectedAccountsAllPriceSources;
		if (nextPriceSources && nextPriceSources !== currentPriceSources) {
			const activeSalesAgreements = nextPriceSources.responseObject ? nextPriceSources.responseObject.filter(salesAgreement => salesAgreement.STATUS === 'ACTIVE' &&
				(!salesAgreement.EXPIRATION_DATE || (salesAgreement.EXPIRATION_DATE && moment().isBefore(moment(salesAgreement.EXPIRATION_DATE))))) : [];

			this.setState({
				isPartsSalesAgreementsOnlyAccount: Boolean(activeSalesAgreements.length && activeSalesAgreements.length === activeSalesAgreements.filter(salesAgreement => salesAgreement.AGREEMENT_TYPE === 'GEA Parts').length)
			});
		}
	}

	getBrandCategory(sku, whichPimData) {
		const self = this;
		let pimData = null;
		if(whichPimData === 'cart') {
			const { cartPimData } = self.props.state.cart;
			pimData = cartPimData && cartPimData.pimData;
		} else if(whichPimData === 'list') {
			pimData = self.props.state.list.pimDataForList;
		}
		const pimItemData = pimData && _.find(pimData, {item_number: sku});
		return {
			brand: pimItemData ? pimItemData['geego_brand'] : undefined,
			category: pimItemData ? pimItemData['item_catalog_group'] : undefined,
		};
	}

	fireGTMTag(tagName, attributes) {
		triggerGTMTag(tagName, attributes);
	}

	fetchHomePageAssets(callback) {
		const self = this,
			{ assets } = self.props.state.homepage;
		if(!assets || !assets.responseObject) {
			self.props.getAssets(true, response => {
				self.props.populateLatestHomePageAssets();
				callback && callback();
			});
		} else {
			callback && callback();
		}
	}
	getCustomerClassCodeOfSelectedAccount() {
		const self = this;
		const { selectedAccount } = self.props.state.user;
		return selectedAccount && selectedAccount.CUSTOMERCLASSCODE ? selectedAccount.CUSTOMERCLASSCODE : '';
	}
	getSelectedAccountType() {
		const self = this;
		const { selectedAccount } = self.props.state.user;
		let accountType = 'RETAIL';
		const salesChannelCode = selectedAccount && (selectedAccount.SALESCHANNEL || selectedAccount.SALESCHANNELCODE);
		if (salesChannelCode === 'CONTRACT') {
			accountType = 'CONTRACT';
		} else if (salesChannelCode === 'PRO CHANNEL') {
			accountType = 'PRO CHANNEL';
		} else if (salesChannelCode === 'HQ') {
			accountType = 'HQ';
		}
		return accountType;
	}
	getSalesAgreementParamForAvailability(agreementNumber = null) {
		const self = this;
		const { selectedPriceSource, selectedAccountsAllPriceSources } = self.props.state.user;
		let priceSourceDetails = JSON.parse(JSON.stringify(selectedPriceSource));
		if (agreementNumber) {
			priceSourceDetails = selectedAccountsAllPriceSources.responseObject.find(item => item.AGREEMENT_NUMBER.toString() === agreementNumber.toString());
		}
		let params = '';
		if (priceSourceDetails && priceSourceDetails["Demand Class"]) {
			params = `&demandClass=${priceSourceDetails["Demand Class"]}`;
		}
		return params;
	}
	prepareBagItems(salesPriceData) {
		const bagItems = [];
		if(salesPriceData && salesPriceData.itemPrice && salesPriceData.itemPrice.discounts && salesPriceData.itemPrice.discounts.discount) {
			const bagItemsList = _.filter(salesPriceData.itemPrice.discounts.discount, item => item.bagitem);
			bagItemsList.forEach(item => {
				if(item.getItemAdjUnitPrice && item.getLineQty && item.getLineTotal) {
					bagItems.push({
						serviceId: item.bagitem,
						serviceName: item.bagitem,
						quantity: item.getLineQty || 0,
						price: item.getItemAdjUnitPrice ? parseFloat(item.getItemAdjUnitPrice).toFixed(2) : 0,
						extendedPrice: item.getLineTotal || 0,
						type: "BAG",
						priceSubType: item.priceSubType
					});
				}
			});
			// Tarrif bag items
			let tariffBagItemsList = _.filter(salesPriceData.itemPrice.discounts.discount, item => item.name && item.name.toLowerCase().indexOf('tariff') !== -1);
			tariffBagItemsList.forEach(item => {
				bagItems.push({
					serviceId: item.chargeTypeCode,
					serviceName: item.chargeTypeCode,
					quantity: item.parentLineQty || 0,
					price: item.amount ? parseFloat(item.amount).toFixed(2) : 0,
					extendedPrice: item.adjustedCharge || 0,
					type: "BAG",
					tariffBagItem: true,
					priceSubType: item.priceSubType
				});
			});
		}
		return bagItems;
	}
	getPriceSources(accountNumber, saveToStore, callback) {
		let self = this;
		self.getAccountResponsibility(accountNumber, () => {
			// reset existing list
			saveToStore && self.props.saveSelectedAccountsAllPriceSources(null);
			// Make third service call and then udpate data for sales agreement
			self.props.getSelectedAccountsPriceSource(`accountNumber=${accountNumber}&requestType=getSalesAgreementList`, response => {
				if(response.status && response.responseObject) {
					self.props.saveSelectedAccountsAllPriceSourcesWithoutFilter(JSON.parse(JSON.stringify(response.responseObject)));
					let responseObject = [];
					const { inventoryFinancingList } = self.props.state.user;
					response.responseObject.forEach(item => {
						if(item.STATUS === 'ACTIVE' &&
							item.Disallow_New_Releases !== 'Y' &&
							(!item.EXPIRATION_DATE || (item.EXPIRATION_DATE && moment().isBefore(moment(item.EXPIRATION_DATE))))
						) {
							let AGREEMENT_TYPE = item.AGREEMENT_TYPE;
							if (item.BILL_TO_LOCATION && inventoryFinancingList.find(itm => item.BILL_TO_LOCATION.toLowerCase().indexOf(itm) !== -1)) {
								AGREEMENT_TYPE = 'Inventory Financing';
							}
							responseObject.push({
								...item,
								AGREEMENT_TYPE: AGREEMENT_TYPE,
								ACCOUNT_NUMBER: item.ACCOUNT_NUMBER,
								AGREEMENT_NAME: item.AGREEMENT_NAME,
								DISPLAY_AGREEMENT_NAME: item.AGREEMENT_NAME,
								AGREEMENT_NUMBER: item.AGREEMENT_NUMBER
							});
						}
					});
					responseObject = self.sortyByDisplaySA({
						...response,
						responseObject
					}, saveToStore);
					callback && callback(responseObject);
				} else {
					self.setState({
						error: {
							selectedPriceSourceError: 'error'
						},
					});
				}
			});
		});
	}
	getAttributeBySalesAgreement(salesAgreement, attributeName) {
		const self = this;
		const { allSelectedAccountsAllPriceSources } = self.props.state.user;
		const saDetails = allSelectedAccountsAllPriceSources.find(item => item.AGREEMENT_NUMBER === parseInt(salesAgreement, 10));
		let attributeValue = '';
		if (saDetails) {
			attributeValue = saDetails[attributeName];
		}
		return attributeValue;
	}
	showOtherFieldsInAddShippingAddress() {
		const self = this,
			{ selectedAccount } = self.props.state.user,
			{ accountCustomerClassCodes, accountSalesChannelCodes } = self.props.state.order,
			customerClassCode = selectedAccount && selectedAccount.CUSTOMERCLASSCODE ? selectedAccount.CUSTOMERCLASSCODE.toLowerCase() : "",
			salesChannelCode = selectedAccount && (selectedAccount.SALESCHANNEL || selectedAccount.SALESCHANNELCODE).toLowerCase();
		let showOtherFields = true;
		// WCP-6197: #1, the Add Address functionality should be the same as Home Warranty accounts.
		// We want to offer the pop-up that allows input of a First Name, Last Name and we need to use the services
		// that create a related person party and account.
		if (accountSalesChannelCodes.indexOf(salesChannelCode) !== -1) {
			showOtherFields = true;
		} else if (accountCustomerClassCodes.indexOf(customerClassCode) === -1) {
			showOtherFields = false;
		}
		return showOtherFields;
	}
	sortyByDisplaySA(response, saveToStore) {
		const self = this;
		const { accountResponsibilityData } = self.props.state.user;
		let displaySA = '';
		if (accountResponsibilityData && accountResponsibilityData.responseObject && accountResponsibilityData.responseObject.displaySA) {
			displaySA = self.props.state.user.accountResponsibilityData.responseObject.displaySA;
		}
		if (displaySA === 'Numerically') {
			response.responseObject = _.sortBy(response.responseObject, ['AGREEMENT_NUMBER']);
			response.responseObject.forEach(item => {
				item.DISPLAY_AGREEMENT_NAME = `${item.AGREEMENT_NUMBER} ${item.AGREEMENT_NAME}`;
			});
		} else {
			response.responseObject.forEach(item => {
				item.sortingAgreementLowerCase = item.AGREEMENT_NAME.toLowerCase();
			});
			response.responseObject = _.sortBy(response.responseObject, ['sortingAgreementLowerCase']);
			response.responseObject.forEach(item => {
				item.DISPLAY_AGREEMENT_NAME = item.AGREEMENT_NAME;
			});
		}
		saveToStore && self.props.saveSelectedAccountsAllPriceSources(response);
		return response.responseObject;
	}
	getShippingAddressesDetails(zipCode,
		forAvailability,
		loctype,
		callback,
		showLoader = true,
		state,
		accountNumber = this.getSelectedAccountNumber(),
		requestedDeliveryDate = null,
		doNotSelectHeaderSelectedADC = false,
		country = this.getCountry(),
		isEnteredOrder =false
	) {
		const self = this;
		if (state === undefined) {
				state = this.getState();
			} else if (state !== null && typeof state === "object") {
				state = state.state;
		}
		let LocalStorageVar =JSON.parse( localStorage.getItem( "RDDate" ) );
		let LocalStorageVarZipCodeChanged = JSON.parse( localStorage.getItem( "zipCodeChanged" ) );
		state = LocalStorageVarZipCodeChanged?"":state;
		if (forAvailability && !doNotSelectHeaderSelectedADC && self.props.state.user.userDetails && self.props.state.user.userDetails.typeOfUser === 'employee' && self.state.customZipCode === self.getZipCode()) {
			const { selectedADC } = self.props.state.user;
			if (selectedADC) {
				callback && callback({
					agentid: selectedADC
				});
			}
		} else {
				// if requested delivery is passed from create/editorder then always we need to make the service call and return data
				requestedDeliveryDate= requestedDeliveryDate || LocalStorageVar
				if (requestedDeliveryDate){
				let shippingAddressDetail = _.find(this.props.state.user.shippingAddressDetailsListWithZipCode, {zipCode: zipCode, requestedDeliveryDate});
				if(!shippingAddressDetail || !shippingAddressDetail.details) {
					self.props.getShippingAddresses(`zip=${zipCode.split('-')[0]}&accountNumber=${accountNumber}&date=${requestedDeliveryDate}&country=${country}&state=${state? state : ''}`, showLoader, resp => {
						if (resp.responseObject && resp.responseObject.length === undefined) {
							resp.responseObject = [resp.responseObject];
						}
						self.props.saveShippingAddresses({
							zipCode,
							requestedDeliveryDate,
							details: resp.responseObject,
							state:state
						});
						callback && callback(self.getLocTypeData(resp.responseObject, loctype));
					});
				} else {
					callback && callback(self.getLocTypeData(shippingAddressDetail.details, loctype));
				}
			} else {
				let shippingAddressDetail = this.props.state.user.shippingAddressDetailsListWithZipCode;
                    let shippingAddressDetailsObj = shippingAddressDetail.filter(shippingAddress => shippingAddress.state === state);
                    shippingAddressDetail = _.find(shippingAddressDetailsObj, {zipCode: zipCode})
				if(!shippingAddressDetail || !shippingAddressDetail.details) {
					self.props.getShippingAddresses(`zip=${zipCode.split('-')[0]}&accountNumber=${accountNumber}&country=${country}&state=${state?state:''}`, showLoader, resp => {
						if (resp.responseObject && resp.responseObject.length === undefined) {
							resp.responseObject = [resp.responseObject];
						}
						self.props.saveShippingAddresses({
							zipCode,
							details: resp.responseObject,
							state:state
						});
						callback && callback(self.getLocTypeData(resp.responseObject, loctype));
					});
				} else {
					callback && callback(self.getLocTypeData(shippingAddressDetail.details, loctype));
				}
			}
			
		}
	}
	getOrgAttributesByAttributeName(attributeName, callback, useThisSiteNumber) {
		const self = this;
		let siteNumberShipTo = useThisSiteNumber;
		let siteNumberSoldTo = '';
		if (!useThisSiteNumber) {
			let shipToAddress = self.getAddressByCategory('SHIP_TO');
			if(!shipToAddress) {
				// Check data from second service that is customerShipToDetails
				// only ship to and primary indicator Y needs to be check from second service.
				// First come first use
				shipToAddress = self.props.state.user.customerShipToDetailsAddressListForOrder && self.props.state.user.customerShipToDetailsAddressListForOrder.find(itm => itm.PRIMARYINDICATOR === 'Y' && itm.PURPOSE === 'SHIP_TO');
			}
			siteNumberShipTo = shipToAddress && shipToAddress.PARTYSITEID;
		}
		const soldToAddress = self.getAddressByCategory('SOLD_TO');
		siteNumberSoldTo = soldToAddress && soldToAddress.PARTYSITEID;
		// If useThisSiteNumber is not passed then need to make 2 parallel calls of SHIP_TO & SOLD_TO
		// if (!useThisSiteNumber) {
			// reset all flags and data
			self.setState({
				isShipToCallCompleted: false,
				isSoldToCallCompleted: attributeName === 'EDI Velocity Indicator' ? true : false,
				shipToIndicator: true, // This should be defaulted to true as per business requirement
				soldToIndicator: true, // This should be defaulted to true as per business requirement
			}, () => {
				// Make call if sitenumber is available else set flag to true and execute call back
				if (siteNumberShipTo) {
					self.getAddressAttributeData(siteNumberShipTo, attributeName, (flag) => {
						setTimeout(() => {
							self.setState({
								isShipToCallCompleted: true,
								shipToIndicator: flag
							}, () => {
								self.callBackAfterShipToSoldTo(callback);
							});
						}, 30);
					});
				} else {
					setTimeout(() => {
						self.setState({
							isShipToCallCompleted: true,
							shipToIndicator: true
						}, () => {
							self.callBackAfterShipToSoldTo(callback);
						});
					}, 30);
				}
				// for edi velocity indicator check only ship to call required so avoiding sold to call
				if (attributeName !== 'EDI Velocity Indicator') {
					// Make call if sitenumber is available else set flag to true and execute call back
					if (siteNumberSoldTo) {
						self.getAddressAttributeData(siteNumberSoldTo, attributeName, (flag) => {
							setTimeout(() => {
								self.setState({
									isSoldToCallCompleted: true,
									soldToIndicator: flag
								}, () => {
									self.callBackAfterShipToSoldTo(callback);
								});
							}, 20);
						});
					} else {
						setTimeout(() => {
							self.setState({
								isSoldToCallCompleted: true,
								soldToIndicator: true
							}, () => {
								self.callBackAfterShipToSoldTo(callback);
							});
						}, 20);
					}
				}
			});
		// } else {
		// 	// If any sitenumber is passed then need to only make that call, no need to make SOLD_TO call
		// 	self.getAddressAttributeData(siteNumberShipTo, attributeName, (flag) => {
		// 		callback && callback(flag);
		// 	});
		// }
	}

	add2BusinessDaysToToday() {
		const businessDaysAdd = [ 2, 2, 2, 4, 4, 3, 2];
		let requestedDeliveryDate = moment().tz('America/New_York')
		let currentDay = requestedDeliveryDate.day();
		requestedDeliveryDate = requestedDeliveryDate.add(businessDaysAdd[currentDay - 1], 'days');
		return requestedDeliveryDate.format('MM/DD/YYYY');
	}

	callBackAfterShipToSoldTo(callback) {
		const self = this;
		const { isShipToCallCompleted, isSoldToCallCompleted, shipToIndicator, soldToIndicator } = self.state;
		if (isShipToCallCompleted && isSoldToCallCompleted) {
			callback && callback((!shipToIndicator || !soldToIndicator) ? false : true);
		}
	}

	getCombinedAddresses(sortByLocation = false) {
		const self = this;
		// get delivery address
		let { addressList: addressListResponse, customerShipToDetailsAddressListForOrder, selectedPriceSource, selectedAccount } = self.props.state.user;

		let addressList = addressListResponse && addressListResponse.responseObject ? JSON.parse(JSON.stringify(addressListResponse.responseObject)) : [];
		customerShipToDetailsAddressListForOrder = customerShipToDetailsAddressListForOrder ? JSON.parse(JSON.stringify(customerShipToDetailsAddressListForOrder)) : [];
		addressList = addressList.concat(customerShipToDetailsAddressListForOrder);

		// Filtering out Non US/Canada addresses
		if (selectedPriceSource && selectedPriceSource.AGREEMENT_TYPE !== 'GEA Parts') {
			const salesChannelCode = selectedAccount && (selectedAccount.SALESCHANNEL || selectedAccount.SALESCHANNELCODE);
			const isCanadianAddressEnabled = addressListResponse && addressListResponse.responseObject.some(itm => itm.PURPOSE === "SOLD_TO" && itm.COUNTRY === 'CA' && itm.STATUS === 'A') && salesChannelCode === 'PRO CHANNEL'
			
			addressList = addressList && addressList.filter(address => {
				if (address.PRIMARYINDICATOR === 'Y') {
					return true;
				}
				if (!address.POSTALCODE || (address.LOCATION && address.LOCATION.includes('NEW_SHIP_TO_PNET'))) {
					return false;
				}
				if (address.PURPOSE === 'SHIP_TO') {
					return (isCanadianAddressEnabled ? ['AS', 'US', 'CA', 'GU'].includes(address.COUNTRY) : ['AS', 'US', 'GU'].includes(address.COUNTRY)) || (address.LOCATION && address.LOCATION.includes('NEW_SHIP_TO_NCRP'));
				}
				return true;
			});
		}

		if (sortByLocation) {
			//sorting addresses by LOCATION (numeric first, alphanumeric next)
			const numericLocations = [], alphaNumericLocations = [];
			addressList.forEach(address => {
				if (isNaN(address.LOCATION)) {
					alphaNumericLocations.push(address);
				} else {
					numericLocations.push(address);
				}
			});

			return numericLocations.sort((a, b) => a.LOCATION - b.LOCATION).concat(alphaNumericLocations.sort((a, b) => a.LOCATION.localeCompare(b.LOCATION)));
		}

		return addressList;
	}

	checkAvailabilityGeneric(payload, hybridQueryParams, whereToSave, showLoader, callback, redirectError = true) {
		const self = this;
		if((hybridQueryParams !== null && hybridQueryParams !== '') && whereToSave.includes('cart')) {
			let warehouseCode = hybridQueryParams.split("&").filter(item => item.startsWith("warehouseCode="));
			if(warehouseCode[0].split('=')[1].length > 3 ) {
				hybridQueryParams = hybridQueryParams.replace(warehouseCode[0], warehouseCode[0].split('=')[0]+"="+warehouseCode[0].split('=')[1].substring(0, 3));
			}
		}
		self.props.checkAvailabilityGeneric(payload, hybridQueryParams, whereToSave, showLoader, (response) => {
			if (whereToSave === 'list') {
				self.props.saveAvailabilityToList(response);
			} else if (whereToSave === 'cart') {
				self.props.saveAvailabilityToCart(response);
			} else if (whereToSave === 'searchresult') {
				self.props.saveProductResultAvailability(response);
			}
			callback && callback(response);
		}, redirectError);
	}

	checkItemOrderabilityInBatches(skuList, orderabilityQueryParams, whereToSave, showLoader, callback) {
		const self = this;
		const isPart = orderabilityQueryParams && orderabilityQueryParams.includes(PNET_APP_QUERY_PARAM);
		const batches = _.chunk(skuList, isPart ? 50 : self.state.itemOrderabilityBatchSize);
		const orderabilityBatchData = [];
		const noOfCallRequired = batches.length;
		let completedOrderabilityCall = 0;

		let locationQueryParam = orderabilityQueryParams;
		const headerSelectedAddress = JSON.parse(self.props.state.user.selectedAddress);
		if (!isPart && headerSelectedAddress) {
				const {
					STATE,
					COUNTRY,
					POSTALCODE,
				} = headerSelectedAddress;
			if (!locationQueryParam || COUNTRY === "CA") {
				locationQueryParam = `&state=${STATE===undefined?null:STATE}&country=${COUNTRY}&zip=${POSTALCODE ? POSTALCODE.split('-')[0] : POSTALCODE}`;
			}
		}
		let LocalStorageVarZipCodeChanged = JSON.parse( localStorage.getItem( "zipCodeChanged" ) );
		locationQueryParam = LocalStorageVarZipCodeChanged?self.zipCodeChangeConversion(locationQueryParam):locationQueryParam;
		batches.forEach(item => {
			const queryString = `item=${item.join(',')}${locationQueryParam}`;
			self.props.checkItemOrderability(queryString, showLoader, (response) => {
				if (isPart && !(response && response.responseObject && Array.isArray(response.responseObject))) {
					orderabilityBatchData.push(...item.map(itemNumber => ({ INVENTORY_ITEM: itemNumber.replaceAll(`'`, ''), error: `ERROR: ${response && response.responseObject && response.responseObject.error}`})));
				} else if (response && response.responseObject) {
					orderabilityBatchData.push(...response.responseObject);
				}
				completedOrderabilityCall += 1;
				if (noOfCallRequired === completedOrderabilityCall) {
					callback && callback(orderabilityBatchData);
				}
			});
		});
	}

	processAvailabilityResponse = (batchIndex, requestPayload, responsePayload) => {
		if (responsePayload && responsePayload.responseObject && responsePayload.responseObject.length) {
			requestPayload.forEach(requestItem => {
				const foundItem = responsePayload.responseObject.find(responseItem => requestItem.inventoryItemName === responseItem.inventoryItemName &&
					(requestItem.orderLineIdentifier === responseItem.orderLineIdentifier || (requestItem.orderLineIdentifier - batchIndex * PNET_GOP_BATCH_SIZE) === responseItem.orderLineIdentifier));
				if (foundItem) {
					foundItem.id = requestItem.id;
				}
			})
		}
	}

	checkAvailabilityGenericInBatches(skuList, queryStringParams, whereToSave, showLoader, callback, redirectError) {
		const self = this;
		const isPart = queryStringParams && queryStringParams.includes(PNET_APP_QUERY_PARAM);
		const batches = _.chunk(skuList, isPart ? PNET_GOP_BATCH_SIZE : pageSizeForGettingProductAvailability);

		const availabilityBatchData = [];
		const noOfAvailabilityCallRequired = batches.length;
		let	completedAvailabilityCall = 0;

		batches.forEach((item, index) => {
			self.props.checkAvailabilityGeneric(item, queryStringParams, whereToSave, showLoader, (response) => {
				if (isPart) {
					this.processAvailabilityResponse(index, item, response);
				}
				availabilityBatchData.push(response);
				completedAvailabilityCall += 1;
				if (noOfAvailabilityCallRequired === completedAvailabilityCall) {
					callback && callback(availabilityBatchData);
				}
			}, redirectError);
		});
	}

	checkAvailabilityAndOrderability(payload, hybridQueryParams, orderabilityQueryParams, whereToSave, showLoader, callback, redirectError = true) {
		const self = this;
		self.setState({
			isAvailabilityCallCompleted: false,
			availabilityData: null,
			isOrderabilityCallCompleted: false,
			orderabilityData: null,
		}, () => {
			const isPart = hybridQueryParams.includes(PNET_APP_QUERY_PARAM);

			self.checkAvailabilityGenericInBatches(payload, hybridQueryParams, whereToSave, showLoader, (responses) => {
				const availabilityData = {
					...responses[0],
					responseObject: [],
				};
				responses.forEach(item => {
					availabilityData.responseObject = availabilityData.responseObject.concat(item.responseObject);
				});
				self.setState({
					isAvailabilityCallCompleted: true,
					availabilityData,
				}, () => {
					self.callBackAfterAvailabilityAndOrderability(whereToSave, callback, isPart);
				});
			}, redirectError);

			let itemOrderabilityPayload;
			if(isPart) {
				itemOrderabilityPayload = payload.map(item => `'${item.inventoryItemName}'`);
			} else {
				itemOrderabilityPayload = payload.map(item => `'${item.sku}'`);
			}
			self.checkItemOrderabilityInBatches(itemOrderabilityPayload, orderabilityQueryParams, whereToSave, showLoader, (response) => {
				self.setState({
					isOrderabilityCallCompleted: true,
					orderabilityData: response,
				}, () => {
					self.callBackAfterAvailabilityAndOrderability(whereToSave, callback, isPart);
				});
			});
		});
	}

	callBackAfterAvailability(whereToSave, callback) {
		const self = this;
		const {
			isAvailabilityCallCompleted,
			availabilityData
		} = self.state;
		if (isAvailabilityCallCompleted) {
			if (whereToSave === 'cart') {
				self.props.saveAvailabilityToCart(availabilityData);
			} else if (whereToSave === 'searchresult') {
				self.props.saveProductResultAvailability(availabilityData);
			}
			callback && callback(availabilityData);
		}
	}

	callBackAfterAvailabilityAndOrderability(whereToSave, callback, isPart = false) {
		const self = this;
		const {
			isAvailabilityCallCompleted,
			availabilityData,
			isOrderabilityCallCompleted,
			orderabilityData,
		} = self.state;
		if (isAvailabilityCallCompleted && isOrderabilityCallCompleted) {
			// process availability data with orderability data
			const response = {
				...availabilityData,
				responseObject: []
			};
			if (availabilityData && availabilityData.responseObject && orderabilityData) {
				if(isPart) {
					response.responseObject = orderabilityData.length > 0 ? availabilityData.responseObject.filter(availabilityItem => {
						return orderabilityData.some(orderabilityItem => orderabilityItem.INVENTORY_ITEM === availabilityItem.inventoryItemName && orderabilityItem.ITEM_ORDERABILITY_FLAG === 'Y');
					})
					: availabilityData.responseObject;
				} else {
					response.responseObject = orderabilityData.length > 0
					? availabilityData.responseObject.filter(item => {
						return orderabilityData.find(itm => itm.ITEM === item.sku && itm.ITEM_ORDERABILITY_FLAG === 'Y');
					})
					: availabilityData.responseObject;
				}
			}
			if (whereToSave === 'list') {
				self.props.saveAvailabilityToList(response);
			} else if (whereToSave === 'cart') {
				self.props.saveAvailabilityToCart(response);
			} else if (whereToSave === 'searchresult') {
				self.props.saveProductResultAvailability(response);
			}
			callback && callback(response);
		}
	}

	zipCodeChangeConversion(locationQueryParam){
		let arr= locationQueryParam.split("&");
		arr.find((el, index)=>{
		 if(el.startsWith("state")){
			 arr[index] = "state=";
		 }    
		})
		return arr.join("&")
	}
	// second copy of parallel call batch as in header search when auto suggestion call in progress and user click on search it was calling wrong call back
	// eventaully it was not showing data on search result page so we have separate copy of this block
	checkItemOrderabilityInBatches2(skuList, orderabilityQueryParams, whereToSave, showLoader, callback) {
		const self = this;
		const batches = _.chunk(skuList, self.state.itemOrderabilityBatchSize);
		self.setState({
			orderabilityBatchData2: [],
			noOfCallRequired2: batches.length,
			completedOrderabilityCall2: 0
		}, () => {
			let locationQueryParam = orderabilityQueryParams;
			const headerSelectedAddress = JSON.parse(self.props.state.user.selectedAddress);
			if (headerSelectedAddress) {
				const {
					STATE,
					COUNTRY,
					POSTALCODE,
				} = headerSelectedAddress;
			if (!locationQueryParam || COUNTRY === "CA") {
				locationQueryParam = `&state=${STATE===undefined?null:STATE}&country=${COUNTRY}&zip=${POSTALCODE ? POSTALCODE.split('-')[0] : POSTALCODE}`;
			}
		}
			let LocalStorageVarZipCodeChanged = JSON.parse( localStorage.getItem( "zipCodeChanged" ) );
			locationQueryParam = LocalStorageVarZipCodeChanged?self.zipCodeChangeConversion(locationQueryParam):locationQueryParam;
			batches.forEach(item => {
				const queryString = `item=${item.join(',')}${locationQueryParam}`;
				self.props.checkItemOrderability(queryString, showLoader, (response) => {
					let orderabilityBatchData2 = self.state.orderabilityBatchData2;
					if (response && response.responseObject) {
						orderabilityBatchData2 = orderabilityBatchData2.concat(response.responseObject);
					}
					self.setState({
						orderabilityBatchData2,
						completedOrderabilityCall2: self.state.completedOrderabilityCall2 + 1
					}, () => {
						if (self.state.noOfCallRequired2 === self.state.completedOrderabilityCall2) {
							callback && callback(self.state.orderabilityBatchData2);
						}
					});
				});
			});
		});
	}

	checkAvailabilityGenericInBatches2(skuList, queryStringParams, whereToSave, showLoader, callback, redirectError) {
		const self = this;
		const batches = _.chunk(skuList, pageSizeForGettingProductAvailability);
		self.setState({
			availabilityBatchData2: [],
			noOfAvailabilityCallRequired2: batches.length,
			completedAvailabilityCall2: 0
		}, () => {
			batches.forEach(item => {
				self.props.checkAvailabilityGeneric(item, queryStringParams, whereToSave, showLoader, (response) => {
					let availabilityBatchData2 = self.state.availabilityBatchData2;
					availabilityBatchData2.push(response);
					self.setState({
						availabilityBatchData2,
						completedAvailabilityCall2: self.state.completedAvailabilityCall2 + 1
					}, () => {
						if (self.state.noOfAvailabilityCallRequired2 === self.state.completedAvailabilityCall2) {
							callback && callback(self.state.availabilityBatchData2);
						}
					});
				}, redirectError);
			});
		});
	}

	checkAvailabilityAndOrderability2(payload, hybridQueryParams, orderabilityQueryParams, whereToSave, showLoader, callback, redirectError = true) {
		const self = this;
		self.setState({
			isAvailabilityCallCompleted2: false,
			availabilityData2: null,
			isOrderabilityCallCompleted2: false,
			orderabilityData2: null,
		}, () => {
			self.checkAvailabilityGenericInBatches2(payload, hybridQueryParams, whereToSave, showLoader, (responses) => {
				const availabilityData2 = {
					...responses[0],
					responseObject: [],
				};
				responses.forEach(item => {
					availabilityData2.responseObject = availabilityData2.responseObject.concat(item.responseObject);
				});
				self.setState({
					isAvailabilityCallCompleted2: true,
					availabilityData2,
				}, () => {
					self.callBackAfterAvailabilityAndOrderability2(whereToSave, callback);
				});
			}, redirectError);
			self.checkItemOrderabilityInBatches2(payload.map(item => `'${item.sku}'`), orderabilityQueryParams, whereToSave, showLoader, (response) => {
				self.setState({
					isOrderabilityCallCompleted2: true,
					orderabilityData2: response,
				}, () => {
					self.callBackAfterAvailabilityAndOrderability2(whereToSave, callback);
				});
			});
		});
	}

	callBackAfterAvailabilityAndOrderability2(whereToSave, callback) {
		const self = this;
		const {
			isAvailabilityCallCompleted2,
			availabilityData2,
			isOrderabilityCallCompleted2,
			orderabilityData2,
		} = self.state;
		if (isAvailabilityCallCompleted2 && isOrderabilityCallCompleted2) {
			// process availability data with orderability data
			const response = {
				...availabilityData2,
				responseObject: []
			};
			if (availabilityData2 && availabilityData2.responseObject && orderabilityData2) {
				response.responseObject = orderabilityData2.length > 0
					? availabilityData2.responseObject.filter(item => {
						return orderabilityData2.find(itm => itm.ITEM === item.sku && itm.ITEM_ORDERABILITY_FLAG === 'Y');
					})
					: availabilityData2.responseObject;
			}
			if (whereToSave === 'list') {
				self.props.saveAvailabilityToList(response);
			} else if (whereToSave === 'cart') {
				self.props.saveAvailabilityToCart(response);
			} else if (whereToSave === 'searchresult') {
				self.props.saveProductResultAvailability(response);
			}
			callback && callback(response);
		}
	}

	checkIfAnyActiveSoldAddress(callback) {
		const self = this;
		const addressList = self.getCombinedAddresses();
		if (!addressList.find(itm => itm.PURPOSE === "SOLD_TO" && itm.STATUS === 'A')) {
			// show popup and stay on same page
			self.setState({
				genericDialogHeading: 'Action',
				genericDialogText: 'Account setup is incomplete. Please contact the CustomerNet Help Desk at customernet@geappliances.com or 1-800-242-1333.',
				modalButtons: 'ok',
				customClass: ''
			}, () => {
				self.handleDialog('WeAreSorryDialog', true);
			});
		} else if (!self.isValidBillToSiteAndLocation()) {
			// show popup and stay on same page
			self.setState({
				genericDialogHeading: 'Action',
				genericDialogText: "Bill To information is missing from the Sales Agreement. Please contact your finance rep for assistance.",
				modalButtons: 'ok',
				customClass: 'orange'
			}, () => {
				self.handleDialog('WeAreSorryDialog', true);
			});
		} else {
			// continue by executing call back
			callback && callback();
		}
	}

	getAddressAttributeData(siteNumber, attributeName, callback) {
		const self = this;
		const isAnySavedData = self.props.state.order.topIndicatorAddAttrBySiteNum.find(itm => itm.siteNumber === siteNumber && itm.attributeName === attributeName);
		if(isAnySavedData) {
			// If we already having data then return indicator flag
			if(isAnySavedData.isCompleted) {
				callback && callback(isAnySavedData.indicator);
			}
			// if there is already some call in progress then wait until it is completed
			else {
				setTimeout(() => {
					self.getAddressAttributeData(siteNumber, attributeName, callback);
				}, 100);
			}
		} else {
			// Here we will set indicator as true to track in progress
			self.props.saveLoadIndicatorBySiteNumber({
				siteNumber,
				attributeName: "Top Load Indicator",
				isCompleted: false,
			});
			self.props.saveLoadIndicatorBySiteNumber({
				siteNumber,
				attributeName: "EDI Velocity Indicator",
				isCompleted: false,
			});
			self.props.getAddressAttributes(`siteNumber=${siteNumber}&requestType=getAddressAttributes`, true, rspnce => {
				if(rspnce.status) {
					const topLoadIndicator = rspnce.responseObject.find(itm => itm.ATTR_NAME === "Top Load Indicator" && itm.ATTR_VAL === 'N') ? false : true;
					// After call is completed it will update inCompleted flag as true
					self.props.updateLoadIndicatorBySiteNumber({
						siteNumber,
						attributeName: "Top Load Indicator",
						indicator: topLoadIndicator,
						isCompleted: true
					});
					// After call is completed it will update inCompleted flag as true
					const isEDIVelocityIndicator = rspnce.responseObject.find(itm => itm.ATTR_NAME === 'EDI Velocity Indicator' && itm.ATTR_VAL === 'Y') ? true : false;
					self.props.updateLoadIndicatorBySiteNumber({
						siteNumber,
						attributeName: "EDI Velocity Indicator",
						indicator: isEDIVelocityIndicator,
						isCompleted: true
					});
					let indicator = false;
					if (attributeName === "Top Load Indicator") {
						indicator = topLoadIndicator;
					} else if (attributeName === "EDI Velocity Indicator") {
						indicator = isEDIVelocityIndicator;
					}
					callback && callback(indicator);
				} else {
					callback && callback(true);
				}
			});
		}
	}

	getLocTypeData(shippingData, loctype) {
		if(loctype){
			let data = _.find(shippingData, ["loctype", loctype]);
			if(loctype === "sds_loc") {
				if(!data || (data && (data.agentid === 'NA' || data.agentid === 'NULL' || !data.agentid))) {
					data = _.find(shippingData, ["loctype", 'adc_loc']);
					data = {
						...data,
						isThisADCLOC: true
					}
				}
			}
		return data;
		}
		return shippingData;
	}
	callbackAfterCheckAndSetSearchResult = (callbackData, callback) => {
		if (callbackData.isAvailabilityCallCompleted && callbackData.isPricesCallCompleted) {
			setTimeout(() => {
				callback && callback();
			}, 0)
		}
	}
	checkAndSetSearchResult(typeOfSearch, accountNumber, pricingSource, zipCode, searchStr, navigationState, callback, onlyAvailabilityCall, onlyAvailabilityPricingCall, options = { useBackup: { items: false } }) {
		var self = this;
		// reset keyword result list, availability list, and prices list
		const headerSelectedAddress = JSON.parse(self.props.state.user.selectedAddress);
		const {
			STATE,
			COUNTRY,
		} = headerSelectedAddress || {};
		const callbackData = {
			isAvailabilityCallCompleted: false,
			isPricesCallCompleted: false
		}
		const productNumberKeywordResult = JSON.parse(JSON.stringify(options && options.useBackup && options.useBackup.items ? self.props.state.product.productNumberKeywordResultBackup : self.props.state.product.productNumberKeywordResult));
		if(onlyAvailabilityCall) {
			self.props.resetProductAvailabilityResultList();
			if(productNumberKeywordResult && productNumberKeywordResult.length > 0) {
				// Make parallel availability call
				const availabilityPayload = productNumberKeywordResult.map(item => {
					return { sku: item.sku };
				});
				self.props.saveProductAvailabilityCallCompleted(false);
				// const data = JSON.parse(self.props.state.user.selectedAddress);
				// const zipCode = data ? data.POSTALCODE.split('-')[0] : '';
				zipCode && self.getShippingAddressesDetails(zipCode, true, 'adc_loc', resp => {
					if(resp && resp.agentid) {
						availabilityPayload.length > 0 && self.checkAvailabilityAndOrderability(availabilityPayload, `accountNumber=${accountNumber}&zipCode=${zipCode}&warehouseCode=${resp.agentid}${this.getSalesAgreementParamForAvailability()}`, `&zip=${zipCode}&state=${STATE}&country=${COUNTRY}`, 'searchresult', true, response => {
							self.props.saveProductAvailabilityCallCompleted(true);
							setTimeout(() => {
								if(self.props.state.product.isProductAvailabilityCallCompleted) {
									callback && callback({data: response, type: 'availability'});
								}
							}, 300);
						});
					}
				});
			}
		} else if(onlyAvailabilityPricingCall) {
			self.props.resetProductAvailabilityResultList();
			self.props.resetProductPricesResultList();
			// Make parallel availability call
			const availabilityPayload = productNumberKeywordResult.map(item => {
				return { sku: item.sku };
			});
			self.props.saveProductAvailabilityCallCompleted(false);
			// const data = JSON.parse(self.props.state.user.selectedAddress);
			// const zipCode = data ? data.POSTALCODE.split('-')[0] : '';
			zipCode && self.getShippingAddressesDetails(zipCode, true, 'adc_loc', resp => {
				if(resp && resp.agentid) {
					availabilityPayload.length > 0 && self.checkAvailabilityAndOrderability(availabilityPayload, `accountNumber=${accountNumber}&zipCode=${zipCode}&warehouseCode=${resp.agentid}${this.getSalesAgreementParamForAvailability()}`, `&zip=${zipCode}&state=${STATE}&country=${COUNTRY}`, 'searchresult', true, response => {
						self.props.saveProductAvailabilityCallCompleted(true);
						callbackData.isAvailabilityCallCompleted = true;
						self.callbackAfterCheckAndSetSearchResult(callbackData, callback);
					});
				}
			});

			//Make parallel call for pricing
			const pricingEffectiveDate = moment().tz('America/New_York').format('YYYYMMDD');
			let payload = JSON.parse(JSON.stringify(productNumberKeywordResult));
			payload = payload.map(item => item.sku);
			payload = _.chunk(payload, pageSizeForGettingProductPrices);
			self.props.saveNumberOfParallelCallForProductPrices(payload.length);
			let requiredNumberOfParallelCallForProductPrices = payload.length, completedNumberOfParallelCallForProductPrices = 0;
			for(let j = 0; j < payload.length; j++) {
				payload[j].length > 0 && self.props.checkPricesForSearchResult({
					account_number: accountNumber,
					pricing_effective_date: pricingEffectiveDate,
					sa_number: pricingSource,
					item_numbers: payload[j]
				}, true, true, response => {
					completedNumberOfParallelCallForProductPrices+=1;
					self.props.saveCompletedNumberOfParallelCallForProductPrices();
					if (completedNumberOfParallelCallForProductPrices === requiredNumberOfParallelCallForProductPrices) {
						callbackData.isPricesCallCompleted = true;
						self.callbackAfterCheckAndSetSearchResult(callbackData, callback);
					}
				});
			}
		} else {
			self.props.resetProductNumberKeywordResultList();
			self.props.resetProductAvailabilityResultList();
			self.props.resetProductPricesResultList();

			self.props.getProductNumberKeywordResult(
				searchStr,
				navigationState,
				{
					accountNumber: accountNumber,
					zipCode: zipCode
				},
				typeOfSearch,
				response => {
					if(self.props.state.product.productNumberKeywordResult.length > 0) {
						// Make parallel availability call
						let productNumberKeywordResult = JSON.parse(JSON.stringify(self.props.state.product.productNumberKeywordResult));
						productNumberKeywordResult = productNumberKeywordResult.map(item => {
							return { sku: item.sku };
						});
						self.props.saveProductAvailabilityCallCompleted(false);
						// const data = JSON.parse(self.props.state.user.selectedAddress);
						// const zipCode = data ? data.POSTALCODE.split('-')[0] : '';
						zipCode && self.getShippingAddressesDetails(zipCode, true, 'adc_loc', resp => {
							if(resp && resp.agentid) {
								productNumberKeywordResult.length > 0 && self.checkAvailabilityAndOrderability(productNumberKeywordResult, `accountNumber=${accountNumber}&zipCode=${zipCode}&warehouseCode=${resp.agentid}${this.getSalesAgreementParamForAvailability()}`, `&zip=${zipCode}&state=${STATE}&country=${COUNTRY}`, 'searchresult', true, response => {
									self.props.saveProductAvailabilityCallCompleted(true);
									callbackData.isAvailabilityCallCompleted = true;
									self.callbackAfterCheckAndSetSearchResult(callbackData, callback);
								});
							}
						});

						//Make parallel call for pricing
						const pricingEffectiveDate = moment().tz('America/New_York').format('YYYYMMDD');
						let payload = JSON.parse(JSON.stringify(self.props.state.product.productNumberKeywordResult));
						payload = payload.map(item => item.sku);
						payload = _.chunk(payload, pageSizeForGettingProductPrices);
						self.props.saveNumberOfParallelCallForProductPrices(payload.length);
						let requiredNumberOfParallelCallForProductPrices = payload.length, completedNumberOfParallelCallForProductPrices = 0;
						for(let j = 0; j < payload.length; j++) {
							payload[j].length > 0 && self.props.checkPricesForSearchResult({
								account_number: accountNumber,
								pricing_effective_date: pricingEffectiveDate,
								sa_number: pricingSource,
								item_numbers: payload[j]
							}, true, true, response => {
								completedNumberOfParallelCallForProductPrices+=1;
								self.props.saveCompletedNumberOfParallelCallForProductPrices();
								if (completedNumberOfParallelCallForProductPrices === requiredNumberOfParallelCallForProductPrices) {
									callbackData.isPricesCallCompleted = true;
									self.callbackAfterCheckAndSetSearchResult(callbackData, callback);
								}
							});
						}
					} else {
						self.props.saveProductAvailabilityCallCompleted(true);
						self.props.saveNumberOfParallelCallForProductPrices(1);
						self.props.saveCompletedNumberOfParallelCallForProductPrices();
						setTimeout(() => {
							callback && callback();
						}, 300);
					}
				},
				"postlogin"
			);
		}
	}

	getList(userId, accountNumber, showLoader) {
		this.props.getList(`userId=${userId}&accountNumber=${accountNumber}`, showLoader, response => {
		});
	}

	getCart(userId, accountNumber, showLoader, isPart = false) {
		this.props.getCart(`userId=${userId}&accountNumber=${accountNumber}${isPart ? '&' + PNET_APP_QUERY_PARAM : ''}`, showLoader, response => {
			// save backup of cart items for future reference to set keepOriginalPrice while moving from cart to create order
			this.props.saveBackupCartItem(response);
		});
	}

	processPricingResponse(response) {
		return processPricingResponse(response);
	}

	getLocalUserDetails(typeOfUser, sso, selectedAccountNumber, showLoader) {
		if(typeOfUser !== 'customer') return;
		const self = this;
		//Make call to get local profile details if its not in store
		const { localUserDetails, userOtherDetails } = self.props.state.user;
		if(!localUserDetails) {
			let personPartyId = null;
			if(userOtherDetails && userOtherDetails.responseObject && userOtherDetails.responseObject.length > 0) {
				personPartyId = userOtherDetails.responseObject[0].PERSON_PARTY_ID;
			}
			// Check if data is available in store for getlocaluser
			self.props.getLocalUserDetails(`userId=${sso}&requestType=getLocalUser&personPartyId=${personPartyId}`, showLoader, response => {
				self.checkAndSetIsAdminOrNot(response, selectedAccountNumber);
				// Uncomment below section when need to show notification update dialog
				self.setState({
					lastLoginDate: response.responseObject && response.responseObject.lastLoginDate ? true : false
				});
			});
		} else {
			//set is admin or not
			self.checkAndSetIsAdminOrNot(localUserDetails, selectedAccountNumber);
			// Uncomment below section when need to show notification update dialog
			self.setState({
				lastLoginDate: localUserDetails.responseObject && localUserDetails.responseObject.lastLoginDate ? true : false
			});
		}
	}

	checkAndSetIsAdminOrNot(response, selectedAccountNumber) {
		const self = this;
		if(response.status) {
			if(selectedAccountNumber) {
				let isAdmin = false;
				// Check if user is admin or not
				response && response.responseObject && response.responseObject.accounts && response.responseObject.accounts.map((item,index) => {
					if(item.accountNumber === selectedAccountNumber && item.admin === "Y")
						isAdmin = true
					return null
				});
				self.props.updateUserAdminOrNot(isAdmin);
				//This will update localstorage with admin or not
				self.saveUserIsAdminOrNotToLocalStorage(isAdmin);

				// If user is customer and admin then only make below call
				if(isAdmin) {
					self.props.getUsersOfAccount(`accountNumber=${selectedAccountNumber}&requestType=getLocalUsersOfAccount`, false);
				}
			}
		} else {
			// browserHistory.push('/error');
		}
	}

	// it will reutrn array of addresses
	getAddressesByCategory(purpose, isPrimaryIndicatorNeedsToCheck = true) {
		const self = this;
		const { addressList, customerShipToDetailsAddressListForOrder } = self.props.state.user;
		let addresses = [];
		let filter = {'PURPOSE': purpose, 'PRIMARYINDICATOR': 'Y'};
		if(!isPrimaryIndicatorNeedsToCheck) {
			filter = {'PURPOSE': purpose};
		}
		if(addressList && addressList.responseObject && addressList.responseObject.length > 0) {
			addresses = _.filter(addressList.responseObject, filter);
		}
		if(addresses.length === 0 && customerShipToDetailsAddressListForOrder) {
			// Check data from second service that is customerShipToDetails
			// only ship to and primary indicator Y needs to be check from second service.
			// First come first use
			addresses = _.filter(customerShipToDetailsAddressListForOrder, filter);
		}
		return addresses;
	}

	// It will return single address
	getAddressByCategory(purpose, isPrimaryIndicatorNeedsToCheck = true) {
		const self = this;
		const { addressList, customerShipToDetailsAddressListForOrder } = self.props.state.user;
		let addresses = null;
		let filter = {'PURPOSE': purpose, 'PRIMARYINDICATOR': 'Y'};
		if(!isPrimaryIndicatorNeedsToCheck) {
			filter = {'PURPOSE': purpose};
		}
		if(addressList && addressList.responseObject && addressList.responseObject.length > 0) {
			addresses = _.find(addressList.responseObject, filter);
		}
		if(!addresses && customerShipToDetailsAddressListForOrder) {
			// Check data from second service that is customerShipToDetails
			// only ship to and primary indicator Y needs to be check from second service.
			// First come first use
			addresses = _.find(customerShipToDetailsAddressListForOrder, filter);
		}
		return addresses;
	}

	//get zip Code
	// getZipCode() {
	// 	const self = this;
	// 	const { addressList, customerShipToDetailsAddressListForOrder } = self.props.state.user;
	// 	let zipCode = '';
	// 	if(addressList && addressList.responseObject && addressList.responseObject.length > 0) {
	// 		let addresses = self.getAddressByCategory('SHIP_TO');
	// 		if(!addresses) {
	// 			addresses = self.getAddressByCategory('SOLD_TO');
	// 		}
	// 		if(!addresses) {
	// 			// Check data from second service that is customerShipToDetails
	// 			// only ship to and primary indicator Y needs to be check from second service.
	// 			// First come first use
	// 			addresses = customerShipToDetailsAddressListForOrder.find(itm => itm.PRIMARYINDICATOR === 'Y' && itm.PURPOSE === 'SHIP_TO');
	// 		}
	// 		if(addresses) {
	// 			zipCode = addresses.POSTALCODE;
	// 			zipCode = zipCode.split("-")[0];
	// 		}
	// 	}
	// 	return zipCode;
	// }
	getZipCode() {
		const self = this;
		let { selectedAddress } = self.props.state.user;
		let zipCode = '';
		if(selectedAddress) {
			zipCode = JSON.parse(selectedAddress).POSTALCODE;
			zipCode = zipCode.split("-")[0];
		}
		return zipCode;
	}

	getState() {
		const self = this;
		let { selectedAddress } = self.props.state.user;
		let state = '';
		if(selectedAddress) {
			state = JSON.parse(selectedAddress).STATE;
		}
		return state;
	}

	getCountry() {
		const self = this;
		let { selectedAddress } = self.props.state.user;
		let country = '';
		if(selectedAddress) {
			country = JSON.parse(selectedAddress).COUNTRY;
		}
		return country;
	}

	getShipToState() {
		const self = this;
		// fetch site id from SOLD_TO to address
		const shipToAddress = self.getAddressesByCategory('SHIP_TO');
		let state = '';
		if(shipToAddress.length > 0) {
			state = shipToAddress[0].STATE;
		}
		return state;
	}

	getSalesAgreementList(salesAgreementNumber = null) {
		const self = this;
		// Filter out all sales agreement if sales agreement which is selected is non "Inventory Financing"
		let selectedAccountsAllPriceSources = self.props.state.user.selectedAccountsAllPriceSources && JSON.parse(JSON.stringify(self.props.state.user.selectedAccountsAllPriceSources));
		return selectedAccountsAllPriceSources;
	}

	fetchApproveReturnsList(redirect, callback) {
		const self = this;
		self.setState({
			viewRequestsSet1CallCompleted: false,
			viewRequestDataSet1: null,
		}, () => {
			self.props.getOrderList(`accountNumber=${self.getSelectedAccountNumber()}&requestType=viewRequests&orderStatus=ENTERED`, response => {
				if (response.status) {
					self.setState({
						viewRequestsSet1CallCompleted: true,
						viewRequestDataSet1: response,
					}, () => {
						self.callBackAfterAllApprovedReturnsCall(redirect, callback);
					});
				} else {
					self.setState({
						errorMessage: response.responseMessage
					});
				}
			});
		});
	}

	callBackAfterAllApprovedReturnsCall(redirect, callback) {
		const self = this;
		const {
			viewRequestsSet1CallCompleted,
			viewRequestDataSet1,
		} = self.state;
		if (viewRequestsSet1CallCompleted) {
			self.props.saveApproveReturnsList(viewRequestDataSet1);
			redirect && browserHistory.push(redirect);
			callback && callback(viewRequestDataSet1);
		}
	}

	getAgreementType(agreementNumber, agreementType) {
		const self = this;
		if (self.checkInventoryFinancingSA(agreementNumber)) {
			return 'Inventory Financing';
		}
		return agreementType;
	}

	checkInventoryFinancingSA(salesAgreementNumber) {
		const self = this;
		const { inventoryFinancingList } = self.props.state.user;
		let selectedPriceSource = self.props.state.user.selectedPriceSource;
		if(salesAgreementNumber) {
			const selectedAccountsAllPriceSources = self.props.state.user.selectedAccountsAllPriceSources.responseObject;
			selectedPriceSource = selectedAccountsAllPriceSources.find(itm => itm.AGREEMENT_NUMBER === parseInt(salesAgreementNumber, 10));
		}
		if (selectedPriceSource && selectedPriceSource.BILL_TO_LOCATION && inventoryFinancingList.find(itm => selectedPriceSource.BILL_TO_LOCATION.toLowerCase().indexOf(itm) !== -1)) {
			return true;
		}
		return false;
	}

	// This is the function which is getting called everytime when account number is changed
	getAccountDetailsAndAddressList(accountNumber, showLoader, userDetails, callback) {
		const self = this;

		setTimeout(() => {
			// check if localUser details is available or not and set if user is admin or not
			self.getLocalUserDetails(userDetails.typeOfUser, userDetails.sso, accountNumber, false);
			// reset orders reducer
			self.props.resetOrderObjectInStore();
		}, 50);

		// reset topindicator progress if any so that it will not call settimeout again and again
		self.props.resetLoadIndicatorBySiteNumber([]);

		// check back orders
		self.checkForBackOrders(accountNumber, false);

		// check bulk orders hold
		self.checkForBulkOrdersHold(accountNumber, false);

		// reset ASM value in the store
		self.props.updateUserASMOrNot(false);

		// check account responsibility
		// self.getAccountResponsibility(accountNumber);

		// reset org attributes when sales agreement is changed
		self.props.saveOrgAttributes(null);

		// reset role list response if any
		self.props.saveRoleList(null);

		// reset search suggestion result if any
		self.props.resetSearchKeywordSuggestionList();

		// reset packages data if any
		self.props.saveRequestReturnList(null);

		// reset request return data if any
		self.props.resetPackageObjectInStore(null);

		// reset all zip code along with its data as account number is changed
		self.props.resetShippingAddresses([]);

		// reset prices, services_prices and availability to cart reducer
		self.props.resetPricesToCart();
		self.props.resetServicesPricesToCart();
		self.props.resetAvailabilityToCart();

		// reset availability to list reducer
		self.props.resetAvailabilityToList();

		// get users of account for myprofile second tab
		// Check if it is customer admin, then make call
		// Check if employee and isInDL, then make call (ASM check is not yet completed at this point, it will be completed after all parallel calls are completed)
		if((userDetails.typeOfUser === 'customer' && userDetails.isAdmin) || (userDetails.typeOfUser === 'employee' && (userDetails.isInDL || userDetails.isASM || (userDetails.isNonGEASsoUser && userDetails.isManRepSsoUser)))) {
			self.props.getUsersOfAccount(`accountNumber=${accountNumber}&requestType=getLocalUsersOfAccount`, false);
		}

		// parallel call to get account Details
		let url = `accountNumber=${accountNumber}&requestType=getAccountDetails&ssoId=${userDetails.sso}`;
		self.props.getAccountDetails(url, showLoader, resp => {
			if(resp.status) {
				self.props.saveAccountDetail(resp);
				callback && callback(resp);
				// once service will start working properly move this code in above if condition
				if(resp.responseObject.length > 0) {
					self.setState({
						getAddressListCallCompleted: false,
						getCustomerShipToDetailsCompleted: false,
						isAnyAddressCallInProgress: true,
						// customADC: '',
						// customZipCode: '',
					}, () => {
						// reset selected address first
						self.props.updateSelectedAddress(null);
						//get list and cart details if account is selected
						self.getList(userDetails.sso, accountNumber, false);
						// self.getCart(userDetails.sso, accountNumber, false);
						const customerClassCode = resp.responseObject[0].CUSTOMERCLASSCODE;
						self.props.getAddressList(`accountNumber=${accountNumber}&partyId=${resp.responseObject[0].PARTYID}&requestType=getAddressList`, false, response => {
							if(response.status && response.responseObject) {
								const copyOfAddressListResponseObject = JSON.parse(JSON.stringify(response.responseObject));
								// Filter out address which are not having zip code or not active
								let jobSiteAddressList = [];
								if (customerClassCode === 'INTERNATIONAL') {
									response.responseObject	= response.responseObject.filter(item => item.ADDRESS4 !== 'JOB SITE' && item.PURPOSE && (item.PURPOSE === 'BILL_TO' ? true : (!['US','CA'].includes(item.COUNTRY) || item.POSTALCODE)) && item.STATUS === 'A' && (!item.PURPOSE_STATUS || item.PURPOSE_STATUS === 'A'));
									jobSiteAddressList = copyOfAddressListResponseObject.filter(item => item.ADDRESS4 === 'JOB SITE' && item.PURPOSE && (item.PURPOSE === 'BILL_TO' ? true : item.POSTALCODE) && item.STATUS === 'A' && (!item.PURPOSE_STATUS || item.PURPOSE_STATUS === 'A'));
								} else {
									response.responseObject	= response.responseObject.filter(item => item.ADDRESS4 !== 'JOB SITE' && item.PURPOSE && item.POSTALCODE && item.STATUS === 'A' && (!item.PURPOSE_STATUS || item.PURPOSE_STATUS === 'A'));
									jobSiteAddressList	= copyOfAddressListResponseObject.filter(item => item.ADDRESS4 === 'JOB SITE' && item.PURPOSE && item.POSTALCODE && item.STATUS === 'A' && (!item.PURPOSE_STATUS || item.PURPOSE_STATUS === 'A'));
								}
								// only filter out items which are purpose SHIP_TO but not SITE_USE_ID
								response.responseObject = response.responseObject.filter((item) => item.PURPOSE !== 'SHIP_TO' || (item.PURPOSE === 'SHIP_TO' && item.SITE_USE_ID));
								jobSiteAddressList = jobSiteAddressList.filter((item) => item.PURPOSE !== 'SHIP_TO' || (item.PURPOSE === 'SHIP_TO' && item.SITE_USE_ID))
								// add to existing job site addresses
								self.props.saveAllJobSiteAddressList(jobSiteAddressList);
								self.props.saveAddressList(response);

								if(response && response.responseObject && response.responseObject.length > 0) {
									let partyId = '';
									if(response.responseObject.length > 0) {
										partyId = response.responseObject[0].PARTY_ID;
									}
									//get relation ship party list
									partyId && self.props.getRelationShipPartyList(`partyId=${partyId}&requestType=getRelationShipPartyList`, false, rspnce => {
										if(rspnce.status) {
											self.props.saveRelationShipPartyList(rspnce);
										}
									});
									self.props.getAllTcaList(`accountNumber=${accountNumber}`, false, respTca=>{
										self.props.saveAllTcaList(respTca);
									});
									self.props.getAllAdjPrcMod(`accountNumber=${accountNumber}`, false, adjPrdMods => {
										self.props.saveAllAdjPrcModifier(adjPrdMods);
									});
									const { userDetails } = self.props.state.user;
									if(userDetails.typeOfUser === 'employee' && !userDetails.isInDL) {
										self.props.getSalesRepId(`accountNumber=${accountNumber}&requestType=getSalesRepId`, resp => {
											if(resp.status) {
												if(typeof resp.responseObject !== 'string' && resp.responseObject && resp.responseObject.length) {
													const paramList = [];
													resp.responseObject.forEach((item) => {
														const {
															ASM_ID,
															RMID,
															DSASMID,
															DSRMID,
															NAMID,
															BRAND_ASM_ID,
															KEYACCOUNT_ASM
														} = item;
														if(ASM_ID && paramList.indexOf(ASM_ID) === -1) {
															paramList.push(ASM_ID);
														}
														if(RMID && paramList.indexOf(RMID) === -1) {
															paramList.push(RMID);
														}
														if(DSASMID && paramList.indexOf(DSASMID) === -1) {
															paramList.push(DSASMID);
														}
														if(DSRMID && paramList.indexOf(DSRMID) === -1) {
															paramList.push(DSRMID);
														}
														if(NAMID && paramList.indexOf(NAMID) === -1) {
															paramList.push(NAMID);
														}
														if(BRAND_ASM_ID && paramList.indexOf(BRAND_ASM_ID) === -1) {
															paramList.push(BRAND_ASM_ID);
														}
														if(KEYACCOUNT_ASM && paramList.indexOf(KEYACCOUNT_ASM) === -1) {
															paramList.push(KEYACCOUNT_ASM);
														}
													});
													self.props.getSSOFromSalesRepId(`requestType=getSSOFromSalesRepId&salesRepId=${paramList.join(',')}`, respn => {
														if(respn.status) {
															let isASM = false;
															if(respn.responseObject && respn.responseObject.length) {
																const { sso } = self.props.state.user.userDetails;
																const parsed = !Array.isArray(respn.responseObject) ? JSON.parse(respn.responseObject) : respn.responseObject
																if(parsed.find(itm => itm.SALESREP_NUMBER === sso)) {
																	isASM = true;
																}
															}
															if (!self.props.state.user.userDetails.isASM) {
																//This will update store with asm indicator
																self.props.updateUserASMOrNot(isASM);
															}
															// need to check if user is not asm for current selected account
															if(!isASM) {
																self.checkForOtherAccountASM();
															} else {
																// if user is asm then need to make below call
																self.props.getUsersOfAccount(`accountNumber=${accountNumber}&requestType=getLocalUsersOfAccount`, false);
															}
														} else {
															// browserHistory.push('/error');
															// In case service failed then assume set asm false and continue other check
															self.props.updateUserASMOrNot(false);
															self.checkForOtherAccountASM();
														}
													});
												} else {
													// if (!self.props.state.user.userDetails.isASM) {
													// 	//This will update store with asm indicator
													// 	self.props.updateUserASMOrNot(false);
													// }
													self.checkForOtherAccountASM();
												}
											} else {
												// In case service failed then assume set asm false and continue other check
												self.props.updateUserASMOrNot(false);
												self.checkForOtherAccountASM();
											}
										}, false);
									}
								}
								self.setState({
									getAddressListCallCompleted: true,
									addressException:false
								}, () => {
									self.callBackAfterGettingAddressListAndCustomerShipToDetails(accountNumber);
								});
							} else if(response.responseMessage!=='Got the adress list'){
								self.props.saveAddressList({status:true, responseObject:[{PURPOSE:"SOLD_TO", STATUS:"A"}, {PURPOSE:"SHIP_TO", STATUS:"A"}]});
								self.props.addressExceptionDispatch(false);
								self.setState({
									getAddressListCallCompleted: true,
									addressException:true
								},() => {
									self.callBackAfterGettingAddressListAndCustomerShipToDetails(accountNumber);
								});

						}else {
								browserHistory.push('/error');
							}
						});
						self.props.getCustomerShipToDetails(`accountNumber=${accountNumber}&requestType=getCustomerShipToDetails`, false, response => {
							if(response.status && response.responseObject) {
								const copyOfAddressListResponseObject = JSON.parse(JSON.stringify(response.responseObject));
								let jobSiteAddressList = [];
								// Filter out address which are not having zip code or not active
								if (customerClassCode === 'INTERNATIONAL') {
									response.responseObject	= response.responseObject.filter(item => item.ADDRESS4 !== 'JOB SITE' && item.PURPOSE && (item.PURPOSE === 'BILL_TO' ? true : (!['US','CA'].includes(item.COUNTRY) || item.POSTAL_CODE)) && item.SHIP_TO_ACCT_STATUS === 'A' && item.PARTY_SITE_STATUS === 'A' && item.SOLD_TO_ACCT_STATUS === 'A' && item.STATUS === 'A' && item.PURPOSE_STATUS === 'A' && item.ACCOUNT_SITE_STATUS === 'A' && (!self.props.state.user.selectedAddressBackup || self.props.state.user.selectedAddressBackup.SITE_USE_ID !== item.SITE_USE_ID));
									jobSiteAddressList = copyOfAddressListResponseObject.filter(item => item.ADDRESS4 === 'JOB SITE' && item.PURPOSE && (item.PURPOSE === 'BILL_TO' ? true : item.POSTAL_CODE) && item.SHIP_TO_ACCT_STATUS === 'A' && item.PARTY_SITE_STATUS === 'A' && item.SOLD_TO_ACCT_STATUS === 'A' && item.STATUS === 'A' && item.PURPOSE_STATUS === 'A' && item.ACCOUNT_SITE_STATUS === 'A');
								} else {
									response.responseObject	= response.responseObject.filter(item => item.ADDRESS4 !== 'JOB SITE' && item.PURPOSE && item.POSTAL_CODE && item.SHIP_TO_ACCT_STATUS === 'A' && item.PARTY_SITE_STATUS === 'A' && item.SOLD_TO_ACCT_STATUS === 'A' && item.STATUS === 'A' && item.PURPOSE_STATUS === 'A' && item.ACCOUNT_SITE_STATUS === 'A' && (!self.props.state.user.selectedAddressBackup || self.props.state.user.selectedAddressBackup.SITE_USE_ID !== item.SITE_USE_ID));
									jobSiteAddressList = copyOfAddressListResponseObject.filter(item => item.ADDRESS4 === 'JOB SITE' && item.PURPOSE && item.POSTAL_CODE && item.SHIP_TO_ACCT_STATUS === 'A' && item.PARTY_SITE_STATUS === 'A' && item.SOLD_TO_ACCT_STATUS === 'A' && item.STATUS === 'A' && item.PURPOSE_STATUS === 'A' && item.ACCOUNT_SITE_STATUS === 'A');
								}
								// only filter out items which are purpose SHIP_TO but not SITE_USE_ID
								response.responseObject = response.responseObject.filter((item) => item.PURPOSE !== 'SHIP_TO' || (item.PURPOSE === 'SHIP_TO' && item.SITE_USE_ID));
								jobSiteAddressList = jobSiteAddressList.filter((item) => item.PURPOSE !== 'SHIP_TO' || (item.PURPOSE === 'SHIP_TO' && item.SITE_USE_ID));
								const otherCopyForOrder = [];
								response.responseObject.forEach(itm => {
									otherCopyForOrder.push({
										LOCATION: itm.LOCATION,
										LOCATIONID: itm.LOCATION,
										POSTALCODE: itm.POSTAL_CODE,
										SITE_USE_ID: itm.SITE_USE_ID,
										STATE: itm.STATE,
										PROVINCE: itm.PROVINCE,
										SITEID: itm.ACCOUNT_SITE_ID,
										NAME: itm.LOCATION,
										STATUS: itm.PURPOSE_STATUS,
										CITY: itm.CITY,
										COUNTRY: itm.COUNTRY,
										PURPOSE: itm.PURPOSE,
										PURPOSE_STATUS: itm.PURPOSE_STATUS,
										ACCOUNT_NUMBER: itm.SOLD_TO_ACCOUNT,
										ADDRESS1: itm.ADDRESS1,
										ADDRESS2: itm.ADDRESS2 || "",
										PRIMARYINDICATOR: itm.PRIMARY_FLAG,
										PARTY_ID: itm.PARTY_SITE_ID,
										COUNTY: itm.COUNTY,
										SITENUMBER: parseInt(itm.PARTY_SITE, 10),
										PARTYSITEID: parseInt(itm.PARTY_SITE_ID, 10),
										SHIP_TO_ACCOUNT_NUMBER: itm.SHIP_TO_ACCOUNT,
										SHIP_TO_ACCOUNT_ID: itm.SHIP_TO_ACCOUNT_ID
									});
								});
								if (self.props.state.user.selectedAddressBackup) {
									otherCopyForOrder.push(self.props.state.user.selectedAddressBackup);
								}
								self.props.otherCustomerShipToDetailsForOrder(otherCopyForOrder);
								const otherJobSiteAddressList = [];
								jobSiteAddressList.forEach(itm => {
									otherJobSiteAddressList.push({
										LOCATION: itm.LOCATION,
										LOCATIONID: itm.LOCATION,
										POSTALCODE: itm.POSTAL_CODE,
										SITE_USE_ID: itm.SITE_USE_ID,
										STATE: itm.STATE,
										PROVINCE: itm.PROVINCE,
										SITEID: itm.ACCOUNT_SITE_ID,
										NAME: itm.LOCATION,
										STATUS: itm.PURPOSE_STATUS,
										CITY: itm.CITY,
										COUNTRY: itm.COUNTRY,
										PURPOSE: itm.PURPOSE,
										PURPOSE_STATUS: itm.PURPOSE_STATUS,
										ACCOUNT_NUMBER: itm.SOLD_TO_ACCOUNT,
										ADDRESS1: itm.ADDRESS1,
										ADDRESS2: itm.ADDRESS2 || "",
										PRIMARYINDICATOR: itm.PRIMARY_FLAG,
										PARTY_ID: itm.PARTY_SITE_ID,
										COUNTY: itm.COUNTY,
										SITENUMBER: parseInt(itm.PARTY_SITE, 10),
										PARTYSITEID: parseInt(itm.PARTY_SITE_ID, 10),
										SHIP_TO_ACCOUNT_NUMBER: itm.SHIP_TO_ACCOUNT,
										SHIP_TO_ACCOUNT_ID: itm.SHIP_TO_ACCOUNT_ID
									});
								});
								// add to existing job site addresses
								self.props.saveAllJobSiteAddressList(otherJobSiteAddressList);
								self.props.saveCustomerShipToDetails(response);
								self.setState({
									getCustomerShipToDetailsCompleted: true
								}, () => {
									self.callBackAfterGettingAddressListAndCustomerShipToDetails(accountNumber);
								});
							} else {
								self.props.otherCustomerShipToDetailsForOrder([]);
								self.props.saveCustomerShipToDetails({
									...response,
									responseObject: []
								});
								self.setState({
									getCustomerShipToDetailsCompleted: true
								}, () => {
									self.callBackAfterGettingAddressListAndCustomerShipToDetails(accountNumber);
								});
							}
						});
					});

					if (userDetails && userDetails.isNonGEASsoUser && userDetails.isManRepSsoUser) {
						const asmDetails = {
							asmList: [],
							dsAsmList: []
						};
						self.props.getSalesRepId(`accountNumber=${accountNumber}&requestType=getSalesRepId`, salesRepIdResponse => {
							if(salesRepIdResponse.status && typeof salesRepIdResponse.responseObject !== 'string' && salesRepIdResponse.responseObject && salesRepIdResponse.responseObject.length) {
								const paramList = [];
								const asmSalesRepIds = [], dsAsmSalesRepIds = [];
								salesRepIdResponse.responseObject.forEach((item) => {
									const {
										ASM_ID,
										DSASMID
									} = item;
									if(ASM_ID && ASM_ID !== -3) {
										if (!asmSalesRepIds.includes(ASM_ID)) {
											asmSalesRepIds.push(ASM_ID);
										}
										if (!paramList.includes(ASM_ID)) {
											paramList.push(ASM_ID);
										}
									}
									if(DSASMID && DSASMID !== -3) {
										if (!dsAsmSalesRepIds.includes(DSASMID)) {
											dsAsmSalesRepIds.push(DSASMID);
										}
										if (!paramList.includes(DSASMID)) {
											paramList.push(DSASMID);
										}
									}
								});

								if (paramList.length) {
									self.props.getSSOFromSalesRepId(`requestType=getSSOFromSalesRepId&salesRepId=${paramList.join(',')}`, ssoFromSalesRepIdResponse => {
										if(ssoFromSalesRepIdResponse.status && ssoFromSalesRepIdResponse.responseObject && ssoFromSalesRepIdResponse.responseObject.length) {
											const parsed = !Array.isArray(ssoFromSalesRepIdResponse.responseObject)? JSON.parse(ssoFromSalesRepIdResponse.responseObject) : ssoFromSalesRepIdResponse.responseObject;
											parsed.forEach(ssoDetails => {
												if (asmSalesRepIds.includes(ssoDetails.SALESREP_ID)) {
													asmDetails.asmList.push(ssoDetails);
												}
												if (dsAsmSalesRepIds.includes(ssoDetails.SALESREP_ID)) {
													asmDetails.dsAsmList.push(ssoDetails);
												}
											})
										}
										self.props.saveSelectedAccountASMDetails(asmDetails);
									});
								} else {
									self.props.saveSelectedAccountASMDetails(asmDetails);
								}
							} else {
								self.props.saveSelectedAccountASMDetails(asmDetails);
							}
						}, false);
					}
				}
			}
		});
	}

	updateAddressList(callback) {
		const self = this;
		const { selectedAccount } = self.props.state.user;
		self.props.getAddressList(`accountNumber=${selectedAccount.ACCOUNTNUMBER}&partyId=${selectedAccount.PARTYID}&requestType=getAddressList`, false, response => {
			if(response.status) {
				// Filter out address which are not having zip code or not active
				if (selectedAccount.CUSTOMERCLASSCODE === 'INTERNATIONAL') {
					response.responseObject	= response.responseObject.filter(item => item.ADDRESS4 !== 'JOB SITE' && item.PURPOSE && (item.PURPOSE === 'BILL_TO' ? true : item.POSTALCODE) && item.STATUS === 'A' && (!item.PURPOSE_STATUS || item.PURPOSE_STATUS === 'A'));
				} else {
					response.responseObject	= response.responseObject.filter(item => item.ADDRESS4 !== 'JOB SITE' && item.PURPOSE && item.POSTALCODE && item.STATUS === 'A' && (!item.PURPOSE_STATUS || item.PURPOSE_STATUS === 'A'));
				}
				// only filter out items which are purpose SHIP_TO but not SITE_USE_ID
				response.responseObject = response.responseObject.filter((item) => item.PURPOSE !== 'SHIP_TO' || (item.PURPOSE === 'SHIP_TO' && item.SITE_USE_ID));
				self.props.saveAddressList(response);
				callback && callback();
			}
		});
	}

	checkForOtherAccountASM() {
		this.props.checkOtherAccountASM(`requestType=getAllOtherASM`);
	}

	makeParallelCalls(promises, callback) {
		const self = this;
		self.props.ajaxRequestInitiated();
		Promise.all(promises).then((responses) => {
			callback && callback(responses);
			self.props.ajaxRequestCompleted();
		});
	}

	getAddressListCombinedDataByAccountNumber(accountNumber, callback) {
		const self = this;
		// Make account details call first.
		self.props.getAccountDetails(`accountNumber=${accountNumber}&requestType=getAccountDetails&editOrderStatus=ENTERED`, true, resp => {
			if(resp.status && resp.responseObject) {
				self.props.getAddressList(`accountNumber=${accountNumber}&partyId=${resp.responseObject.partyId}&requestType=getAddressList&editOrderStatus=ENTERED`, false, response => {
					if(response.status) {
						callback && callback(response.responseObject);
					} else {
						browserHistory.push('/error');
					}
				});
			}
		});
	}

	whichTypeOfEmployee() {
		const self = this;
		const { userDetails } = self.props.state.user;
		if(!userDetails || userDetails.typeOfUser !== 'employee') return '';
		if(userDetails.isASM) {
			return 'asm';
		} 
		else if(userDetails.omAccess) {
			return 'om';
		}
		else if(userDetails.isInDL) {
			return 'dl';
		} else if(userDetails.otherASM) {
			return 'otherasm';
		}
		
		return 'normal';
	}

	isEmployeeHasAccessTo(whichAccess, needToHaveOnlyRetailAccount = false) {
		const self = this;
		const { userDetails } = self.props.state.user;
		if (userDetails && userDetails.isNonGEASsoUser) {
			if (userDetails.isManRepSsoUser) {
				if (['Approve Returns', 'Create New Order', 'Edit Orders', 'Invoices and Payments', 'Manage Users', 'Price', 'Price Discounts', 'Returns', 'Returns/Credits', 'User Requests', 'View Orders', 'View Reports'].includes(whichAccess)) {
					return true;
				}
			} else {
				if (['Manage Users', 'User Requests'].includes(whichAccess)) {
					return false;
				}
			}
		}
		const accessibility = typeOfEmployeeAccessLevel.find(itm => itm.typeOfEmployee === self.whichTypeOfEmployee());
		if(!needToHaveOnlyRetailAccount) {
			return accessibility && accessibility.accessLevel.indexOf(whichAccess) !== -1 ? true : false;
		} else if(self.getSelectedAccountType() === 'RETAIL') {
			return accessibility && accessibility.accessLevel.indexOf(whichAccess) !== -1 ? true : false;
		} else {
			return false;
		}
	}

	callBackAfterGettingAddressListAndCustomerShipToDetails(accountNumber) {
		const self = this;
		const { getAddressListCallCompleted, getCustomerShipToDetailsCompleted } = self.state;
		if(getAddressListCallCompleted || getCustomerShipToDetailsCompleted) {
			if(getAddressListCallCompleted && getCustomerShipToDetailsCompleted) {
				self.setState({
					isAnyAddressCallInProgress: false
				});
			}
			const { addressList, customerShipToDetailsAddressListForOrder, selectedAddressBackup } = self.props.state.user;
			if(addressList && addressList.responseObject && addressList.responseObject.length > 0) {
				let address = self.getAddressByCategory('SHIP_TO');
				if(!address) {
					address = self.getAddressByCategory('SOLD_TO');
				}
				if(!address && customerShipToDetailsAddressListForOrder) {
					// Check data from second service that is customerShipToDetails
					// only ship to and primary indicator Y needs to be check from second service.
					// First come first use
					address = customerShipToDetailsAddressListForOrder.find(itm => itm.PRIMARYINDICATOR === 'Y' && itm.PURPOSE === 'SHIP_TO');
				}
				// filtering out address from customerShipToDetails which are already present in addressList response
				if (customerShipToDetailsAddressListForOrder && customerShipToDetailsAddressListForOrder.length) {
					const updatedCustomerShipToDetailsAddressListForOrder = [];
					customerShipToDetailsAddressListForOrder.forEach(shipToAddress => {
						const foundAddressInAddressList = addressList.responseObject.find(addressListItem => addressListItem.SITE_USE_ID === shipToAddress.SITE_USE_ID
							&& addressListItem.PURPOSE === shipToAddress.PURPOSE && shipToAddress !== address);
						if(!foundAddressInAddressList) {
							updatedCustomerShipToDetailsAddressListForOrder.push(shipToAddress);
						}
					})
					self.props.otherCustomerShipToDetailsForOrder(updatedCustomerShipToDetailsAddressListForOrder);
				}
				if (!selectedAddressBackup) {
					self.props.updateSelectedAddress(JSON.stringify(address));
					if(getAddressListCallCompleted && getCustomerShipToDetailsCompleted) {
						const zipCode = address && address.POSTALCODE && address.POSTALCODE.split('-')[0];
						// if its canadian zip
						// if (isCanadianZipCode(zipCode)) {
						// 	self.saveCustomZipCode("40225");
						// 	self.setDefaultADC({POSTALCODE: "40225"}, accountNumber);
						// } else {
							self.saveCustomZipCode(zipCode);
							self.setDefaultADC(address, accountNumber);
						//}
					}
				}
			} else {
				if (!selectedAddressBackup) {
					// Check data from second service that is customerShipToDetails
					// only ship to and primary indicator Y needs to be check from second service.
					// First come first use
					let address = customerShipToDetailsAddressListForOrder.find(itm => itm.PRIMARYINDICATOR === 'Y' && itm.PURPOSE === 'SHIP_TO');
					self.props.updateSelectedAddress(JSON.stringify(address));
					if(getAddressListCallCompleted && getCustomerShipToDetailsCompleted) {
						const zipCode = address.POSTALCODE && address.POSTALCODE.split('-')[0];
						//commenting as part of WCP-7305 if its canadian zip
						// if (isCanadianZipCode(zipCode)) {
						// 	self.saveCustomZipCode("40225");
						// 	self.setDefaultADC({POSTALCODE: "40225"}, accountNumber);
						// } else {
							self.saveCustomZipCode(zipCode);
							self.setDefaultADC(address, accountNumber);
						//}
					}
				}
			}
		}
	}

	setDefaultADC(address, accountNumber) {
		const self = this;
		if (address && self.getSelectedAccountNumber() && address.POSTALCODE) {
			const zipCode = address.POSTALCODE.split('-')[0];
			// if (isCanadianZipCode(zipCode)) {
			// 	self.props.setDefaultADC('LOU');
			// 	self.props.setSelectedADC('LOU');
			// 	self.saveCustomADC('LOU');
			// } else {
				if (address.COUNTRY === 'CA'){
					address.STATE = "";
				}
				//here
				self.getShippingAddressesDetails(zipCode, false, 'adc_loc', resp => {
					if(resp && resp.agentid) {
						self.props.setDefaultADC(resp.agentid);
						self.props.setSelectedADC(resp.agentid);
						self.saveCustomADC(resp.agentid);
					}
				},
				 false, address.STATE, accountNumber,null,false,address.COUNTRY);
			//}
		}
	}

	resetShipToAddress = () => {
		const {selectedAccount} = this.props.state.user;
		if (selectedAccount) {
			const address = this.getAddressByCategory('SHIP_TO');
			if (address) {
				this.props.updateSelectedAddress(JSON.stringify(address));
				const zipCode = address.POSTALCODE && address.POSTALCODE.split('-')[0];
				this.saveCustomZipCode(zipCode);
				this.setDefaultADC(address, selectedAccount.ACCOUNTNUMBER);
			}
		}
	}

	getItemTypeByName(itemName) {
		itemName = itemName ? itemName.toLowerCase() : '';
		if(itemName.indexOf("delivery") !== -1 ||
			itemName.indexOf("handling") !== -1 ||
			itemName.indexOf("customer") !== -1 ||
			itemName.indexOf("uncrate") !== -1 ||
			itemName.indexOf("freight") !== -1 ||
			itemName.indexOf("fee") !== -1 ||
			itemName.indexOf("adc") !== -1
		) {
			return 'S';
		}
		return null;
	}

	getItemType(itemName, record) {
		let itemType = 'M';
		if (record.geego_accessory_indicator === 'Y') {
			itemType = 'A';
		} else if (itemName.length === 4 && itemName.indexOf("M") === 0) {
			itemType = "S";
		} else if(record.item_type === 'DELIVERY SERVICE') {
			if(itemName.length === 4 && itemName.indexOf("M") === 0) {
				itemType = "S";
			} else {
				itemType = "BAG";
			}
		}
		return itemType;
	}

	isItSpecialService(item) {
		let flag = false;
		const list = ['DELIVERY', 'RESTOCKING'];
		if (list.find(itm => item.toUpperCase().indexOf(itm) !== -1)) {
			flag = true;
		}
		return flag;
	}

	checkItemIsServiceOrNot(itemName) {
		const self = this;
		let itemType = 'product';
		itemName = itemName.toLowerCase();
		if((itemName.length === 4 && itemName.indexOf("m") === 0) || self.getItemTypeByName(itemName) === 'S') {
			itemType = 'service';
		}
		return itemType;
	}

	getPimDataInBatches(skuListForPim, batchSize, callback) {
		const self = this;
		const batches = _.chunk(skuListForPim, batchSize);
		const promises = [];
		batches.forEach(item => {
			// Get Order Details: getOrderDetails in parallel
			promises.push(
				sendRequest(
					productAPIUrl,
					product.pinItemInfo.path,
					'',
					product.pinItemInfo.method,
					item,
					"requestType=getPIMItemInfo",
				)
			);
		});
		self.props.ajaxRequestInitiated();
		Promise.all(promises).then((responses) => {
			// logic to combine all responses and then run call back
			let responseObject = [];
			if(responses.length > 0) {
				responses.forEach(resp => {
					if(resp.status) {
						responseObject = responseObject.concat(resp.responseObject ? resp.responseObject : []);
					}
				});
				const finalResponse = processPimDataResponse({
					...responses[0],
					responseObject
				});
				responseObject = finalResponse.responseObject;
			}
			self.props.ajaxRequestCompleted();
			callback && callback(responseObject);
		});
	}

	getItemTypeByOrderDetails(orderDetails, callback) {
		const self = this;
		const skuListForPim = orderDetails && orderDetails.items.map(item => item.internalItem);
		self.setState({
			orderDetails: JSON.parse(JSON.stringify(orderDetails))
		}, () => {
			// make service call to get pim details
			self.props.getPIMItemInfo(skuListForPim, "requestType=getPIMItemInfo", response => {
				if(response.status) {
					const responseObject = response.responseObject ? response.responseObject : null;
					let ordersDtls = JSON.parse(JSON.stringify(self.state.orderDetails));
					ordersDtls.items = [];
					const { selectedAccountsAllPriceSources } = self.props.state.user;
					self.state.orderDetails.items.forEach(item => {
						let record = _.find(responseObject, {item_number: item.item});
						if(record) {
							let customUncrateInd = "";
							let geego_uncrateind = record.geego_uncrateind;
							const saDetails  = selectedAccountsAllPriceSources && selectedAccountsAllPriceSources.responseObject.find(itm => itm.AGREEMENT_NUMBER.toString() === item.agreementNumber.toString());
							if(saDetails) {
								customUncrateInd = saDetails[geego_uncrateind] === "Y"?"Y":"N";
							}
							const itemType = self.getItemType(item.item, record);
							if(itemType) {
								ordersDtls.items.push({
									...item,
									itemType,
									customUncrateInd,
								});
							}
						}
					});
					callback && callback({
						status: true,
						orderDetails: ordersDtls,
						pimData: responseObject
					});
				}
			})
		});
	}

	isBackOrderHold(lineDetails) {
		const {
			holds
		} = lineDetails;
		if(holds && holds.hold && holds.hold.length > 0 && _.find(holds.hold, {holdName: "Backorder Hold"})) {
			return true;
		}
		return false;
	}

	isBulkOrderHold(orderHeader, orderLine) {
		const {
			holds
		} = orderHeader;
		if(holds && holds.hold && holds.hold.length > 0 &&
			_.find(holds.hold, {holdName: "Bulk Order - Do not Ship"}) &&
			orderLine.find(itm => itm.lineStatus.toLowerCase() !== 'cancelled' && itm.reservedQty)
		) {
			return true;
		}
		return false;
	}

	getLineStatusFromMapping(itemName, deliveryMethod, lineStatus, lineDetails) {
        const self = this;
        if(!lineStatus) return null;
        let {
            holds,
            backOrdNotifications,
            isodetails
        } = lineDetails;
        const originalDeliveryMethod = deliveryMethod;
        if (holds && holds.hold && holds.hold.length > 0) {
            if (_.find(holds.hold, {holdName: "Backorder Hold"})) {
                if(backOrdNotifications && backOrdNotifications.backOrdNotification) {
                    if(backOrdNotifications.backOrdNotification.length > 0) {
                        backOrdNotifications.backOrdNotification.sort(function(a, b){
                            return moment(b.notificationDate).format('YYYYMMDDhh:mm:ss') - moment(a.notificationDate).format('YYYYMMDDhh:mm:ss');
                        });
                        if(backOrdNotifications.backOrdNotification[0].notificationFlag === 'Y') {
                            return 'Backorder Available';
                        } else {
                            return 'Backorder Hold';
                        }
                    } else {
                        return 'Backorder Hold';
                    }
                }
            } else if (_.find(holds.hold, {holdName: "Reservation Transfer Line"})) {
                return 'Backorder Transferred';
            }
        }
        // lineStatus = lineStatus.toUpperCase().replace(/ /g, '_');
        const itemType = self.checkItemIsServiceOrNot(itemName);
        const relatedRecords = _.find(self.state.lineStatusMapping, {itemType});
        let label = '';
        if(itemType && relatedRecords) {
            const deliveryRecords = _.find(relatedRecords.lineStatusMappingWithDeliveryMethod, {lineStatus: lineStatus.replace(/ /g, '_').toUpperCase()});
            if(deliveryRecords) {
                if(itemType === 'product') {
                    if(!(deliveryMethod === DM_SDS_DELIVERY || deliveryMethod === DM_HOME_DELIVERY || deliveryMethod === DM_SDS_WILL_CALL)) {
                        deliveryMethod = DM_OTHER;
                    }
                    const record = _.find(deliveryRecords.deliveryMethod, {deliveryMethod});
                    if(record) {
                        label = record.label;
                    } else {
                        label = lineStatus;
                    }
                } else if(itemType === 'service') {
                    label = deliveryRecords.label;
                }
            } else {
                label = lineStatus;
            }
        }
        if(originalDeliveryMethod === DM_SDS_DELIVERY || originalDeliveryMethod === DM_SDS_NEXT_DAY_DELIVERY || originalDeliveryMethod === DM_SDS_WILL_CALL) {
            if(isodetails && isodetails.isodetail && isodetails.isodetail.length > 0) {
                const csoLineStatus = isodetails.isodetail[0].csolineStatus;
                const isoLineStatus = isodetails.isodetail[0].isolineStatus;

                if((csoLineStatus === LS_INTERNAL_REQ_OPEN || csoLineStatus === LS_INTERNAL_REQ_PARTIAL)&& isoLineStatus === 'CLOSED') {
                    label = 'Shipped';
                }
            }
        } else if(originalDeliveryMethod === DM_ADC_WILL_CALL && lineStatus === 'Picked') {
            label = 'Ready for Pickup';
        }
        return label;
    }

	getLineStatusFromMappingForParts = (lineItem, isMule) => {
		const ITEM_NUMBER_KEY = isMule ? 'ORDERED_ITEM' : 'item';
		const LINE_STATUS_KEY = isMule ? 'FORM_FLOW_STATUS_CODE' : 'lineStatus';
		const SCHEDULED_SHIP_DATE_KEY = isMule ? 'SCHEDULE_SHIP_DATE' : 'scheduleShipDate';

		let lineStatus = lineItem[LINE_STATUS_KEY] || '';

		if (this.getItemTypeByName(lineItem[ITEM_NUMBER_KEY]) !== 'S') {
			const ebsLineStatusMappingKey = lineStatus.trim().replaceAll(' ', '_').toUpperCase();

			const status = ebsLineStatusMapping[ebsLineStatusMappingKey];

			if (status) {
				lineStatus = status;
			}
			if (ebsLineStatusMappingKey === 'AWAITING_SHIPPING' && lineItem[SCHEDULED_SHIP_DATE_KEY] && moment(lineItem[SCHEDULED_SHIP_DATE_KEY]).diff(moment(), 'days') > 6) {
				lineStatus = 'Backordered';
			}
		}

		return lineStatus;
	}

	checkForBackOrders(accountNumber, showLoader, callback) {
		const self = this;
		self.props.checkForBackOrders(`accountNumber=${accountNumber}&requestType=getOrderList&orderStatus=BACKORDER`, showLoader, response => {
			if (response.status) {
				let isBackOrderAvailable = false;
				response.responseObject && response.responseObject.length > 0 && response.responseObject.forEach(item => {
					const { orderHeader, orderDetail } = item;
					orderDetail.orderLine.forEach((itm, ind) => {
						if (itm.lineStatus.toLowerCase() !== 'cancelled') {
							const orderStatus = self.getLineStatusFromMapping(itm.item, orderHeader.shipmentMethod && orderHeader.shipmentMethod.description, itm.lineStatus, itm);
							if(orderStatus === 'Backorder Available') {
								isBackOrderAvailable = true;
							}
						}
					});
				});
				self.props.saveIsBackOrdersAvailable(isBackOrderAvailable);
			} else {
				self.setState({
					errorMessage: response.responseMessage
				})
			}
			callback && callback(response);
		});
	}

	checkForBulkOrdersHold(accountNumber, showLoader, callback) {
		const self = this;
		// check for bulk order hold
		self.props.checkForBulkOrdersHold(`accountNumber=${accountNumber}&requestType=getOrderList&orderStatus=bulkOrderHold`, showLoader, response => {
			if (response.status) {
				let isBulkOrdersHoldAvailable = false;
				response.responseObject && response.responseObject.length > 0 && response.responseObject.forEach(item => {
					if(self.isBulkOrderHold(item.orderHeader, item.orderDetail.orderLine)) {
						isBulkOrdersHoldAvailable = true;
					}
				});
				self.props.saveIsBulkOrdersHoldAvailable(isBulkOrdersHoldAvailable);
			} else {
				self.setState({
					errorMessage: response.responseMessage
				})
			}
			callback && callback(response);
		});
	}
	saveSelectedAccountAndPriceSourceToLocalStorage(selectedAccount, selectedPriceSource) {
		const self = this,
			localStrogeObj = self.getLocalStorageVar(localStorageVar);
		if(localStrogeObj) {
			localStorage.setItem(localStorageVar, JSON.stringify({
				...localStrogeObj,
				selectedAccount,
				selectedPriceSource
			}))
		}
	}

	saveUserIsASMOrNotToLocalStorage(isASM) {
		const self = this,
			localStrogeObj = self.getLocalStorageVar(localStorageVar);
		if(localStrogeObj) {
			localStorage.setItem(localStorageVar, JSON.stringify({
				...localStrogeObj,
				isASM
			}))
		}
	}

	saveUserIsInDLOrNotToLocalStorage(isInDL) {
		const self = this,
			localStrogeObj = self.getLocalStorageVar(localStorageVar);
		if(localStrogeObj) {
			localStorage.setItem(localStorageVar, JSON.stringify({
				...localStrogeObj,
				isInDL
			}));
		}
	}

	saveUserHasManageSiteAccessToLocalStorage(isSiteManagementAccess) {
		const self = this,
			localStrogeObj = self.getLocalStorageVar(localStorageVar);
		if(localStrogeObj) {
			localStorage.setItem(localStorageVar, JSON.stringify({
				...localStrogeObj,
				isSiteManagementAccess
			}));
		}
	}

	saveUserIsAdminOrNotToLocalStorage(isAdmin) {
		const self = this,
			localStrogeObj = self.getLocalStorageVar(localStorageVar);
		if(localStrogeObj) {
			localStorage.setItem(localStorageVar, JSON.stringify({
				...localStrogeObj,
				isAdmin
			}));
		}
	}

	saveCustomZipCode(customZipCode) {
		const self = this;
		self.setState({
			customZipCode
		}, () => {
			const localStrogeObj = self.getLocalStorageVar(localStorageVar);
			if(localStrogeObj) {
				localStorage.setItem(localStorageVar, JSON.stringify({
					...localStrogeObj,
					customZipCode
				}));
			}
		});
	}

	saveCustomADC(customADC) {
		const self = this;
		self.setState({
			customADC
		}, () => {
			const localStrogeObj = self.getLocalStorageVar(localStorageVar);
			if(localStrogeObj) {
				localStorage.setItem(localStorageVar, JSON.stringify({
					...localStrogeObj,
					customADC
				}));
			}
		});
	}

	removeLocalStorageVar(variableName) {
		localStorage.removeItem(variableName);
	}

	getLocalStorageVar(variableName) {
		var localStrogeObj = localStorage.getItem(variableName);
		localStrogeObj = localStrogeObj?JSON.parse(localStrogeObj):null;
		return localStrogeObj;
	}

	handlePrint(event) {
		event.preventDefault();
		window.print();
	}

	logout(event) {
        event && event.preventDefault();
		const self = this;
		let punchOutAccess = localStorage.getItem("punchOutAccess")
		let punchOutData = localStorage.getItem("punchOutData");
		let punchOutPostUrl = 	localStorage.getItem("punchOutPostUrl");
		localStorage.removeItem("RDDate");
		localStorage.removeItem("zipCodeChanged");
		localStorage.removeItem("punchOutAccess");
        self.removeLocalStorageVar(localStorageVar);
		self.removeLocalStorageVar(redirectURLCNetVar);
		//Clearing stores as well with initial state
		self.props.resetErrorsObjectInStore();
		self.props.resetBrochureObjectInStore();
		self.props.resetExportObjectInStore();
		self.props.resetHomePageObjectInStore();
		self.props.resetLoadingObjectInStore();
		self.props.resetOrderObjectInStore();
		self.props.resetPackageObjectInStore();
		self.props.resetPriceTagsObjectInStore();
		self.props.resetProductObjectInStore();
		self.props.resetRegistrationObjectInStore();
		self.props.resetResourcesObjectInStore();
		self.props.resetSearchKeywordObjectInStore();
		self.props.resetUserObjectInStore();
		self.props.resetCartObjectInStore();
		self.props.resetListObjectInStore();
		self.fireGTMTag('Header Logout', {
			navURL: '/login'
		});
		sessionStorage.clear();
		localStorage.clear();
		if(punchOutAccess == true || punchOutAccess == 'true'){
			localStorage.setItem("punchOutData", punchOutData);
			localStorage.setItem("punchOutPostUrl", punchOutPostUrl);
			browserHistory.push("/punchoutTransferCart");
		}
		else{
			window.location.href = routes.logoutSSOUrl;
		}
    }

	formatDate(date, format) {
		return date?this.pickTheDateFromString(date, format):'';
	}

	showHideLoader(flag) {
        this.setState({
            showLoader: flag
        })
    }
	acceptNumbersOnly(event) {
		if(!(event.charCode >= 48 && event.charCode <= 57)){
			event.preventDefault();
		}
	}
	isValidOrderNumer(orderNumber) {
		let flag = true;
		const numericRegex = /^[0-9]*$/;
		if (orderNumber && !numericRegex.test(orderNumber)) {
			flag = false;
		}
		return flag;
	}

	isValidCLANumber(claNumber){
		let flag = true;
		const regex = /^CLA[A-Za-z0-9]{7,8}$/;
		if (claNumber && !regex.test(claNumber)) {
			flag = false;
		}
		return flag;
	}
	// @param context - CNET or PNET or NCRP
	isValidReferenceNumber(referenceNumber, context = 'CNET') {
		let flag = true;
		referenceNumber = referenceNumber.toUpperCase();
		if (context === 'CNET' && referenceNumber && referenceNumber.toUpperCase().indexOf("CTN") !== 0) {
			flag = false;
		}
		return flag;
	}
	// acceptNumbersAndDotOnly(event) {
	// 	if(!((event.charCode >= 48 && event.charCode <= 57) || String.fromCharCode(event.charCode) === '.')) {
	// 		event.preventDefault();
	// 	}
	// }

	acceptNumbersAndDotOnly(event) {
        const currentValue = event.target.value;
		const isNumberPressed = (event.charCode >= 48 && event.charCode <= 57);
		const isDotPressed = String.fromCharCode(event.charCode) === '.';
		const isAlreadyDotEntered = currentValue.indexOf('.') !== -1;
		const indexOfDot = currentValue.indexOf('.');
		const selectionStart = event.target.selectionStart;
        if(
			// if . pressed at start then preventDefault
			(isDotPressed && currentValue.length === 0) ||
			// if not . or number pressed then ignore and preventDefault
			!(isNumberPressed || isDotPressed) ||
			(isDotPressed && isAlreadyDotEntered) ||
			(isAlreadyDotEntered && selectionStart - indexOfDot > 2)
            // // if . is already entered and 2 decimal places are also entered then ignore
            // (currentValue.indexOf('.') !== -1 && currentValue.split('.')[1].length === 2) ||
            // // OR
            // // number is not entered or . pressed which is already in text field then need to ignore
            // !(
            //     (event.charCode >= 48 && event.charCode <= 57) ||
            //     (currentValue.length && currentValue.indexOf('.') === -1 && String.fromCharCode(event.charCode) === '.')
            // )
        ) {
			event.preventDefault();
        }
	}

	accept2DecimalNumbersOnly(value) {
		const regexp = /^\d+(\.\d{1,2})?$/;
		return regexp.test(value);
	}

	acceptAlphaNumericOnly(event) {
		if(!(/^\s*([0-9a-zA-Z]*)\s*$/).test(String.fromCharCode(event.charCode))){
			event.preventDefault();
		}
	}

	getSelectedAccountNumber() {
		const self = this;
		let accountNumber = self.props.state.user.selectedAccount?self.props.state.user.selectedAccount.ACCOUNTNUMBER:'';
		if(!accountNumber) {
			//read it from localStorage
			const localStrogeObj = self.getLocalStorageVar(localStorageVar);
			if(localStrogeObj && localStrogeObj.selectedAccount) {
				accountNumber = localStrogeObj.selectedAccount.ACCOUNTNUMBER;
			}
		}
		return accountNumber;
	}

	isSelectedAccountNumberAsIs() {
		const self = this;
		let flag = false;
		const { selectedAccount } = self.props.state.user;
		if(selectedAccount && selectedAccount.CUSTOMERCLASSCODE === 'AS-IS') {
			flag = true;
		}
		return flag;
	}

	normalizePhoneNumber(s, isNonUSOrCA = false) {
		if(!s) return '';
		if (!isNonUSOrCA) {
			var npa, nxx, xxxx, n;

			n = s.replace(/\D+/g, "");
			if ((/^1?([2-9]\d{2})(\d{3})(\d{4})$/).test(n)) {
				npa  = RegExp.$1;
				nxx  = RegExp.$2;
				xxxx = RegExp.$3;
				n = "(%s) %s-%s".replace(/%s/, npa).replace(/%s/, nxx).replace(/%s/, xxxx);
				return n;
			}
			return s;
		} else {
			let formattedPhoneNumber = s.trim();
			formattedPhoneNumber = formattedPhoneNumber.charAt(0) === '+' ? formattedPhoneNumber.charAt(0) + formattedPhoneNumber.slice(1).replace(/\D+/g, '') : formattedPhoneNumber.replace(/\D+/g, '');
			return formattedPhoneNumber;
		}
	}

	formatAmount2Decimal(amount) {
		amount = typeof amount === 'number'?amount.toString():amount;
        amount = (amount)?amount.trim().replace(/,/g,""):amount;
        if(amount) {
            amount = amount.replace("$","");
            amount = "$"+parseFloat(amount).toFixed(2);
            return amount;
        } else {
            return "--";
        }
    }

	formatMoney(n, c, d, t, removeDecimal, currencySymbol) {
		// c = Math.abs(c);
		// c = isNaN(c) ? 2 : c;
		if(n === 0) n = "0";
		if(!n) return "";
		if(n == "Today's price not available currently."){
			return <span style={{color:"red", fontWeight:"bold"}}>{"Item not priced"}</span>
		}
		n = parseFloat(n.toString().replace(/,/g,''));
		var decimalPoints = n.toString().indexOf(".")!==-1?n.toString().substr(n.toString().indexOf(".")):".00";
		n = parseInt(n, 10);
	    d = d === undefined ? "." : d;
	    t = t === undefined ? "," : t;
		var s = n < 0 ? "-" : "",
		    i = String(parseFloat(n = Math.abs(Number(n) || 0))),
			j = i.length;
	    j = j > 3 ? j % 3 : 0;
		if(decimalPoints.length === 2) {
			decimalPoints += "0"
		}
		var result = s + (j ? i.substr(0, j) + t : "") + i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + t) + (removeDecimal?"":decimalPoints);
		if(currencySymbol) {
			if(result < 0) {
				result = "-" + currencySymbol + result.replace("-", "");
			} else {
				result = currencySymbol + result;
			}
		}
	   	return result;
 	}

	// if nothing is passed it will convert today's date to America/New_Yor
	convertDateToTimeZone(date, timezone = 'America/New_York') {
		if (date) {
			return moment(date).tz(timezone);
		} else {
			return moment().tz(timezone);
		}
	}

	isPricingAvailable(response) {
		let flag = false;
		if (response.responseObject && response.responseObject.items && response.responseObject.items.length > 0 &&
			response.responseObject.items[0].records && response.responseObject.items[0].records.length > 0
		) {
			flag = true;
		}
		return flag;
	}

	makeParallelCallsForCartPrices(cartItems, showLoader, saveToStore, cartOrOrder, pricingEffectiveDate, callback = null, isPart = false) {
		// Group all items by agreementNumber and then make parallel calls
		const self = this,
			{ selectedAccount, selectedPriceSource, selectedAccountsAllPriceSources } = self.props.state.user;
			// { cart } = self.props.state.cart,
			// { cartItems } = cart.responseObject;
		if (!pricingEffectiveDate) {
			pricingEffectiveDate = moment().tz('America/New_York').format('YYYYMMDD');
		}

		if(isPart) {
			const cartItemsBySalesAgreement = [];
			const groupBySA = _.groupBy(cartItems, 'agreementNumber');

			Object.keys(groupBySA).forEach(key => {
				cartItemsBySalesAgreement.push({
					agreementNumber: key.toString(),
					list: _.chunk(
						groupBySA[key].map(cartItem => cartItem.item),
						150
					)
				});
			});
			
			const pricingCallsCount = cartItemsBySalesAgreement.reduce((acc, cur) => acc + cur.list.length, 0);

			self.setState({
				totalPricingParallelCalls: pricingCallsCount
			}, () => {
				cartOrOrder === 'order' && self.props.resetPricesToOrder();
				let payload = {
					accountNumber: selectedAccount.ACCOUNTNUMBER,
					pricingEffectiveDate
				};

				cartItemsBySalesAgreement.forEach(item => {
					payload = {
						...payload,
						saNumber: item.agreementNumber
					};

					item.list.forEach(itemNumbers => {
						if(itemNumbers.length) {
							payload = {
								...payload,
								itemNumber: itemNumbers.map(itemNumber => itemNumber)
							}

							self.props.checkForPartsPrices(payload, showLoader, saveToStore, cartOrOrder, () => {
								self.setState({
									totalPricingParallelCalls: self.state.totalPricingParallelCalls - 1
								}, () => {
									if(self.state.totalPricingParallelCalls === 0) {
										callback && callback();
									}
								});
							});
						}
					})
				})
			});
			return;
		}

		let updatedCartItems = window.convertToArrayOfObject(_.groupBy(cartItems, "agreementNumber"), 'groupBy');
		updatedCartItems = updatedCartItems.filter(item => item.key);
		self.setState({
			totalPricingParallelCalls: updatedCartItems.length,
		}, () => {
			let payload = {
				account_number: selectedAccount.ACCOUNTNUMBER,
				pricing_effective_date: pricingEffectiveDate,
			};
			cartOrOrder === 'order' && self.props.resetPricesToOrder();
			updatedCartItems.forEach(item => {
				const items = [];
				item.list.forEach((itm, index) => {
					if((itm.itemType === 'M' || itm.itemType === 'A') && (itm.agreementNumber && selectedAccountsAllPriceSources.responseObject.find(it => it.AGREEMENT_NUMBER.toString() === itm.agreementNumber.toString()))) {
						// if original item is there for any substitute item then we need to pass original item else item
						items.push((itm.originalItem || itm.item));
					}
				});
				if (items.length) {
					payload = {
						...payload,
						sa_number: !item.key || item.key === 'null' ? selectedPriceSource.AGREEMENT_NUMBER.toString() : item.key,
						item_numbers: items
					};
					self.makePricingServiceCall(payload, showLoader, saveToStore, cartOrOrder, callback);
				} else {
					callback && callback();
				}
			})
		});
	}

	makePricingServiceCall(payload, showLoader, saveToStore, cartOrOrder, callback) {
		const self = this;
		self.props.checkForPrices(payload, showLoader, saveToStore, cartOrOrder, response => {
			self.setState({
				totalPricingParallelCalls: self.state.totalPricingParallelCalls - 1
			}, () => {
				if(self.state.totalPricingParallelCalls === 0) {
					callback && callback();
				}
			});
		});
	}

	manipulateProductSpecsData(productSpecsData) {
		// var productSpecsData = action.data;
		if(productSpecsData && productSpecsData.responseObject) {
			var orderOfSorting =['CAPACITY','FEATURES','ECONOMICAL / QUIET','APPEARANCE','WEIGHTS & DIMENSIONS','POWER / RATINGS','ACCESSORIES','WARRANTY','CERTIFICATIONS','FILTER','MISCELLANEOUS'],
				sortedFeaturesList = [];

			/*Set product details*/
			//set product data Group by definition and change it in proper json format
			var temp = productSpecsData.responseObject.attributes;
			temp = _.groupBy(temp, "definition");
			temp = window.convertToArrayOfObject(temp, 'groupBy');

			sortedFeaturesList = orderOfSorting.map((item,index) => {
				return _.find(temp, ['key',item]);
			});
			sortedFeaturesList = sortedFeaturesList.filter(function( element ) {
				return element !== undefined;
			});
			sortedFeaturesList.map((item,index)=>{
				item.list.sort(function(a, b){
					return a.Priority - b.Priority;
				});
				return null;
			})

			//Inherit sorted features list with existing attributes
			productSpecsData = {
				...productSpecsData,
				responseObject: {
					...productSpecsData.responseObject,
					sortedFeaturesList
				}
			}
		} else {
			productSpecsData.responseObject = 'NA'; // 'NA' means no data found for this sku
		}
		return productSpecsData;
	}

	doNothing(event) {
		event && event.preventDefault()
	}

	getIEVersion() {
		var sAgent = window.navigator.userAgent;
		var Idx = sAgent.indexOf("MSIE");

		// If IE, return version number.
		if (Idx > 0)
			return parseInt(sAgent.substring(Idx+ 5, sAgent.indexOf(".", Idx)), 10);

		// If IE 11 then look for Updated user agent string.
		else if (!!navigator.userAgent.match(/Trident\/7\./))
			return 11;

		else
			return 0; //It is not IE
	}

	getUrlParameter(name) {
	    name = name.replace(/[[]/, '\\[').replace(/[\]]/, '\\]');
	    var regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
	    var results = regex.exec(location.search);
	    return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
	}

	hasRequestReturnAccess() {
		const self = this;
		let flag = self.isResponsibilityExists("Returns") || self.isResponsibilityExists("Returns/Credits");
		const { userDetails, accountResponsibilityData } = self.props.state.user;
		// if user is customer and has access to request credit then we have to check allowed credit types should be also there
		if(userDetails && userDetails.typeOfUser === 'customer' && flag) {
			// if there is no account responsibility data then we need to show that link
			// if there is no responseObject data then we need to show that link
			if(!(!accountResponsibilityData || !accountResponsibilityData.responseObject || accountResponsibilityData.responseObject.returns !== 'No')) {
				flag = false;
			}
		}
		return flag;
	}

	hasRequestCreditAccess() {
		const self = this;
		let flag = self.isResponsibilityExists("Returns") || self.isResponsibilityExists("Returns/Credits");
		const { userDetails, accountResponsibilityData } = self.props.state.user;
		// if user is customer and has access to request credit then we have to check allowed credit types should be also there
		if(userDetails && userDetails.typeOfUser === 'customer' && flag) {
			if(!accountResponsibilityData || !accountResponsibilityData.responseObject || !accountResponsibilityData.responseObject.allowedCreditTypes || accountResponsibilityData.responseObject.allowedCreditTypes.length === 0) {
				flag = false;
			}
		}
		return flag;
	}

	isVelocityCustomer(callback) {
		const self = this;
		const { accountResponsibilityData } = self.props.state.user;
		let isVelocityCustomer = false;
		if(accountResponsibilityData && accountResponsibilityData.responseObject && accountResponsibilityData.responseObject.velocityCustomer === 'Y') {
			isVelocityCustomer = true;
		}
		return isVelocityCustomer;
	}

	// Home Depot Renovation Services
	isThisAccountRestricted() {
		const self = this;
		const { accountResponsibilityData } = self.props.state.user;
		let isHomeDepotRennovationServices = false;
		if(accountResponsibilityData && accountResponsibilityData.responseObject && accountResponsibilityData.responseObject.hdRenoAccount === 'Y') {
			isHomeDepotRennovationServices = true;
		}
		return isHomeDepotRennovationServices;
	}

	isShowGESKU() {
		const self = this;
		const { accountResponsibilityData } = self.props.state.user;
		let showGESKU = false;
		if(accountResponsibilityData && accountResponsibilityData.responseObject && accountResponsibilityData.responseObject.showGESKU === 'Y') {
			showGESKU = true;
		}
		return showGESKU;
	}

	isResponsibilityExists(responsibilityToCheck) {
		const self = this;
		const { selectedAccount, localUserDetails, userDetails } = self.props.state.user;
		if(userDetails && userDetails.typeOfUser === 'employee') {
			if(self.isEmployeeHasAccessTo(responsibilityToCheck)) {
				return true;
			} else {
				return false;
			}
		}
		if(self.isPunchOutAccess()){
			
			let accessLevel = [
				'Price',			// Done
				'Price Discounts', 	// Done
				'View Orders'
			]
			let isValuePresent = accessLevel.includes(responsibilityToCheck);
			return isValuePresent;
		}
		let responsibilityThere = false;
		if(selectedAccount && localUserDetails && localUserDetails.responseObject && localUserDetails.responseObject.accounts) {
			const data = localUserDetails.responseObject.accounts.find(itm => itm.accountNumber === selectedAccount.ACCOUNTNUMBER);
			if(data && data.responsibilities && data.responsibilities.indexOf(responsibilityToCheck) !== -1) {
				return true;
			}
		}
		return responsibilityThere;
	}

	isPunchOutAccess(){
		try{
			const self = this;
			if(self.props && self.props.state && self.props.state.user && self.props.state.user.userDetails && self.props.state.user.userDetails.punchOutAccess){
				return self.props.state.user.userDetails.punchOutAccess
			}
		}
		catch(e){
			console.log(JSON.stringify(e))
		}
		return false;
	}

	transferCart(totalCartCost, date){
		const self = this;
		let userDetails = self.props.state.user.userDetails;
		const currentDate = moment();
    	const formattedDate = currentDate.format('YYYY-MM-DD HH:mm:ss.SSS');
		let punchOutCartDetails = {
			"cXML": {
			  "@payloadID": userDetails.payloadID,
			  "@xml:lang": "en-US",
			  "@timestamp": formattedDate,
			  "@version": "1.2.0.14",
			  "Header": {
				"From": {
				  "Credential": {
					"@domain": "NetworkID",
					"Identity": userDetails.punchoutFromIdentity
				  }
				},
				"To": {
				  "Credential": {
					"@domain": "NetworkId",
					"Identity": userDetails.punchoutToIdentity
				  }
				},
				"Sender": {
				  "Credential": {
					"@domain": "NetworkID",
					"Identity": userDetails.punchoutSenderIdentity
				  },
				  "UserAgent": {}
				}
			  },
			  "Message": {
				"@deploymentMode": "production",
				"PunchOutOrderMessage": {
				  "BuyerCookie": userDetails.punchoutBuyerCookie,
				  "PunchOutOrderMessageHeader": {
					"@operationAllowed": "edit",
					"@quoteStatus": "final",
					"Total": {
					  "Money": {
						"@currency": "USD",
						"#text": totalCartCost || 0
					  }
					},
					"Shipping": {
					  "Money": {
						"@currency": "USD",
						"#text": "0"
					  },
					  "Description": {
						"@xml:lang": "en-US",
						"#text": ""
					  }
					},
					"Tax": {
					  "Money": {
						"@currency": "USD",
						"#text": "0"
					  },
					  "Description": {
						"@xml:lang": "en-US",
						"#text": ""
					  }
					}
				  },
				  "ItemIn": []
				}
			  }
			}
		  }
		  
		const { cart } = self.props.state.cart;
		let items = [];
		let lineNumberCount = 1;
		cart.responseObject && cart.responseObject.cartItems &&
		cart.responseObject.cartItems.length > 0 && cart.responseObject.cartItems.forEach((item, index) => {
			let itemIn = {
				"@quantity": item.quantity || 0,
				"@requestedDeliveryDate" : localStorage.getItem("sdsDate"),
				"ItemID": {
				  "SupplierPartID": item.item || "",
				  "SupplierPartAuxiliaryID": null
				},
				"ItemDetail": {
				  "UnitPrice": {
					"Money": {
					  "@currency": "USD",
					  "#text": item.price || 0
					}
				  },
				  "Description": {
					"@xml:lang": "en-US",
					"#text": item.itemDescription || ""
				  },
				  "UnitOfMeasure": "EA",
				  "Classification": {
					"@domain": "UNSPSC",
					"#text": item.unspcClacification || ""
				  },
				  "ManufacturerPartID": null,
				  "ManufacturerName": [
					{
					  "@xml:lang": "en",
					  "#text": "GE APPLIANCES"
					}
				  ],
				  "LeadTime": "0"
				}
			  }
			  if("CoupaCatalog" === userDetails.punchoutFromIdentity){
				itemIn["@requestedDeliveryDate"] = moment().add(3, "days").format("YYYY-MM-DD");
				itemIn["@lineNumber"] = lineNumberCount;
				lineNumberCount++;
			   }else{
				itemIn["@requestedDeliveryDate"] = moment(date).format("YYYY-MM-DD");
			   }
			  items.push(itemIn);
		});
		punchOutCartDetails.cXML.Message.PunchOutOrderMessage.ItemIn=items;
		var xml = builder.create(punchOutCartDetails).end({ pretty: true});
		xml = xml.replace('<?xml version="1.0"?>','');
		let xmlMetaData = `<?xml version="1.0" encoding="UTF-8"?>
<!DOCTYPE cXML SYSTEM "http://xml.cXML.org/schemas/cXML/1.2.011/cXML.dtd">`;
		xml = xmlMetaData + '\n' + xml.trim();
		xml = xml.trim()
		let postUrl = self.props.state.user.userDetails.punchoutPostUrl ? self.props.state.user.userDetails.punchoutPostUrl.replace("&amp;","&") : self.props.state.user.userDetails.punchoutPostUrl;
		let punchOutFinalPostUrl = `${bootAPIUrl}oAuth/postPunchout`;
		self.props.postPunchOutData(xml, punchOutFinalPostUrl, response => {
			localStorage.setItem("punchOutData", xml);
			localStorage.setItem("punchOutPostUrl", postUrl);
			self.logout();
		});
	}

	getElementOffset(elementId) {
		var bodyRect = document.body.getBoundingClientRect(),
			el2 = document.getElementById(elementId).getBoundingClientRect(),
			offset   = el2.top - bodyRect.top;
		return offset;
	}

	viewPDFViewer(pdfURL, pdfLinkText) {
		//check if browser is IE
		if(this.getIEVersion() > 0) {
			//PDF will be opened in new window
			window.open(pdfURL);
		} else {
			localStorage.setItem('cnet-pdf-viewer-details', JSON.stringify({
				pdfPath: pdfURL,
				pdfLinkText: pdfLinkText
			}));
			//PDF will be opened in new window
			window.open('/pdf-viewer');
		}
	}

	getOrderWeightFromPimData(pimItemData, quantity) {
		if(pimItemData && pimItemData['geego_carton_gross_weight'] && pimItemData['geego_carton_gross_weight'] !== 'NULL') {
			return parseFloat(pimItemData['geego_carton_gross_weight'] * quantity);
		}
		return 0.00;
	}

	getPimDataForCartItem(callback) {
		const self = this,
			skuListForPim = [],
			{ cart } = self.props.state.cart;
		cart.responseObject && cart.responseObject.cartItems &&
		cart.responseObject.cartItems.length > 0 && cart.responseObject.cartItems.forEach((item, index) => {
			skuListForPim.push(item.item);
		});
		// make service call to get pim details
		skuListForPim.length > 0 && self.props.getPIMItemInfo(skuListForPim, "requestType=getPIMItemInfo", response => {
			let attributeName = "geego_top_load";
			self.getOrgAttributesByAttributeName("Top Load Indicator", resp => {
				if(!resp) {
					attributeName = "geego_no_top_load";
				}
				self.props.updateCartOrderPoints({pimData: response.responseObject, attributeName});
				callback && callback(response);
			});
		});
	}

	getPimDataForListItem(callback) {
		const self = this;
		const skuListForPim = [];
		this.props.state.list.list && this.props.state.list.list.responseObject && this.props.state.list.list.responseObject.wishlistItems && this.props.state.list.list.responseObject.wishlistItems.length
			&& this.props.state.list.list.responseObject.wishlistItems.forEach((item, index) => {
				if (item.itemType === 'M' || item.itemType === 'A') {
					skuListForPim.push(item.item);
				}
			});
		skuListForPim.length > 0 && self.props.getPIMItemInfo(skuListForPim, "requestType=getPIMItemInfo", response => {
			if (response.status) {
				const responseObject = response.responseObject ? response.responseObject : null;
				self.props.savePimDataForList(responseObject);
				callback && callback();
			}
		});
	}

	getAccountResponsibility(accountNumber, callback) {
		const self = this;
		self.props.saveAccountResponsibility(null);
		self.props.getAccountResponsibility(`requestType=getAccountResponsibility&accountNumber=${accountNumber}`, resp => {
			if(resp.status) {
				callback && callback(resp);
			}
		});
	}

	formatETADate(etaDate) {
		const tempDate = moment(etaDate);
		if(tempDate.isValid()) {
			etaDate = moment(etaDate).format('MM/DD/YY');
		}
		return etaDate;
	}

	validateFDD(item) {
		const data = JSON.parse(JSON.stringify(item));
		// If the FDD is in the future (>sys date), we need to consider this logic:
		if(item.firstDistributionDate && moment(item.firstDistributionDate).isAfter(moment())) {
			// If there is product available now in DDT, put that qty in Avail (like any model), in the Next Avail column put “NEW” and in the ETA column, put the FDD
			if(item.availableQty && parseInt(item.availableQty, 10) > 0) {
				data.intransitQty = 'NEW';
				data.etaDate = moment(item.firstDistributionDate).format('MM/DD/YY');
			}
			// If the ETA is > (sys date + 365 days), in the Next Avail column put “NEW” and in the ETA column, put the FDD (today I see a qty of 10,000,000,000 and an ETA of 12/21/20 which is not “real” data)
			if(moment(item.etaDate).isAfter(moment().add(routes.horizon, "days"))) {
				data.intransitQty = 'NEW';
				data.etaDate = moment(item.firstDistributionDate).format('MM/DD/YY');
			}
			// If the ETA is < (sys date + 365 days), put the Qty from DDT in Next Avail. In the ETA column, put whichever date is GREATER, the FDD or the ETA from DDT
			if(moment(item.etaDate).isBefore(moment().add(routes.horizon, "days"))) {
				data.intransitQty = item.intransitQty;
				if(moment(item.firstDistributionDate).isAfter(item.etaDate)) {
					data.etaDate = moment(item.firstDistributionDate).format('MM/DD/YY');
				} else {
					data.etaDate = moment(item.etaDate).format('MM/DD/YY');
				}
			}
		}
		// Additionally, for any model that is NOT a future FDD (per above) or FP model and
		// the ETA from DDT is more than 1 year in the future (>sysdate+365) do not show
		// the Next Avail qty and show “NA” in the ETA column.
		else if(item.etaDate && moment(item.etaDate).isAfter(moment().add(routes.horizon, "days"))) {
			data.intransitQty = null;
			data.etaDate = '6+ mos';
		}
		return data;
	}

	checkIfFP(item) {
		let flag = false;
		// console.log("cond 1", moment(item.finalProductionDate).isSameOrBefore(moment()));
		// console.log("cond 2", !item.availableQty);
		// console.log("cond 3", moment(item.etaDate).isAfter(moment().add(30, "days")));
		if(moment(item.finalProductionDate).isSameOrBefore(moment().hours(0).minutes(0).seconds(0).milliseconds(0)) &&
			(!item.availableQty || item.availableQty === "0" || item.availableQty < item.requestedQuantity) &&
			moment(item.etaDate).isAfter(moment().add(routes.horizon, "days").hours(0).minutes(0).seconds(0).milliseconds(0))
		) {
			flag = true;
		}
		return flag;
	}

	checkIfFPExceptAvailability(item) {
		let flag = false;
		// console.log("cond 1", moment(item.finalProductionDate).isSameOrBefore(moment()));
		// console.log("cond 3", moment(item.etaDate).isAfter(moment().add(30, "days")));
		if(moment(item.finalProductionDate).isSameOrBefore(moment().hours(0).minutes(0).seconds(0).milliseconds(0)) &&
			moment(item.etaDate).isAfter(moment().add(routes.horizon, "days").hours(0).minutes(0).seconds(0).milliseconds(0))
		) {
			flag = true;
		}
		return flag;
	}

	checkIfFPForManageOrder(item) {
		let flag = false;
		if(moment(item.finalProductionDate).isBefore(moment().hours(0).minutes(0).seconds(0).milliseconds(0)) &&
			moment(item.suggestedShipDate).isAfter(moment().add(routes.horizon, "days").hours(0).minutes(0).seconds(0).milliseconds(0))
		) {
			flag = true;
		}
		return flag ? 'FP' : item.suggestedShipDate;
	}

	checkAvailabilityGroupByDemandClass(payload, params, isItemOrderibilityCallRequired, itemOrderabilityQueryString, whichPage, showLoader, callback) {
		const self = this;
		// Commented for WCP7861 point -11 changes 
		// const skuListGroup = _.chain(payload).groupBy("demandClass")
    	// 		.map((value, key) => ({ demandClass: key, skuList: value }))
    	// 		.value();
		self.setState({
			//noOfBatchesForAvailability: skuListGroup.length,
			//noOfBatchesCompletedForAvailability: 0,
			responseOfAvailability: [],
		}, () => {
			//skuListGroup.forEach(item => {
				if (isItemOrderibilityCallRequired) {
					self.checkAvailabilityAndOrderability(payload, `${params}`, itemOrderabilityQueryString, whichPage, showLoader, response => {
						self.callBackAfterAvailabilityCalls(response, whichPage, callback);
					});
				} else {
					self.checkAvailabilityGeneric(payload, `${params}`, whichPage, showLoader, response => {
						self.callBackAfterAvailabilityCalls(response, whichPage, callback);
					});
				}
			//});
		});
	}

	checkAvailabilityInBatches = (payload, params, isItemOrderibilityCallRequired, itemOrderabilityQueryString, whichPage, showLoader, callback) => {
		if(isItemOrderibilityCallRequired) {
			this.setState({
				noOfBatchesForAvailability: payload.length,
				noOfBatchesCompletedForAvailability: 0,
				responseOfAvailability: [],
			}, () => {
				this.checkAvailabilityAndOrderability(payload, params, itemOrderabilityQueryString, whichPage, showLoader, response => {
					this.callBackAfterAvailabilityCalls(response, whichPage, callback);
				});
			})
		} else {
			this.setState({
				isAvailabilityCallCompleted: false,
				availabilityData: null
			}, () => {
				this.checkAvailabilityGenericInBatches(payload, params, whichPage, showLoader, (responses) => {
					const availabilityData = {
						...responses[0],
						responseObject: [],
					};
					responses.forEach(item => {
						availabilityData.responseObject = availabilityData.responseObject.concat(item.responseObject);
					});
					this.setState({
						isAvailabilityCallCompleted: true,
						availabilityData,
					}, () => {
						this.callBackAfterAvailability(whichPage, callback);
					});
				}, true);
			})
		}
	}

	callBackAfterAvailabilityCalls(response, whichPage, callback) {
		const self = this;
		self.setState({
			// noOfBatchesCompletedForAvailability: self.state.noOfBatchesCompletedForAvailability + 1,
			responseOfAvailability: self.state.responseOfAvailability.concat(response)
		}, () => {
			// Commented for WCP7861 point -11 changes 
			//if(self.state.noOfBatchesCompletedForAvailability === self.state.noOfBatchesForAvailability) {
				const { responseOfAvailability } = self.state;
				let availabilityData = {
					responseObject: []
				};
				responseOfAvailability.forEach(item => {
					availabilityData = {
						...item,
						...availabilityData,
						responseObject: availabilityData.responseObject.concat(item.responseObject)
					};
				});
				if(whichPage === 'cart') {
					self.props.saveAvailabilityToCart(availabilityData);
				}
				callback && callback(availabilityData);
			//}
		});
	}

	isMService(itemName) {
		let flag = false;
		if (itemName.length === 4 && itemName.indexOf("M") === 0) {
			flag = true;
		}
		return flag;
	}

	isAccountClassificationInExceptionList(classificationCode = '') {
		const self = this;
		const { classificationExceptionList } = self.props.state.order;
		if (!classificationCode) {
			const { selectedAccount } = self.props.state.user;
			classificationCode = selectedAccount && selectedAccount.CUSTOMERCLASSCODE ? selectedAccount.CUSTOMERCLASSCODE.toLowerCase() : "";
		}
		if (classificationExceptionList.indexOf(classificationCode) !== -1) {
			return true;
		}
		return false;
	}

	checkAvailabilityForOrder(payload, callback) {
		const self = this;
		self.props.setAvailabilityError(null);
		if(payload.items) {
			const blankShipSetItems = payload.items.filter(itm => !itm.shipSet);
			const sortedShipSetItems = _.orderBy(payload.items.filter(itm => itm.shipSet), ['shipSet'], ['asc'])
			payload.items = sortedShipSetItems.concat(blankShipSetItems);
		}
		self.props.checkAvailabilityGeneric(payload, 'requestType=orderAvailability', '', true, response => {
			if(!response.status || !response.responseObject || self.isAtpDownMessage(response, self)) {
				const errorMessage = 'ATP is currently not available due to planned down time';
				self.props.setAvailabilityError(errorMessage);
				callback && callback([]);
			} else {
				const respObject = response.responseObject;
				respObject.forEach(itm => {
					itm.requestedDateQuantity = itm.requestedDateQuantity === '' ? itm.requestedDateQuantity : parseInt(itm.requestedDateQuantity, 10);
					if(self.props.state.order.itemAvailabilityFailedMsgList.indexOf(itm.message) !== -1){
						self.props.setAvailabilityError(itm.message);
					}
				})
				callback && callback(respObject);
			}
		}, false);
	}

	isAtpDownMessage(response, self) {
		return response.responseObject.find(itm => (self.props.state.order.orderAvailabilityFailedMsgList.indexOf(itm.message) !== -1 ) && !(self.props.state.order.itemAvailabilityFailedMsgList.indexOf(itm.message) !== -1));
	}

	checkETA(eta, firstDistributionDate) {
		// If FDD is available and its greater than today's date then only we will check further
		if(firstDistributionDate && moment(firstDistributionDate).isAfter(moment())) {
			// if there is no existing eta OR
			// If the FDD for any model is greater than the ETA, show FDD.
			if(!eta || moment(firstDistributionDate).isAfter(moment(eta))) {
				eta = moment(firstDistributionDate).format('MM/DD/YYYY');
			}
		}
		// If the ETA for any model is > sysdate+365 days, show NA in the ETA field.
		if(eta && moment(eta).isAfter(moment().add(routes.horizon, "days"))) {
			eta = '6+ mos';
		}
		return eta;
	}
	checkAvailability(availability, firstDistributionDate) {
		if (firstDistributionDate && moment(firstDistributionDate).isAfter(moment())) {
			availability = 'NEW';
		}
		return availability;
	}

	getOrderShippingDetails(orderNumber, callback) {
		const self = this;
		// No need to save this data in store as this method is getting used at multiple place
		self.props.getOrderDetails('orderNumber='+orderNumber+'&requestType=getOrderShippingDetails&accountNumber='+self.getSelectedAccountNumber(), (response) => {
			callback && callback(response);
		}, false);
	}

	getOrderShippingDetailsDates(deliveryMethod, response) {
		const dates = [];
		if(deliveryMethod && deliveryMethod.toLowerCase().indexOf('sds') !== -1) {
			if(response && response.responseObject && response.responseObject.orderdetoutrec && response.responseObject.orderdetoutrec.length &&
				response.responseObject.orderdetoutrec[0].linedetailsrec && response.responseObject.orderdetoutrec[0].linedetailsrec.value &&
				response.responseObject.orderdetoutrec[0].linedetailsrec.value.linedetails && response.responseObject.orderdetoutrec[0].linedetailsrec.value.linedetails.length
			) {
				const lineDetails = response.responseObject.orderdetoutrec[0].linedetailsrec.value.linedetails;
				lineDetails.forEach(item => {
					if(item.isodetailsrec && item.isodetailsrec.value && item.isodetailsrec.value.isodetails
						&& item.isodetailsrec.value.isodetails && item.isodetailsrec.value.isodetails.length
					) {
						item.isodetailsrec.value.isodetails.forEach(itm => {
							if(itm.isodeliverydetailsrec && itm.isodeliverydetailsrec.value && itm.isodeliverydetailsrec.value.isodeliverydetails
								&& itm.isodeliverydetailsrec.value.isodeliverydetails.length
							) {
								itm.isodeliverydetailsrec.value.isodeliverydetails.forEach(it => {
									if(it.tripdetailsrec && it.tripdetailsrec.value && it.tripdetailsrec.value.tripdetails && it.tripdetailsrec.value.tripdetails.length) {
										it.tripdetailsrec.value.tripdetails.forEach(i => {
											if(i.appointmentdelivery && i.appointmentdelivery.value && dates.indexOf(i.appointmentdelivery.value) === -1) {
												dates.push(i.appointmentdelivery.value);
											}
										})
									}
								});
							}
						});
					}
				});
			}
		} else {
			if(response && response.responseObject && response.responseObject.orderdetoutrec && response.responseObject.orderdetoutrec.length &&
				response.responseObject.orderdetoutrec[0].linedetailsrec && response.responseObject.orderdetoutrec[0].linedetailsrec.value &&
				response.responseObject.orderdetoutrec[0].linedetailsrec.value.linedetails && response.responseObject.orderdetoutrec[0].linedetailsrec.value.linedetails.length
			) {
				const lineDetails = response.responseObject.orderdetoutrec[0].linedetailsrec.value.linedetails;
				lineDetails.forEach(item => {
					if(item.deliverydetailsrec && item.deliverydetailsrec.value && item.deliverydetailsrec.value.deliverydetails
						&& item.deliverydetailsrec.value.deliverydetails && item.deliverydetailsrec.value.deliverydetails.length
					) {
						item.deliverydetailsrec.value.deliverydetails.forEach(itm => {
							if(itm.tripdetailsrec && itm.tripdetailsrec.value && itm.tripdetailsrec.value.tripdetails
								&& itm.tripdetailsrec.value.tripdetails.length
							) {
								itm.tripdetailsrec.value.tripdetails.forEach(i => {
									if(i.appointmentdelivery && i.appointmentdelivery.value && dates.indexOf(i.appointmentdelivery.value) === -1) {
										dates.push(i.appointmentdelivery.value);
									}
								});
							}
						});
					}
				});
			}
		}
		return dates;
	}

	addErrorDetailsToStore(data) {
		const self = this;
		self.props.addErrorDetailsToStore(data);
	}

	validateFP(item) {
		const self = this;
		let finalProductionDate = null;
		if(item.geego_final_production_date && item.geego_final_production_date !== 'NULL') {
			finalProductionDate = item.geego_final_production_date;
		}
		return self.checkIfFPExceptAvailability({
			finalProductionDate: finalProductionDate,
			etaDate: item.eta
		});
	}

	checkGroupShipDateByAvailabilityAndDelivery(items) {
		const self = this;
		items = JSON.parse(JSON.stringify(items));
		// Initialize all delivery date with blank means, not available
		let groupShipDate = [{
				groupShipDate: '',
				groupArrivalDate: '',
				delivery: 'delivery1'
			}, {
				groupShipDate: '',
				groupArrivalDate: '',
				delivery: 'delivery2'
			}, {
				groupShipDate: '',
				groupArrivalDate: '',
				delivery: 'delivery3'
			}
		];
		// Iterating
		groupShipDate.forEach((item) => {
			const deliveryItems = items.filter(itm => (itm.itemType === 'A' || itm.itemType === 'M') && itm.onHold !== 'Y' && itm.requestedDeliveryDate === item.delivery);
			// if items available for that particular delivery then only we have to iterate this logic of calculating group ship date
			if(deliveryItems.length) {
				// all items are disabled qty means all items are having originalOrderNumber
				if(deliveryItems.length === deliveryItems.filter(itm => itm.originalOrderNumber).length) {
					item.groupShipDate = moment().format('MM/DD/YYYY');
					item.groupArrivalDate = moment().format('MM/DD/YYYY');
				} else {
					const filteredItems = items.filter(itm => !itm.originalOrderNumber && self.validateFP(itm) !== 'FP' && itm.onHold !== 'Y' && itm.requestedDeliveryDate === item.delivery);
					// if availability error
					if (self.state.availabilityError) {
						// items are available excluding FP models and hold back order items
						if(filteredItems.length === filteredItems.filter(itm => itm.availability >= itm.quantity).length) {
							item.groupShipDate = moment().format('MM/DD/YYYY');
							item.groupArrivalDate = moment().format('MM/DD/YYYY');
						}
					}
					// else availability success
					else {
						// only one item in the response(Excluding FP and hold back order items)
						if (filteredItems.length === 1) {
							// groupShipDate = ship date from response
							item.groupShipDate = filteredItems[0].shipDate;
							item.groupArrivalDate = filteredItems[0].arrivalDate;
						} else if(filteredItems.length > 1) {
						    // groupShipDate = groupShipDate from the respo
							 item.groupShipDate = filteredItems[0].groupShipDateBkp;
							 item.groupArrivalDate = filteredItems[0].groupArrivalDateBkp;
						}
					}
				}

				// highest FDD of all items
				// exclude originalOrderNumber for fdd calculation
				let fdd = '';
				deliveryItems.forEach(itm => {
					if (!itm.originalOrderNumber) {
						if((!fdd && itm.geego_distribution_start_date) || (itm.geego_distribution_start_date && moment(itm.geego_distribution_start_date).isAfter(fdd))) {
							fdd = itm.geego_distribution_start_date;
						}
					}
				});
				// if any item highest FDD > groupShipDate, then groupShipDate = highest FDD
				if (moment(fdd).isAfter(item.groupShipDate)) {
					item.groupShipDate = moment(fdd).format('MM/DD/YYYY');
				}
				if (moment(fdd).isAfter(item.groupArrivalDate)) {
					item.groupArrivalDate = moment(fdd).format('MM/DD/YYYY');
				}

				// if groupShipDate > 1 year, then show "Not Available"
				// Here '' means it will show not available in screen
				// if (item.groupShipDate && moment(item.groupShipDate).isAfter(moment().add(routes.horizon, 'days'))) {
					// item.groupShipDate = '';}
			}
		});

		const updatedItems = [];
		items.forEach(item => {
			const data = groupShipDate.find(itm => itm.delivery === item.requestedDeliveryDate);
			updatedItems.push({
				...item,
				groupShipDate: data && data.groupShipDate,
				groupArrivalDate: data && data.groupArrivalDate
			});
		});
		return updatedItems;
	}

	checkFromOrderHeaderOnly(orderHeader) {
		const self = this;
		let flag = false;
		const selectedAddress = JSON.parse(self.props.state.user.selectedAddress);
		let {
			ADDRESS1,
			ADDRESS2,
			CITY,
			STATE,
			POSTALCODE,
		} = selectedAddress;
		ADDRESS2 = ADDRESS2 || "";
		const purposeShipTo = orderHeader && orderHeader.parties && orderHeader.parties.party.find(item => item.purpose === 'SHIP_TO');
		let locationId = purposeShipTo && purposeShipTo.party && purposeShipTo.party.partySites && purposeShipTo.party.partySites.site && purposeShipTo.party.partySites.site[0] && purposeShipTo.party.partySites.site[0].siteLocation && purposeShipTo.party.partySites.site[0].siteLocation.locationId;
		if (locationId) {
			locationId = locationId.split(' | ');
			const address1 = locationId[0],
				address2 = locationId[1],
				city = locationId[4],
				zipCode = locationId[5],
				state = locationId[6];
			if (ADDRESS1 === address1 && ADDRESS2 === address2 && CITY === city && STATE === state && zipCode === POSTALCODE) {
				flag = true;
			}
		}
		return flag;
	}

	isOrderAddressSameAsHeader(orderHeader) {
		const self = this;
		return self.checkFromOrderHeaderOnly(orderHeader);
	}

	filterLinesBySalesAgreementSameAsHeader(orderLines) {
		const self = this;
		return orderLines.filter(item => item.lineSANumber === self.props.state.user.selectedPriceSource.AGREEMENT_NUMBER);
	}

	getAddressFromOrderHeader(orderHeader) {
		const list = [];
		const { parties } = orderHeader;
		const shippingDetails = parties && parties.party && parties.party.find(itm => itm.purpose === "SHIP_TO");
		if (shippingDetails && shippingDetails.party && shippingDetails.party.partySites && shippingDetails.party.partySites.site && shippingDetails.party.partySites.site[0] && shippingDetails.party.partySites.site[0].siteLocation && shippingDetails.party.partySites.site[0].siteLocation.locationId) {
			const data = shippingDetails.party.partySites.site[0].siteLocation.locationId.split(' | ');
			data[0] && list.push(data[0]);
			data[4] && list.push(data[4]);
			data[6] && list.push(data[6]);
		}
		return list.join(', ');
	}
	// This is getting used in request credit functionality
	makePriceOrderServiceCall(orderDetails, items, accountNumber, accountNumberDetails, priceDate, isCreditRequest,creditType, callback) {
		const self = this;
		let orderTotal = 0.00;
		items.forEach(itm => {
			if(itm.quantity && itm.price) {
				orderTotal += parseFloat(itm.returnQuantity * itm.price);
			}
			itm.relatedServices && itm.relatedServices.forEach(itm => {
				orderTotal += parseFloat(itm.extendedPrice);
			});
		});
		let payload = {
			accountNumber: accountNumber,
			orderTotal: orderTotal,
			warehouseCode: orderDetails.warehouseCode,
			shipmentMethod: orderDetails.deliveryMethod,
			shipToState: self.getDefaultShippingAddressForSelectedAccount(accountNumber, accountNumberDetails) ? self.getDefaultShippingAddressForSelectedAccount(accountNumber, accountNumberDetails).state : self.getShipToState(),
			priceItems: []
		};
		if(isCreditRequest){
			const arrayPayload = [];
			items.forEach(itm => {
				let priceItem = [];
				priceItem.push({
					itemNumber: itm.item,
					qty: itm.returnQuantity,
					agreementNumber: itm.agreementNumber,
					uncrateInd: itm.uncrateInd,
					grossPointValue: itm.pointValue ? itm.pointValue : 0,
				});
				payload = {
					...payload,
					priceItems:priceItem,
					priceDate: creditType === 'As-is Credit/Rebill' ? moment().format('MM/DD/YYYY'): self.pickTheDateFromString(itm.pricingDate.split('T')[0])
				}
				arrayPayload.push(payload);
			});
			const promises = [];
			arrayPayload.forEach(payload => {
				// Get Order Details: getOrderDetails in parallel
				promises.push(
					sendRequest(
						bootAPIUrl,
						product.priceOrder.path,
						'',
						product.priceOrder.method,
						payload,
						'requestType=priceOrder'
					)
				);
			});
			self.props.ajaxRequestInitiated();
			Promise.all(promises).then((responses) => {
				// logic to combine all responses and then run call back
				let responseObject = [];
				if(responses.length > 0) {
					responses.forEach(resp => {
						if(resp.status) {
							if(resp.responseObject) {
								responseObject = responseObject.concat(resp.responseObject);
							}
						} else {
							browserHistory.push('/error');
						}
					});
					responseObject = {
						...responses[0],
						responseObject
					};
				} else {
					responseObject = {};
				}
				self.props.ajaxRequestCompleted();
				callback && callback(responseObject);
			});
		}
		else{
			items.forEach(itm => {
				payload = {
					...payload,
					priceDate: creditType === 'As-is Credit/Rebill' ? moment().format('MM/DD/YYYY') : self.pickTheDateFromString(itm.pricingDate.split('T')[0])
				};
				payload.priceItems.push({
					itemNumber: itm.item,
					qty: itm.returnQuantity,
					agreementNumber: itm.agreementNumber,
					uncrateInd: itm.uncrateInd,
					grossPointValue: itm.pointValue ? itm.pointValue : 0,
				});
			});
			self.props.getPriceOrder(payload, "requestType=priceOrder", response => {
				callback && callback(response);
			});
		}
	}

	getAddressIdOfDefaultShippingAddress() {
		const self = this;
		const shipToAddress = self.getCombinedAddresses().find(item => item.PRIMARYINDICATOR === 'Y' && item.PURPOSE === 'SHIP_TO');
		return shipToAddress && shipToAddress.SITE_USE_ID ? shipToAddress.SITE_USE_ID.toString() : '';
	}

	getDefaultShippingAddressForSelectedAccount(accountNumber, accountNumberDetails) {
		const self = this;
		let defaultShipToAddress = null;
		// if selected account numbers are not the default selected in header then we need to make second service call for rebill.
		// hence we need to save that accounts default shipping address for second service call
		const selectedAccountNumberForCredit = accountNumber.toString();
		if(selectedAccountNumberForCredit !== self.getSelectedAccountNumber()) {
			const accountDetail = accountNumberDetails.find(item => item.ACCOUNTNUMBER === selectedAccountNumberForCredit);
			const {
				ADDRESS1,
				SITE_USE_ID,
				CITY,
				LOCATIONID,
				STATE,
				POSTALCODE,
			} = accountDetail.defaultShipToAddress;
			defaultShipToAddress = {
				address1: ADDRESS1,
				address2: "",
				address3: "",
				address4: "",
				addressId: SITE_USE_ID,
				addressName: accountDetail.ORGANIZATIONNAME,
				city: CITY,
				locationId: LOCATIONID,
				phone: null,
				state: STATE,
				zip: POSTALCODE,
			};
		}
		return defaultShipToAddress;
	}

	isValidPONumberCharacter(event) {
		let isValid = true;
		const character = String.fromCharCode(event.charCode);
		const notAllowedCharacters = "`,~,|,*,>,<,/".split(',');
		if(notAllowedCharacters.indexOf(character) !== -1) {
			event.preventDefault();
			isValid = false;
		}
		return isValid;
	}

	manipulateClipBoardOfPONumber(callback, index, sku, event) {
		const clipboardData = event.clipboardData || window.clipboardData;
		let data = clipboardData.getData('Text');
		data = data.replace(/`/g, '');
		data = data.replace(/~/g, '');
		data = data.replace(/|/g, '');
		data = data.replace(/\*/g, '');
		data = data.replace(/>/g, '');
		data = data.replace(/\//g, '');
		data = data.substring(0, 50);
		if (window.clipboardData) {
			clipboardData.setData("Text", data);
		} else {
			clipboardData.setData('text/plain', data);
		}
		event.target.value = data;
		event.preventDefault();
		if (index !== undefined && sku !== undefined) {
			callback && callback(index, sku, event);
		} else {
			callback && callback(event);
		}
	}

	showAddNewAddressLink() {
		const self = this,
			{ user, order } = self.props.state,
			{ userDetails, selectedAccount, relationShipPartyList } = user,
			customerClassCode = selectedAccount && selectedAccount.CUSTOMERCLASSCODE ? selectedAccount.CUSTOMERCLASSCODE.toLowerCase() : "",
			typeOfAccount = self.getSelectedAccountType(),
			salesChannelCode = selectedAccount && (selectedAccount.SALESCHANNEL || selectedAccount.SALESCHANNELCODE).toLowerCase(),
			{ allowedCustomerClassCodes: customerRestrcictedClassCodes, accountCustomerClassCodes, accountSalesChannelCodes } = order;
		const typeOfUser = (userDetails ? userDetails.typeOfUser : '');
		let display = false;
		// display add new addres link in case of any of the condition is fulfilled
		// 1. if user is employee then show
		// OR
		// 2. if user is customer and account is Contract or Pro Channel and customer class code is not in the predefined list
		// OR
		// 3. if classification code is available in accountCustomerClassCodes
		// OR
		// 4. WCP-6197: if sales channel code is allowed in accountSalesChannelCodes
		const isEmployee = typeOfUser === 'employee';
		const isValidAccountType =(typeOfAccount === 'CONTRACT' || typeOfAccount === 'PRO CHANNEL') && !customerRestrcictedClassCodes.includes(customerClassCode);
		const isAllowedCustomerClass = accountCustomerClassCodes.includes(customerClassCode);
		const isAllowedSalesChannel = accountSalesChannelCodes.includes(salesChannelCode);
		display = isEmployee ||	isValidAccountType || isAllowedCustomerClass ||	isAllowedSalesChannel;
		var isRestrictedCustomer = false;
		if (typeOfUser === 'customer' && customerClassCode && customerClassCode.toLowerCase() === 'direct property mgt replacemen' && relationShipPartyList &&
		relationShipPartyList.responseObject && _.some(relationShipPartyList.responseObject, {RELATIONSHIP_TYPE: 'For Business Partner',RELATIONSHIP_STATUS: 'A',RELATIONSHIPCODE: 'For Business Partner member of'	})
		) {	isRestrictedCustomer = true;}
		if (isRestrictedCustomer) {
		display = false;
		}
		return display;
	}

	isValidPhoneNumber(s) {
		s = s.replace(/\D+/g, "");
		return (/^1?[2-9][0-9]{9}$/).test(s);
	}

	getWarehouseCodeDetailsFromBackOrBulkOrder(orderNumber) {
		const self = this;
		let warehouseCode = '';
		const { backOrders, bulkOrdersHold } = self.props.state.order;
		let orderDetails = backOrders && backOrders.responseObject ? backOrders.responseObject.find(item => item.orderHeader.orderNumber === orderNumber) : null;
		if (!orderDetails) {
			orderDetails = bulkOrdersHold && bulkOrdersHold.responseObject ? bulkOrdersHold.responseObject.find(item => item.orderHeader.orderNumber === orderNumber) : null;
		}
		if (orderDetails) {
			warehouseCode = orderDetails && orderDetails.orderHeader && orderDetails.orderHeader.warehouse ? orderDetails.orderHeader.warehouse.warehouseCode : '';
			warehouseCode = `Avail - ${warehouseCode}`;
		}
		return warehouseCode;
	}

	getWarehouseCodeDetailsFromBackOrBulkOrderLineLevel(orderNumber, item) {
		const self = this;
		let warehouseCode = '';
		const { backOrders, bulkOrdersHold } = self.props.state.order;
		let orderDetails = backOrders && backOrders.responseObject ? backOrders.responseObject.find(item => item.orderHeader.orderNumber === orderNumber) : null;
		if (!orderDetails) {
			orderDetails = bulkOrdersHold && bulkOrdersHold.responseObject ? bulkOrdersHold.responseObject.find(item => item.orderHeader.orderNumber === orderNumber) : null;
		}
		if (orderDetails) {
			let lineItem = orderDetails && orderDetails.orderDetail && orderDetails.orderDetail.orderLine && orderDetails.orderDetail.orderLine.length > 0 ? orderDetails.orderDetail.orderLine.find(line => line.item === item) : null;
			warehouseCode = lineItem && lineItem.warehouse ? lineItem.warehouse.warehouseCode : null;
			warehouseCode = `Avail - ${warehouseCode}`;
		}
		return warehouseCode;
	}

	/*new brochure change*/
	handleCreateFeature(featureCreateOption, fromWhichPage, event) {
		event && event.preventDefault();
		const self = this;
		if (fromWhichPage === 'step1'){
			self.props.selectFeatureCreateOption(featureCreateOption);
			//browserHistory.push('/create-brochure-step1');
		}
	}
	/*end brochure change*/

	handleCreateBrochure(brochureCreateOption, fromWhichPage, event) {
		event && event.preventDefault();
		const self = this;
		if (brochureCreateOption === 1) {
			//Reset Brochure payload before creating a new brochure
			self.props.updateSelectedItems([]);
			self.props.resetBrochurePayload(self.getSelectedAccountNumber());
			self.props.selectBrochureCreateOption(1);
			browserHistory.push('/create-brochure-step1');
		} else if(brochureCreateOption === 2) {
			//Check if user has added more than 50 products or not. If added more than 50 then show we are sorry dialog
	        let selectedItems = _.filter(this.props.state.list.list.responseObject.wishlistItems, ['selected', true]);
	        if (selectedItems.length > 50) {
	            self.setState({
					genericDialogHeading: 'We&#39;re sorry',
					genericDialogText: fromWhichPage === 'list'
						? 'Please deselect some products before creating a brochure.'
						: 'Brochures are limited to a maximum of 50 products, so the full list cannot be imported.<br /><br />Please go to the List, select a maximum of 50 products, and then choose Create Brochure from there.',
					modalButtons: 'ok',
					customClass: '',
					width: '32em',
				}, () => {
					self.handleDialog('WeAreSorryDialog', true);
				});
	        } else if (selectedItems.length === 0) {
	            self.setState({
					genericDialogHeading: 'Brochure',
					genericDialogText: 'Please select at least one product from list to create brochure.',
					modalButtons: 'ok',
					width: '',
				}, () => {
					self.handleDialog('SelectAtleastOneProductDialog', true);
				});
	        } else {
	            const { state } = self.props;
	            //Update brochure store with selected items.
	            selectedItems = JSON.parse(JSON.stringify(selectedItems));
	            selectedItems.map((item, ind) => {
	                delete item.selected;
	                return null;
	            })
	            self.props.updateSelectedItems(selectedItems);

				if (fromWhichPage === 'list') {
		            //Get saved brochures and then show dialog in case of existing brochures
		            //   are available else redirect to first step of brochure
		            self.props.getSavedBrochures("userId=" + state.user.userDetails.sso + "&accountNumber=" + self.getSelectedAccountNumber(), (response) => {
		                if (response.responseObject && response.responseObject.length > 0) {
							self.handleDialog('AddToBrochureOverlayDialog', true);
		                } else {
		                    //Reset Brochure payload before creating a new brochure
		                    self.props.resetBrochurePayload(self.getSelectedAccountNumber());
		                    self.props.selectBrochureCreateOption(2);
		                    browserHistory.push('/create-brochure-step1');
		                }
		            });
				} else if (fromWhichPage === 'step1') {
					//Reset Brochure payload before creating a new brochure
					self.props.resetBrochurePayload(self.getSelectedAccountNumber());
					self.props.selectBrochureCreateOption(2);
					browserHistory.push('/create-brochure-step1');
				}
	        }
		} else if(brochureCreateOption === 3) {
			self.props.updateSelectedItems([]);
			self.props.resetBrochurePayload(self.getSelectedAccountNumber());
			self.props.selectBrochureCreateOption(3);
		} else if(brochureCreateOption === 4) {
			self.props.updateSelectedItems([]);
			self.props.resetBrochurePayload(self.getSelectedAccountNumber());
			self.props.selectBrochureCreateOption(4);
		}
		/*new brochure changes*/
		else if(brochureCreateOption === 5){
			self.props.updateSelectedItems([]);
			self.props.resetBrochurePayload(self.getSelectedAccountNumber());
			self.props.selectBrochureCreateOption(5);
		}
		/*end brochure changes*/
	}

	// event for close dialog
	handleDialog(dialog, flag, event) {
		event && event.preventDefault();
		this.setState({
			['show'+dialog]: false
		}, () => {
			this.setState({
				['show'+dialog]: flag
			})
		})
	}

	getItemsSuggestionDetails(skuList, customParam, callback, showLoader = true) {
		const self = this;
		const isPNETOrNCRP = customParam && (customParam.includes('appName=PNET') || customParam.includes('appName=NCRP'));
		const { batchSizeForGetItems } = self.state;
		const batches = _.chunk(skuList, batchSizeForGetItems);
		const promises = [];
		batches.forEach(item => {
			// Get Order Details: getOrderDetails in parallel
			promises.push(
				sendRequest(
					productAPIUrl,
					product.getKeyWordSuggession.path,
					'',
					product.getKeyWordSuggession.method,
					isPNETOrNCRP ? `requestType=getItems&keyword=${item.join(' ')}${customParam}` :
						`requestType=getItems&keyword=${item.join(' ')}&count=${20}&accountNumber=${self.getSelectedAccountNumber()}&zipCode=${self.getZipCode()}&page=search${customParam}`
				)
			);
		});
		showLoader && self.props.ajaxRequestInitiated();
		Promise.all(promises).then((responses) => {
			// logic to combine all responses and then run call back
			let responseObject = [];
			if(responses.length > 0) {
				responses.forEach(resp => {
					if(resp.status) {
						if(resp.responseObject) {
							responseObject = responseObject.concat(resp.responseObject);
						}
					} else {
						browserHistory.push('/error');
					}
				});
			} else {
				responseObject = [];
			}
			showLoader && self.props.ajaxRequestCompleted();
			self.setState({
				getItemDetailsList: responseObject
			}, () => {
				callback && callback(responseObject);
			});
		});
	}

	getItemDescriptionBySKU(sku) {
		const self = this;
		const { getItemDetailsList } = self.state;
		let itemDescription = '';
		if (getItemDetailsList) {
			const itemDet = getItemDetailsList.find(itm => itm.sku === sku);
			if (itemDet && itemDet.description) {
				itemDescription = itemDet.description;
			}
		}
		return itemDescription;
	}

	isWeekday(date) {
		const day = date.day();
		return day !== 0 && day !== 6;
	}

	isValidBillToSiteAndLocation() {
		const self = this;
		let flag = false;
		const { selectedPriceSource } = self.props.state.user;
		const addressList = self.getCombinedAddresses();
		// The account service returns an active Bill To site for the account
		// 		OR
		// The SA on the order header has a Bill To location returned in the SA service.
		if(
			addressList.find(itm => itm.PURPOSE === "BILL_TO") ||
			selectedPriceSource.BILL_TO_LOCATION
		) {
			flag = true;
		}
		return flag;
	}

	isValidClassificationCodeForSubstitute(classificationCode) {
		const list = ['single family'];
		return list.indexOf(classificationCode) !== -1;
	}

	isAnyModelIsRestrictedInSelectedAccount(pimData) {
		let flag = false;
		if (pimData && pimData.geego_cust_acct && pimData.geego_cust_acct.indexOf(this.getSelectedAccountNumber()) !== -1) {
			flag = true;
		}
		return flag;
	}

	getRelatedItemNumbers = (pimData, relationshipType) => {
		const relatedItemNumbers = [];
		const relationShipStartDate = pimData.relationship_start_date && [].concat(pimData.relationship_start_date);
		const relationShipEndDate = pimData.relationship_end_date && [].concat(pimData.relationship_end_date);
	
		pimData.relationship_type &&
			pimData.related_item_number &&
			pimData.relationship_type.length === pimData.related_item_number.length &&
			pimData.relationship_type.forEach((pimRelationshipType, index) => {
				if (pimRelationshipType === relationshipType) {
					if (
						!relationShipStartDate ||
						relationShipStartDate[index] === 'NULL' ||
						(relationShipStartDate[index] !== 'NULL' && moment(relationShipStartDate[index], 'DD-MMM-YYYY') <= moment(moment().format('DD-MMM-YYYY'), 'DD-MMM-YYYY'))
					) {
						if (
							!relationShipEndDate ||
							relationShipEndDate[index] === 'NULL' ||
							(relationShipEndDate[index] !== 'NULL' && moment(relationShipEndDate[index], 'DD-MMM-YYYY') > moment(moment().format('DD-MMM-YYYY'), 'DD-MMM-YYYY'))
						) {
							relatedItemNumbers.push(pimData.related_item_number[index]);
						}
					}
				}
			});
	
		return relatedItemNumbers;
	};
	
	// this function fetches pim data for the items recursively iterating through the supersedure chain
	fetchPimData = (items, callback, showLoader = false) => {
		const finalPimDataByItem = [];
	
		const fetchPimData = items => {
			// filter out any duplicate items and items that are already checked against pim
			const itemsAwaitingPim = _.uniqBy(
				items.filter(item => !finalPimDataByItem.some(finalPimItemData => finalPimItemData.itemNumber === item.itemNumber)),
				'itemNumber'
			);
	
			if (itemsAwaitingPim.length) {
				const pimPayload = itemsAwaitingPim.map(item => item.itemNumber);
	
				this.props.getPIMItemInfo(
					pimPayload,
					`requestType=getPIMItemInfo`,
					pimResponse => {
						const pimDataByItem = [];
						if (pimResponse.status && pimResponse.responseObject) {
							const supersededByItems = [];
	
							itemsAwaitingPim.forEach(item => {
								const foundPimItem = pimResponse.responseObject.find(pimItem => pimItem.item_number === item.itemNumber);
								const pimItemData = {
									itemNumber: item.itemNumber
								};
	
								if (foundPimItem) {
									// find any supersedure list if any
									const supersededByItemNumbers = this.getRelatedItemNumbers(foundPimItem, 'Superseded');
									pimItemData.pimData = foundPimItem;
									pimItemData.supersededByItemNumbers = supersededByItemNumbers;
	
									// if supersededByItemNumbers contains any item number that already appeared before in the chain, that means it will end up in a loop, we will stop it with an error flag
									if (supersededByItemNumbers.some(supersededByItemNumber => item.supersedureList && item.supersedureList.includes(supersededByItemNumber))) {
										pimItemData.isInvalidSupersedure = true;
									} else if (supersededByItemNumbers.length) {
										supersededByItems.push(
											...supersededByItemNumbers.map(supersededByItemNumber => ({
												itemNumber: supersededByItemNumber,
												supersedureList: (item.supersedureList || [item.itemNumber]).concat(supersededByItemNumbers)
											}))
										);
									}
								}
	
								pimDataByItem.push(pimItemData);
							});
	
							finalPimDataByItem.push(...pimDataByItem);
	
							// if there are any new items in the supersedure list, fetch pim data for those items
							if (supersededByItems.length) {
								fetchPimData(supersededByItems);
							} else {
								// callback after fetching pim data for all the items including superseded ones
								callback && callback(finalPimDataByItem);
							}
						}
					},
					showLoader
				);
			}
		};
	
		fetchPimData(items);
	};
	
	getFinalItemsFromPim = (pimItem, pimDataByItem) => {
		if (
			!pimItem.pimData ||
			pimItem.isInvalidSupersedure ||
			(pimItem.pimData.customer_ordered_enabled === 'Y' && (pimItem.pimData.item_status === 'Inactive' || !pimItem.supersededByItemNumbers.length))
		) {
			return [pimItem];
		}
	
		const supersededByItemNumbers = pimItem.supersededByItemNumbers ? pimItem.supersededByItemNumbers.filter(itemNumber => itemNumber !== 'NLA ITEM') : [];
		const supersededByPimItems = pimDataByItem.filter(pimItemData => supersededByItemNumbers.includes(pimItemData.itemNumber));
	
		if (supersededByPimItems.length) {
			const finalItems = [];
			supersededByPimItems.forEach(supersededByPimItem => {
				finalItems.push(...this.getFinalItemsFromPim({ ...supersededByPimItem, originalItemNumber: pimItem.originalItemNumber || pimItem.itemNumber }, pimDataByItem));
			});
			return finalItems;
		}
	
		return [pimItem];
	};
	
	callbackAfterItemDetailsCalls = (finalData, callback, options) => {
		if (
			(!options.include.pim || finalData.isPimCallFinished) &&
			(!options.include.orderability || finalData.isOrderabilityFinished) &&
			(!options.include.pricing || finalData.isPricingFinished) &&
			(!options.include.availability || finalData.isAvailabilityFinished) &&
			(!options.include.itemSearch || finalData.isItemSearchFinished)
		) {
			callback(finalData);
		}
	};
	
	getAvailabilityOrderabilityAndPricing = (initialData, finalData, callback, options) => {
		if (options.include) {
			const validItems = finalData.filterFn ? finalData.items.filter(finalData.filterFn) : finalData.items;
	
			if (validItems.length) {
				const {
					selectedPriceSource,
					selectedAccount: { ACCOUNTNUMBER: accountNumber },
					selectedAddress: selectedAddressString,
					addressList
				} = this.props.state.user;
				const selectedAddress = JSON.parse(selectedAddressString);
				const zipCode = selectedAddress.COUNTRY === 'US' ? selectedAddress.POSTALCODE.split('-')[0] : INTERNATIONAL_ZIP_CODE;
				// const addressParams =
				// 	selectedAddress.LOCATION === 'NEW_SHIP_TO_NCRP'
				// 		? `regionpostalcode=${selectedAddress.POSTALCODE && selectedAddress.POSTALCODE.split('-')[0]}&regionrulecountry=${selectedAddress.COUNTRY}`
				// 		: `shipToOrgId=${selectedAddress.SITE_USE_ID}`;
				const addressParams = `shipToOrgId=${selectedAddress.SITE_USE_ID}`;
	
				if (options.include.orderability) {
					this.checkItemOrderabilityInBatches(
						validItems.map(item => `'${item.itemNumber}'`),
						`&accountNumber=${accountNumber}&${addressParams}&orgId=82&${PNET_APP_QUERY_PARAM}`,
						null,
						options.showLoader,
						itemOrderabilityResponse => {
							finalData.isOrderabilityFinished = true;
							let isRestrictedByRightToRepairCheck = false;
							if (options.searchContext === 'PNET') {
								isRestrictedByRightToRepairCheck = ((addressList && addressList.responseObject) || []).some(address => address.PURPOSE === 'BILL_TO' && address.COUNTRY === 'US' && ['CA', 'MN', 'OR'].includes(address.STATE)) &&
									['PARTS-AWA', 'PARTS-AWB', 'PARTS-AWG', 'PARTS-AWR'].includes(selectedPriceSource['Sub Account Classification']) && selectedPriceSource.PRICE_LIST_NAME !== 'PARTS - RIGHT TO REPAIR';
							}

							validItems.forEach(item => {
								const itemOrderabilityData = itemOrderabilityResponse.find(orderabilityItem => orderabilityItem.INVENTORY_ITEM === item.itemNumber);
	
								item.orderabilityData = itemOrderabilityData;
								if (!itemOrderabilityData || itemOrderabilityData.ITEM_ORDERABILITY_FLAG !== 'Y') {
									item.isRestricted = true;
								}

								if (options.searchContext === 'PNET' && !item.isRestricted && isRestrictedByRightToRepairCheck) {
									item.isRestricted = true;
									item.restrictionReason = 'Right to Repair';
								}
							});
	
							this.callbackAfterItemDetailsCalls(finalData, callback, options);
						}
					);
				}
	
				if (options.include.pricing) {
					const agreementNumber = (initialData.agreementNumber || selectedPriceSource.AGREEMENT_NUMBER).toString();
					const pricingEffectiveDate = moment().tz('America/New_York').format('YYYYMMDD');
					const finalPricingData = [];
	
					const batches = _.chunk(
						validItems.map(item => item.itemNumber),
						150
					);
	
					const totalPricingCallsCount = batches.length;
					let completedPricingCallsCount = 0;
	
					batches.forEach(batchItems => {
						this.props.checkPricesForPartsSearchResult(
							{
								accountNumber: options.searchContext === 'NCRP' ? routes.ncrpData.accountNumber : accountNumber,
								pricingEffectiveDate,
								saNumber: agreementNumber,
								itemNumber: batchItems
							},
							options.showLoader,
							false,
							pricingResponse => {
								const batchPricingData = [];
								completedPricingCallsCount += 1;
	
								pricingResponse.responseObject &&
									pricingResponse.responseObject.items &&
									pricingResponse.responseObject.items.forEach(item => {
										if (item.records.length > 0) {
											batchPricingData.push(item);
										}
									});
	
								finalPricingData.push(...batchPricingData);
	
								if (completedPricingCallsCount === totalPricingCallsCount) {
									finalData.isPricingFinished = true;
	
									validItems.forEach(item => {
										const itemPricingData = finalPricingData.find(priceItem => priceItem.item_number === item.itemNumber);
										item.pricingData = itemPricingData;
	
										if (item.isVolumeDiscountEligible) {
											if (
												itemPricingData &&
												itemPricingData.records &&
												itemPricingData.records.some(pricingRecord => MODIFIERS_EXCLUDED_FROM_VOLUME_DISCOUNT.includes(pricingRecord.modifierPriceSubtype))
											) {
												item.isVolumeDiscountEligible = false;
											}
										}
									});
	
									this.callbackAfterItemDetailsCalls(finalData, callback, options);
								}
							}
						);
					});
				}
	
				if (options.include.availability) {
					// if single shipSet and items exceed GOP batch size, then skip GOP call as single shipset items have to be in the same batch
					if (initialData.shipSet === '1' && validItems.length > PNET_GOP_BATCH_SIZE) {
						finalData.isItemLimitExceededForSingleShipSet = true;
						finalData.isAvailabilityFinished = true;
	
						this.callbackAfterItemDetailsCalls(finalData, callback, options);
					} else {
						const availabilityPayload = validItems.map((item, index) => ({
							id: item.id,
							inventoryItemName: item.itemNumber,
							orderLineIdentifier: index + 1,
							quantityOrdered: +item.requestedQuantity || 1,
							requestDate: (item.requestedShipDate || moment()).format('YYYY-MM-DD'),
							accountNumber: options.searchContext === 'NCRP' ? routes.ncrpData.accountNumber : accountNumber,
							shipSetName: initialData.shipSet || undefined,
							zipCode,
							// itemType: options.searchContext === 'PNET' ? 'PARTS_ITEM' : item.itemType === 'PART' ? 'PARTS_ITEM' : 'FG'
							itemType: 'PARTS_ITEM'
						}));
	
						this.checkAvailabilityGenericInBatches(availabilityPayload, PNET_APP_QUERY_PARAM, '', options.showLoader, availabilityResponse => {
							finalData.isAvailabilityFinished = true;
							const combinedAvailabilityResponse = {
								responseObject: []
							};
							if (availabilityResponse && availabilityResponse.length) {
								availabilityResponse.forEach(availabilityResponseItem => {
									if (availabilityResponseItem.responseObject && availabilityResponseItem.responseObject.length) {
										combinedAvailabilityResponse.responseObject.push(...availabilityResponseItem.responseObject);
									}
								});
	
								validItems.forEach(item => {
									const itemAvailabilityData = combinedAvailabilityResponse.responseObject.find(
										availabilityItem =>
											availabilityItem.id === item.id &&
											availabilityItem.inventoryItemName === item.itemNumber
									);
									item.availabilityData = itemAvailabilityData;
								});
							}
	
							this.callbackAfterItemDetailsCalls(finalData, callback, options);
						});
					}
				}
			} else {
				finalData.isOrderabilityFinished = true;
				finalData.isPricingFinished = true;
				finalData.isAvailabilityFinished = true;
				this.callbackAfterItemDetailsCalls(finalData, callback, options);
			}
		}
	};
	
	getItemDetails = (initialData, callback, options = { showLoader: false }) => {
		const finalData = {
			items: [],
			isPimCallFinished: false,
			isOrderabilityCallFinished: false,
			isPricingCallFinished: false,
			isAvailabilityCallFinished: false
		};
	
		if (options.include && options.include.pim) {
			this.fetchPimData(
				initialData.items,
				pimDataByItem => {
					const itemsNotInPim = [];

					initialData.items.forEach(item => {
						const pimItem = pimDataByItem && pimDataByItem.find(pimItemData => pimItemData.itemNumber === item.itemNumber.toUpperCase());
	
						if (pimItem) {
							if (options.parallelCalls) {
								item.pimData = pimItem.pimData;
							} else {
								const finalPimItems = this.getFinalItemsFromPim(pimItem, pimDataByItem);
	
								finalData.items.push(
									...finalPimItems.map(pimItem => {
										if (!pimItem.pimData) {
											itemsNotInPim.push(pimItem);
										} else {
											if (
												pimItem.pimData.customer_ordered_enabled !== 'Y' ||
												pimItem.pimData.item_status === 'Inactive' ||
												(pimItem.supersededByItemNumbers && pimItem.supersededByItemNumbers[0] === 'NLA ITEM') ||
												pimItem.pimData.lifecycle_phase === 'NLA'
											) {
												pimItem.isNLA = true;
											}
											if (this.state.isPOKEnabled && pimItem.pimData.geego_pok_install === 'Y') {
												pimItem.isPOKInstall = true;
											}
											if (pimItem.pimData.geego_discount_ind === 'Y') {
												pimItem.isVolumeDiscountEligible = true;
											}
		
											if (pimItem.pimData.geego_accessory_indicator === 'Y') {
												pimItem.itemType = 'ACCESSORY';
											} else if (pimItem.pimData.icc_hierarchy && pimItem.pimData.icc_hierarchy.length && pimItem.pimData.icc_hierarchy.includes('Service Parts')) {
												pimItem.itemType = 'PART';
											}
										}
										const { id: reference, ...rest } = item;
										return {
											id: uuidv4(),
											reference,
											...rest,
											...pimItem
										};
									})
								);
							}
						}
					});

					finalData.isPimCallFinished = true;
					if (options.parallelCalls) {
						finalData.items = initialData.items;
						this.callbackAfterItemDetailsCalls(finalData, callback, options);
					} else {
						// if items are not found in PIM, we check item status to determine if they are NLA or Invalid
						if (itemsNotInPim.length || options.include.itemSearch) {
							let itemNumbers, includeAllItems = false;
							if (!options.include.itemSearch) {
								options.include = {...options.include, itemSearch: true};
								itemNumbers = itemsNotInPim.map(item => item.itemNumber);
							} else {
								itemNumbers = finalData.items.map(item => item.itemNumber);
								includeAllItems = true;
							}
							
							finalData.isItemSearchFinished = false;
							
							this.getItemsSuggestionDetails(itemNumbers, `&${PNET_APP_QUERY_PARAM}`, foundItems => {
								finalData.items.forEach(finalItem => {
									let foundItem;
									if (includeAllItems) {
										foundItem = foundItems && foundItems.find(item => item.sku === finalItem.itemNumber);
										finalItem.itemData = foundItem;
									}
									if (!finalItem.pimData) {
										if (foundItem === undefined) {
											foundItem = foundItems && foundItems.find(item => item.sku === finalItem.itemNumber);
										}
										if (foundItem && foundItem.lifeCyclePhase === 'NLA') {
											finalItem.isNLA = true;
										} else {
											finalItem.isInvalid = true;
										}
									}
								})
								finalData.isItemSearchFinished = true;
								this.callbackAfterItemDetailsCalls(finalData, callback, options);
							}, !!options.showLoader)
						}

						finalData.filterFn = item =>
							item.pimData && !item.isNLA && (options.searchContext !== 'NCRP' || ['PART', 'ACCESSORY'].includes(item.itemType)) && (options.skipPOKCheck || !item.isPOKInstall);
						this.getAvailabilityOrderabilityAndPricing(initialData, finalData, callback, options);
					}
				},
				options.showLoader
			);

			if (options.parallelCalls) {
				finalData.items = initialData.items;
				finalData.filterFn = initialData.filterFn;
				this.getAvailabilityOrderabilityAndPricing(initialData, finalData, callback, options);
			}
		} else {
			finalData.items = initialData.items;
			finalData.filterFn = initialData.filterFn;
			this.getAvailabilityOrderabilityAndPricing(initialData, finalData, callback, options);
		}
	};

	fetchFreightForwarders = callback => {
		const { user : { customerShipToDetailsAddressList, userDetails } } = this.props.state;

		const freightForwarderAddresses = customerShipToDetailsAddressList.responseObject
			.filter(
				customerShipToAddress =>
					customerShipToAddress.SHIP_TO_ACCT_DESCRIPTION.startsWith('Freight Forwarder') &&
					customerShipToAddress.PURPOSE === 'SHIP_TO' &&
					customerShipToAddress.SITE_USE_ID &&
					customerShipToAddress.PURPOSE_STATUS === 'A' &&
					customerShipToAddress.STATUS === 'A'
			)
			.map(customerShipToAddress => {
				const { POSTAL_CODE, ...rest } = customerShipToAddress;

				return {
					...rest,
					POSTALCODE: POSTAL_CODE
				};
			});

		const requests = [];
		freightForwarderAddresses.forEach(freightForwarderAddress => {
			if (freightForwarderAddress.SHIP_TO_ACCOUNT) {
				requests.push(
					sendRequest(
						bootAPIUrl,
						users.account.path,
						'',
						users.account.method,
						`accountNumber=${freightForwarderAddress.SHIP_TO_ACCOUNT}&requestType=getAccountDetails&ssoId=${userDetails.sso}`
					)
				);
			}
		});

		if (requests.length) {
			this.props.ajaxRequestInitiated();

			Promise.all(requests)
				.then(accountDetailsResponses => {
					freightForwarderAddresses.forEach(freightForwarderAddress => {
						const freightForwarderAccountDetails = accountDetailsResponses.find(
							accountDetailsResponse =>
								accountDetailsResponse.responseObject &&
								accountDetailsResponse.responseObject[0] &&
								accountDetailsResponse.responseObject[0].ACCOUNTNUMBER === freightForwarderAddress.SHIP_TO_ACCOUNT
						);

						if (freightForwarderAccountDetails) {
							freightForwarderAddress.NAME = freightForwarderAccountDetails.responseObject[0].ORGANIZATIONNAME;
						}
					});

					callback(freightForwarderAddresses);
				})
				.catch(_err => {
					callback(freightForwarderAddresses);
				})
				.finally(() => {
					this.props.ajaxRequestCompleted();
				});
		} else {
			this.setState({
				availableFreightForwarders: []
			});
		}
	};

	getASMAndDSASMSSOList = () => {
		const ssoList = [];
		const { selectedAccountAsmDetails } = this.props.state.user;
		if (selectedAccountAsmDetails) {
			(selectedAccountAsmDetails.asmList || []).concat(selectedAccountAsmDetails.dsAsmList || []).forEach(asmSSODetails => {
				if (!ssoList.includes(asmSSODetails.SALESREP_NUMBER)) {
					ssoList.push(asmSSODetails.SALESREP_NUMBER);
				}
			})
		}
		return ssoList;
	}

	getDeliveryCalendarType = shippingMethod => {
		const shippingMethodForDeliveryCalendar = SHIPPING_METHODS_FOR_DELIVERY_CALENDAR.find(shippingMethodForDeliveryCalendar => shippingMethodForDeliveryCalendar.name === shippingMethod || shippingMethodForDeliveryCalendar.name.replaceAll('-', ' ') === shippingMethod); // added extra check due to inconsistencies in the shipping method name
		return shippingMethodForDeliveryCalendar && shippingMethodForDeliveryCalendar.type;
	}

	formatOrderAvailabilityData = availabilityData => {
		return availabilityData && {
			sku: availabilityData.itemNumber,
			itemType: availabilityData.itemType,
			description: null,
			msrp: null,
			quickSpecPdfName: null,
			orderQty: availabilityData.qty,
			availableQty: availabilityData.requestedDateQuantity,
			//intransitQty: availabilityData.availableQuantity === "10000000000" ? null : availabilityData.availableQuantity,
			intransitQty: availabilityData && availabilityData.availableQuantity,
			etaDate: availabilityData.shipDate && moment(availabilityData.shipDate).format('MM/DD/YYYY'),
			warehouseCode: availabilityData.sourceOrganizationCode && availabilityData.sourceOrganizationCode.split(':').at(-1),
			finalProductionDate: null,
			firstDistributionDate: null,
			demandClass: availabilityData.demandClass,
			agreementNumber: availabilityData.agreementNumber,
			message: availabilityData.message
		};
	}

	handleAccountAndPriceSourceDialog = ({ accountNumber, show }) => {
		this.headerRef.handleAccountAndPriceSourceDialog({ accountNumber, show })
	}

    render() {
		const isPDFViewer = window.location.pathname === "/pdf-viewer"?true:false;
		const self = this;
		const isPunchOutAccess = self.props.state.user && self.props.state.user.userDetails && self.props.state.user.userDetails.punchOutAccess;
		//commenting as part of WCP-7305
		//const { selectedAddress } = this.props.state.user;
		//const canadianZip = selectedAddress && isCanadianZipCode(JSON.parse(selectedAddress).POSTALCODE);
        return (
			<div>
				{isPDFViewer
					?<div>
						{React.cloneElement(this.props.children, {getLocalStorageVar: this.getLocalStorageVar})}
						{(this.props.state.loading.showLoading)?<Loader />:null}
					</div>
					:<div>
		                <Header
							setRef={(el) => this.headerRef = el}
							isAnyModelIsRestrictedInSelectedAccount={this.isAnyModelIsRestrictedInSelectedAccount}
							hasRequestReturnAccess={this.hasRequestReturnAccess()}
							handleCreateBrochure={this.handleCreateBrochure}
							/*new brochure single change*/
							handleCreateFeature={this.handleCreateFeature}
							//isCanadianZipCode={canadianZip}
							addressException={this.state.addressException}
							checkForTokenAccountByMasterSA={checkForTokenAccountByMasterSA}
							hasRequestCreditAccess={this.hasRequestCreditAccess()}
							convertDateToTimeZone={this.convertDateToTimeZone}
							fireGTMTag={this.fireGTMTag}
							getSalesAgreementParamForAvailability={this.getSalesAgreementParamForAvailability}
							selectedADC={this.state.selectedADC}
							handleChangeADC={this.handleChangeADC}
							setDefaultADC={this.setDefaultADC}
							getPriceSheets={this.getPriceSheets}
							checkAvailabilityGeneric={this.checkAvailabilityGeneric}
							checkAvailabilityAndOrderability={this.checkAvailabilityAndOrderability}
							checkAvailabilityAndOrderability2={this.checkAvailabilityAndOrderability2}
							getSelectedAccountType={this.getSelectedAccountType}
							resetParallelCallsOrderDetails={this.resetParallelCallsOrderDetails}
							doNothing={this.doNothing}
							getOrderShippingDetails={this.getOrderShippingDetails}
							getOrderShippingDetailsDates={this.getOrderShippingDetailsDates}
							isAnyAddressCallInProgress={this.state.isAnyAddressCallInProgress}
							getShipToState={ this.getShipToState }
							isThisAccountRestricted={this.isThisAccountRestricted()}
							getZipCode={this.getZipCode}
							customZipCode={this.state.customZipCode}
							customADC={this.state.customADC}
							whichTypeOfEmployee={this.whichTypeOfEmployee}
							getState={this.getState}
							getCountry={this.getCountry}
							addErrorDetailsToStore={this.addErrorDetailsToStore}
							isEmployeeHasAccessTo={this.isEmployeeHasAccessTo}
							formatETADate={this.formatETADate}
							fetchApproveReturnsList={this.fetchApproveReturnsList}
							checkAndSetSearchResult={this.checkAndSetSearchResult}
							checkForBackOrders={this.checkForBackOrders}
							checkForBulkOrdersHold={this.checkForBulkOrdersHold}
							getCombinedAddresses={this.getCombinedAddresses}
							getAccountDetailsAndAddressList={this.getAccountDetailsAndAddressList}
							saveSelectedAccountAndPriceSourceToLocalStorage={this.saveSelectedAccountAndPriceSourceToLocalStorage}
							logout={this.logout}
							addErrorLog={this.addErrorLog}
							isShowGESKU={this.isShowGESKU()}
							getLocalStorageVar={this.getLocalStorageVar}
							getUrlParameter={this.getUrlParameter}
							getSelectedAccountNumber={this.getSelectedAccountNumber}
							getShippingAddressesDetails={this.getShippingAddressesDetails}
							fetchHomePageAssets={this.fetchHomePageAssets}
							getOrgAttributesByAttributeName={this.getOrgAttributesByAttributeName}
							isResponsibilityExists={this.isResponsibilityExists}
							makeParallelCallsForCartPrices={this.makeParallelCallsForCartPrices}
							getPimDataForCartItem={this.getPimDataForCartItem}
							getPimDataForListItem={this.getPimDataForListItem}
							showErrorsOfPage={this.showErrorsOfPage}
							path={this.props.children.props.route.path}
							history={this.state.history}
							goBack={this.goBack}
							isAccessToMAPGuidelines={this.isAccessToMAPGuidelines()}
							getPriceSources={this.getPriceSources}
							processPricingResponse={this.processPricingResponse}
							getAddressesByCategory={this.getAddressesByCategory}
							getAddressByCategory={this.getAddressByCategory}
							checkIfFP={this.checkIfFP}
							validateFDD={this.validateFDD}
							checkIfFPExceptAvailability={this.checkIfFPExceptAvailability}
							customerClassCodeOfSelectedAccount={this.getCustomerClassCodeOfSelectedAccount()}
							acceptNumbersOnly={this.acceptNumbersOnly}
							saveCustomZipCode={this.saveCustomZipCode}
							saveCustomADC={this.saveCustomADC}
							isPunchOutAccess={this.isPunchOutAccess}
							transferCart={this.transferCart}
							isGEAPartsSalesAgreementSelected={this.isGEAPartsSalesAgreementSelected}
							isInternationalPartsCustomer={this.state.isInternationalPartsCustomer}
							isFreightDocumentAvailable={this.state.isFreightDocumentAvailable}
							handleGetFreightDocument={this.handleGetFreightDocument}
							checkAvailabilityForOrder={this.checkAvailabilityForOrder}
							getItemDetails={this.getItemDetails}
							formatOrderAvailabilityData={this.formatOrderAvailabilityData}
						 />
	                    <div className={self.props.state.order.mobileView?"d-none d-sm-block content":"content"}>
							{((this.props.state.user.addressList && this.props.state.user.addressList.status && this.props.state.user.accountDetail && this.props.state.user.accountDetail.status && this.props.state.cart.cart && this.props.state.list.list &&
							this.props.state.user.selectedPriceSource && this.props.state.user.selectedAccountsAllPriceSources) || this.props.children.props.route.path === 'home' || this.props.children.props.route.path === 'order/orderreview' || this.props.children.props.route.path === 'error')
								? ((this.isGEAPartsSalesAgreementSelected() || (this.state.customZipCode && this.state.customADC)) && React.cloneElement(this.props.children, {
									getWarehouseCodeDetailsFromBackOrBulkOrder: this.getWarehouseCodeDetailsFromBackOrBulkOrder,
									getWarehouseCodeDetailsFromBackOrBulkOrderLineLevel: this.getWarehouseCodeDetailsFromBackOrBulkOrderLineLevel,
									getAttributeBySalesAgreement: this.getAttributeBySalesAgreement,
									checkAvailabilityGenericInBatches: this.checkAvailabilityGenericInBatches,
									addressException:this.state.addressException,
									isWeekday: this.isWeekday,
									checkForTokenAccountByMasterSA: checkForTokenAccountByMasterSA,
									getAddressListCombinedDataByAccountNumber: this.getAddressListCombinedDataByAccountNumber,
									updateAddressList: this.updateAddressList,
									saveCustomZipCode: this.saveCustomZipCode,
									isValidClassificationCodeForSubstitute: this.isValidClassificationCodeForSubstitute,
									saveCustomADC: this.saveCustomADC,
									isPricingAvailable: this.isPricingAvailable,
									isAccountClassificationInExceptionList: this.isAccountClassificationInExceptionList,
									isValidOrderNumer: this.isValidOrderNumer,
									isValidCLANumber: this.isValidCLANumber,
									isValidReferenceNumber: this.isValidReferenceNumber,
									showOtherFieldsInAddShippingAddress: this.showOtherFieldsInAddShippingAddress(),
									addressIdOfDefaultShippingAddress: this.getAddressIdOfDefaultShippingAddress(),
									getItemDescriptionBySKU: this.getItemDescriptionBySKU,
									getItemsSuggestionDetails: this.getItemsSuggestionDetails,
									checkAvailabilityAndOrderability: this.checkAvailabilityAndOrderability,
									checkAvailabilityInBatches: this.checkAvailabilityInBatches,
									checkOnlinePricingForParts: this.checkOnlinePricingForParts,
									handleCreateBrochure: this.handleCreateBrochure,
									/*new brochure single change*/
									handleCreateFeature: this.handleCreateFeature,
									//isCanadianZipCode: canadianZip,
									checkAvailabilityGeneric: this.checkAvailabilityGeneric,
									checkIfAnyActiveSoldAddress: this.checkIfAnyActiveSoldAddress,
									checkItemOrderabilityInBatches: this.checkItemOrderabilityInBatches,
									isMService: this.isMService,
									hasRequestReturnAccess: this.hasRequestReturnAccess(),
									hasRequestCreditAccess: this.hasRequestCreditAccess(),
									showAddNewAddressLink: this.showAddNewAddressLink(),
									customerClassCodeOfSelectedAccount: this.getCustomerClassCodeOfSelectedAccount(),
									sortyByDisplaySA: this.sortyByDisplaySA,
									convertDateToTimeZone: this.convertDateToTimeZone,
									isValidPhoneNumber: this.isValidPhoneNumber,
									accept2DecimalNumbersOnly: this.accept2DecimalNumbersOnly,
									checkAvailabilityGroupByDemandClass: this.checkAvailabilityGroupByDemandClass,
									getSalesAgreementParamForAvailability: this.getSalesAgreementParamForAvailability,
									getBrandCategory: this.getBrandCategory,
									getDefaultShippingAddressForSelectedAccount: this.getDefaultShippingAddressForSelectedAccount,
									makePriceOrderServiceCall: this.makePriceOrderServiceCall,
									isOrderAddressSameAsHeader: this.isOrderAddressSameAsHeader,
									filterLinesBySalesAgreementSameAsHeader: this.filterLinesBySalesAgreementSameAsHeader,
									getPimDataInBatches: this.getPimDataInBatches,
									isItSpecialService: this.isItSpecialService,
									isValidPONumberCharacter: this.isValidPONumberCharacter,
									manipulateClipBoardOfPONumber: this.manipulateClipBoardOfPONumber,
									getAddressFromOrderHeader: this.getAddressFromOrderHeader,
									checkIfFP: this.checkIfFP,
									isSelectedAccountNumberAsIs: this.isSelectedAccountNumberAsIs(),
									isShowGESKU: this.isShowGESKU(),
									getPriceSheets: this.getPriceSheets,
									addErrorDetailsToStore: this.addErrorDetailsToStore,
									validateFDD: this.validateFDD,
									checkInventoryFinancingSA: this.checkInventoryFinancingSA,
									formatETADate: this.formatETADate,
									makeParallelCalls: this.makeParallelCalls,
									getPriceSources: this.getPriceSources,
									getAgreementType: this.getAgreementType,
									fireGTMTag: this.fireGTMTag,
									getOrderShippingDetails: this.getOrderShippingDetails,
									getOrderShippingDetailsDates: this.getOrderShippingDetailsDates,
									checkGroupShipDateByAvailabilityAndDelivery: this.checkGroupShipDateByAvailabilityAndDelivery,
									checkIfFPExceptAvailability: this.checkIfFPExceptAvailability,
									acceptNumbersOnly: this.acceptNumbersOnly,
									acceptAlphaNumericOnly: this.acceptAlphaNumericOnly,
									acceptNumbersAndDotOnly: this.acceptNumbersAndDotOnly,
									isBackOrderHold: this.isBackOrderHold,
									isAnyModelIsRestrictedInSelectedAccount: this.isAnyModelIsRestrictedInSelectedAccount,
									isBulkOrderHold: this.isBulkOrderHold,
									getElementOffset: this.getElementOffset,
									getSelectedAccountNumber: this.getSelectedAccountNumber,
									normalizePhoneNumber: this.normalizePhoneNumber,
									whichTypeOfEmployee: this.whichTypeOfEmployee,
									isEmployeeHasAccessTo: this.isEmployeeHasAccessTo,
									formatAmount2Decimal: this.formatAmount2Decimal,
									formatDate: this.formatDate,
									checkETA: this.checkETA,
									checkAvailability: this.checkAvailability,
									add2BusinessDaysToToday: this.add2BusinessDaysToToday,
									checkForBackOrders: this.checkForBackOrders,
									checkForBulkOrdersHold: this.checkForBulkOrdersHold,
									doNothing: this.doNothing,
									isThisAccountRestricted: this.isThisAccountRestricted(),
									getUrlParameter: this.getUrlParameter,
									checkIfFPForManageOrder: this.checkIfFPForManageOrder,
									showHideLoader: this.showHideLoader,
									handlePrint: this.handlePrint,
									getIEVersion: this.getIEVersion,
									formatMoney: this.formatMoney,
									viewPDFViewer: this.viewPDFViewer,
									pickTheDateFromString: this.pickTheDateFromString,
									checkItemIsServiceOrNot: this.checkItemIsServiceOrNot,
									manipulateProductSpecsData: this.manipulateProductSpecsData,
									getLocalStorageVar: this.getLocalStorageVar,
									removeLocalStorageVar: this.removeLocalStorageVar,
									getAccountDetailsAndAddressList: this.getAccountDetailsAndAddressList,
									checkAndSetSearchResult: this.checkAndSetSearchResult,
									getZipCode: this.getZipCode,
									customZipCode: this.state.customZipCode,
									customADC: this.state.customADC,
									getState: this.getState,
									getCountry: this.getCountry,
									checkAvailabilityForOrder: this.checkAvailabilityForOrder,
									getShippingAddressesDetails: this.getShippingAddressesDetails,
									getOrgAttributesByAttributeName: this.getOrgAttributesByAttributeName,
									prepareBagItems: this.prepareBagItems,
									getItemTypeByOrderDetails: this.getItemTypeByOrderDetails,
									getSelectedAccountType: this.getSelectedAccountType,
									validateAccountNumber: this.validateAccountNumber,
									isResponsibilityExists: this.isResponsibilityExists,
									makeParallelCallsForCartPrices: this.makeParallelCallsForCartPrices,
									getPimDataForCartItem: this.getPimDataForCartItem,
									getPimDataForListItem: this.getPimDataForListItem,
									getItemTypeByName: this.getItemTypeByName,
									getItemType: this.getItemType,
									addErrorLog: this.addErrorLog,
									showErrorsOfPage: this.showErrorsOfPage,
									getOrderWeightFromPimData: this.getOrderWeightFromPimData,
									history: this.state.history,
									goBack: this.goBack,
									getLineStatusFromMapping: this.getLineStatusFromMapping,
									getLineStatusFromMappingForParts: this.getLineStatusFromMappingForParts,
									getShipToState: this.getShipToState,
									isAccessToMAPGuidelines: this.isAccessToMAPGuidelines(),
									getOrderDetailsInParallelBatches: this.getOrderDetailsInParallelBatches,
									orderDetailsOfOrderNumbers: this.state.orderDetailsOfOrderNumbers,
									allBatchesCompleted: this.state.allBatchesCompleted,
									getDataFromParallelCall: this.getDataFromParallelCall,
									getOrderDetailsFromParallelCall: this.getOrderDetailsFromParallelCall,
									resetParallelCallsOrderDetails: this.resetParallelCallsOrderDetails,
									fetchApproveReturnsList: this.fetchApproveReturnsList,
									getSalesAgreementList: this.getSalesAgreementList,
									processPricingResponse: this.processPricingResponse,
									isVelocityCustomer: this.isVelocityCustomer(),
									getAddressesByCategory: this.getAddressesByCategory,
									getAddressByCategory: this.getAddressByCategory,
									getCombinedAddresses: this.getCombinedAddresses,
									isPunchOutAccess : this.isPunchOutAccess,
									transferCart : this.transferCart,
									getPartsSalesAgreements: this.getPartsSalesAgreements,
									isGEAPartsSalesAgreementSelected: this.isGEAPartsSalesAgreementSelected,
									isInternationalPartsCustomer: this.state.isInternationalPartsCustomer,
									isPOKEnabled: this.state.isPOKEnabled,
									isFreightDocumentAvailable: this.state.isFreightDocumentAvailable,
									handleGetFreightDocument: this.handleGetFreightDocument,
									isPartsSalesAgreementsOnlyAccount: this.state.isPartsSalesAgreementsOnlyAccount,
									getItemDetails: this.getItemDetails,
									resetShipToAddress: this.resetShipToAddress,
									isAnyAddressCallInProgress: this.state.isAnyAddressCallInProgress,
									fetchFreightForwarders: this.fetchFreightForwarders,
									setDefaultADC: this.setDefaultADC,
									getASMAndDSASMSSOList: this.getASMAndDSASMSSOList,
									getDeliveryCalendarType: this.getDeliveryCalendarType,
									formatOrderAvailabilityData: this.formatOrderAvailabilityData,
									handleAccountAndPriceSourceDialog: this.handleAccountAndPriceSourceDialog
								}))
								: (this.props.state.loading.isFetching > 0 ? <Loader /> : null)
							}
							{this.state.showSelectAtleastOneProductDialog ? <GenericOverlayDialog flag={'SelectAtleastOneProductDialog'} genericDialogHeading={this.state.genericDialogHeading} genericDialogText={this.state.genericDialogText} buttons={this.state.modalButtons} handleDialog={this.handleDialog.bind(this)} showDialog={true} /> : null}
							{this.state.showWeAreSorryDialog ? <GenericOverlayDialog flag={'WeAreSorryDialog'} customClass={this.state.customClass} width={ this.state.width } genericDialogHeading={this.state.genericDialogHeading} genericDialogText={this.state.genericDialogText} buttons={this.state.modalButtons} handleDialog={this.handleDialog.bind(this)} showDialog={true} /> : null}
							{this.state.showSoldToInactiveOverlayDialog ? <GenericOverlayDialog flag={'SoldToInactiveOverlayDialog'} genericDialogHeading={this.state.genericDialogHeading} genericDialogText={this.state.genericDialogText} buttons={this.state.modalButtons} handleDialog={this.handleDialog.bind(this)} showDialog={true} /> : null}
							{this.state.showAddToBrochureOverlayDialog ? <AddToBrochureOverlayDialog getSelectedAccountNumber={this.getSelectedAccountNumber} flag={'AddToBrochureOverlayDialog'} handleDialog={this.handleDialog.bind(this)} showDialog={true} /> : null }
							{this.getSelectedAccountNumber() && this.props.state.user.selectedPriceSource && this.state.lastLoginDate === false && isPunchOutAccess === false && !this.state.isPartsSalesAgreementsOnlyAccount
								&& <NotificationUpdateConfirmationOverlayDialog showDialog={true} isPunchOutAccess={isPunchOutAccess}/>}
		                </div>
						{this.props.state.loading.isFetching > 0 ? <Loader /> : null}
		                <Footer fireGTMTag={this.fireGTMTag} hideFooterInfForPunchOut={isPunchOutAccess}/>
					</div>
				}
			</div>
        );
    }
}

const mapStateToProps = (state) => {
	return {state};
};

const mapDispatchToProps = (dispatch) => ({
	getOrderDetails: (queryStringParams, callback, saveInStore) => dispatch(getOrderDetails(queryStringParams, callback, saveInStore)),
	resetErrorsObjectInStore: () => dispatch(resetErrorsObjectInStore()),
	resetBrochureObjectInStore: () => dispatch(resetBrochureObjectInStore()),
	resetExportObjectInStore: () => dispatch(resetExportObjectInStore()),
	resetHomePageObjectInStore: () => dispatch(resetHomePageObjectInStore()),
	resetLoadingObjectInStore: () => dispatch(resetLoadingObjectInStore()),
	resetOrderObjectInStore: () => dispatch(resetOrderObjectInStore()),
	resetPackageObjectInStore: () => dispatch(resetPackageObjectInStore()),
	resetPriceTagsObjectInStore: () => dispatch(resetPriceTagsObjectInStore()),
	resetProductObjectInStore: () => dispatch(resetProductObjectInStore()),
	resetRegistrationObjectInStore: () => dispatch(resetRegistrationObjectInStore()),
	resetResourcesObjectInStore: () => dispatch(resetResourcesObjectInStore()),
	resetSearchKeywordObjectInStore: () => dispatch(resetSearchKeywordObjectInStore()),
	resetUserObjectInStore: () => dispatch(resetUserObjectInStore()),
	saveUserDetails: (data) => dispatch(saveUserDetails(data)),
	updateCartOrderPoints: (data) => dispatch(updateCartOrderPoints(data)),
	saveApprovedAccountDetails: (data) => dispatch(saveApprovedAccountDetails(data)),
	saveSelectedAccountAndPriceSource: (data) => dispatch(saveSelectedAccountAndPriceSource(data)),
	resetCartObjectInStore: () => dispatch(resetCartObjectInStore()),
	resetListObjectInStore: () => dispatch(resetListObjectInStore()),
	resetPricesToCart: () => dispatch(resetPricesToCart()),
	resetServicesPricesToCart: () => dispatch(resetServicesPricesToCart()),
	resetAvailabilityToCart: () => dispatch(resetAvailabilityToCart()),
	resetAvailabilityToList: () => dispatch(resetAvailabilityToList()),
	getAccountDetails: (queryStringParams, showLoader, callback) => dispatch(getAccountDetails(queryStringParams, showLoader, callback)),
	getAddressList: (queryStringParams, showLoader, callback) => dispatch(getAddressList(queryStringParams, showLoader, callback)),
	getRelationShipPartyList: (queryStringParams, showLoader, callback) => dispatch(getRelationShipPartyList(queryStringParams, showLoader, callback)),
	getAllTcaList: (payload, showLoader, callback) => dispatch(getAllTcaList(payload, showLoader, callback)),
	getAllAdjPrcMod: (payload, showLoader, callback) => dispatch(getAllAdjPrcMod(payload, showLoader, callback)),
	saveAccountDetail: (data) => dispatch(saveAccountDetail(data)),
	saveAddressList: (data) => dispatch(saveAddressList(data)),
	addressExceptionDispatch:(flag)=>dispatch(addressExceptionDispatch(flag)),
	saveRelationShipPartyList: (data) => dispatch(saveRelationShipPartyList(data)),
	saveAllTcaList: (data) => dispatch(saveAllTcaList(data)),
	saveAllAdjPrcModifier: (data) => dispatch(saveAllAdjPrcModifier(data)),
	checkForBackOrders: (data, showLoader, callback) => dispatch(checkForBackOrders(data, showLoader, callback)),
	checkForBulkOrdersHold: (data, showLoader, callback) => dispatch(checkForBulkOrdersHold(data, showLoader, callback)),
	saveIsBackOrdersAvailable: (data) => dispatch(saveIsBackOrdersAvailable(data)),
	saveIsBulkOrdersHoldAvailable: (data) => dispatch(saveIsBulkOrdersHoldAvailable(data)),
	saveUserOtherDetails: (data) => dispatch(saveUserOtherDetails(data)),
	getAddressAttributes: (data, showLoader, callback) => dispatch(getAddressAttributes(data, showLoader, callback)),
	saveAddressAttributes: (data) => dispatch(saveAddressAttributes(data)),
	updateUserASMOrNot: (data) => dispatch(updateUserASMOrNot(data)),
	checkOtherAccountASM: (queryStringParams, callback) => dispatch(checkOtherAccountASM(queryStringParams, callback)),
	updateUserIsInDLOrNot: (data) => dispatch(updateUserIsInDLOrNot(data)),
	getLocalUserDetails: (data, showLoader, callback) => dispatch(getLocalUserDetails(data, showLoader, callback)),
	getUsersOfAccount: (data, showLoader, callback) => dispatch(getUsersOfAccount(data, showLoader, callback)),
	updateUserAdminOrNot: (data) => dispatch(updateUserAdminOrNot(data)),
	getList: (data, showLoader, callback) => dispatch(getList(data, showLoader, callback)),
	getCart: (data, showLoader, callback) => dispatch(getCart(data, showLoader, callback)),
	saveNumberOfParallelCallForProductPrices: (data) => dispatch(saveNumberOfParallelCallForProductPrices(data)),
	checkPricesForSearchResult: (data, showLoader, saveToStore, callback) => dispatch(checkPricesForSearchResult(data, showLoader, saveToStore, callback)),
	saveCompletedNumberOfParallelCallForProductPrices: () => dispatch(saveCompletedNumberOfParallelCallForProductPrices()),
	getProductNumberKeywordResult: (searchStr, filters, params, typeOfSearch, callback, whichSearch) => dispatch(getProductNumberKeywordResult(searchStr, filters, params, typeOfSearch, callback, whichSearch)),
	saveProductAvailabilityCallCompleted: (data) => dispatch(saveProductAvailabilityCallCompleted(data)),
	checkAvailabilityGeneric: (payload, hybridQueryParams, whereToSave, showLoader, callback, redirectToError) => dispatch(checkAvailabilityGeneric(payload, hybridQueryParams, whereToSave, showLoader, callback, redirectToError)),
	checkItemOrderability: (queryString, showLoader, callback) => dispatch(checkItemOrderability(queryString, showLoader, callback)),
	resetProductNumberKeywordResultList: () => dispatch(resetProductNumberKeywordResultList()),
	resetProductAvailabilityResultList: () => dispatch(resetProductAvailabilityResultList()),
	resetProductPricesResultList: () => dispatch(resetProductPricesResultList()),
	saveShippingAddresses: (data) => dispatch(saveShippingAddresses(data)),
	updateHomePageAssetsFromBackup: (data) => dispatch(updateHomePageAssetsFromBackup(data)),
	saveSelectedAccountsAllPriceSources: (data) => dispatch(saveSelectedAccountsAllPriceSources(data)),
	getSelectedAccountsPriceSource: (queryStringParams, callback) => dispatch(getSelectedAccountsPriceSource(queryStringParams, callback)),
	getShippingAddresses: (queryStringParams, showLoader, callback) => dispatch(getShippingAddresses(queryStringParams, showLoader, callback)),
	getOrgAttributes: (queryStringParams, callback) => dispatch(getOrgAttributes(queryStringParams, callback)),
	saveOrgAttributes: (data) => dispatch(saveOrgAttributes(data)),
	getPIMItemInfo: (payload, params, response, showLoader) => dispatch(getPIMItemInfo(payload, params, response, showLoader)),
	resetSearchKeywordSuggestionList: () => dispatch(resetSearchKeywordSuggestionList()),
	resetShippingAddresses: () => dispatch(resetShippingAddresses()),
	saveGEAccountNumbers: (data) => dispatch(saveGEAccountNumbers(data)),
	validateAccountNumber: (data, callback) => dispatch(validateAccountNumber(data, callback)),
	getOrderList: (data, callback) => dispatch(getOrderList(data, callback)),
	adminDLCheck: (data, callback) => dispatch(adminDLCheck(data, callback)),
	checkManageSiteAccess: (data, callback) => dispatch(checkManageSiteAccess(data, callback)),
	saveRequestReturnList: (data) => dispatch(saveRequestReturnList(data)),
	addErrorLogToStore: (data) => dispatch(addErrorLogToStore(data)),
	resetPricesToOrder: (data) => dispatch(resetPricesToOrder(data)),
	saveApproveReturnsList: (data) => dispatch(saveApproveReturnsList(data)),
	getCustomerShipToDetails: (payload, showLoader, callback) => dispatch(getCustomerShipToDetails(payload, showLoader, callback)),
	saveCustomerShipToDetails: (data) => dispatch(saveCustomerShipToDetails(data)),
	otherCustomerShipToDetailsForOrder: (data) => dispatch(otherCustomerShipToDetailsForOrder(data)),
	updateSelectedAddress: (data) => dispatch(updateSelectedAddress(data)),
	saveLoadIndicatorBySiteNumber: (data) => dispatch(saveLoadIndicatorBySiteNumber(data)),
	resetLoadIndicatorBySiteNumber: () => dispatch(resetLoadIndicatorBySiteNumber()),
	updateLoadIndicatorBySiteNumber: (data) => dispatch(updateLoadIndicatorBySiteNumber(data)),
	getAssets: (showLoader, callback) => dispatch(getAssets(showLoader, callback)),
	getSalesRepId: (payload, callback, redirectToError) => dispatch(getSalesRepId(payload, callback, redirectToError)),
	getSSOFromSalesRepId: (payload, callback) => dispatch(getSSOFromSalesRepId(payload, callback)),
	populateLatestHomePageAssets: () => dispatch(populateLatestHomePageAssets()),
	saveRoleList: (data) => dispatch(saveRoleList(data)),
	setDefaultADC: (data) => dispatch(setDefaultADC(data)),
	setSelectedADC: (data) => dispatch(setSelectedADC(data)),
	setAvailabilityError: (data) => dispatch(setAvailabilityError(data)),
	checkForPrices: (payload, showLoader, saveToStore, cartOrOrder, response) => dispatch(checkForPrices(payload, showLoader, saveToStore, cartOrOrder, response)),
	savePimDataForList: (data) => dispatch(savePimDataForList(data)),
	saveBackOrders: (data) => dispatch(saveBackOrders(data)),
	getAccountResponsibility: (queryString, callback) => dispatch(getAccountResponsibility(queryString, callback)),
	addErrorDetailsToStore: (data) => dispatch(addErrorDetailsToStore(data)),
	savePriceSheets: (data) => dispatch(savePriceSheets(data)),
	saveAvailabilityToCart: (data) => dispatch(saveAvailabilityToCart(data)),
	saveAccountResponsibility: (data) => dispatch(saveAccountResponsibility(data)),
	getTokenAccount: (queryString, callback) => dispatch(getTokenAccount(queryString, callback)),
	getDocuments: (queryStringParams, willSaveToStore, callback) => dispatch(getDocuments(queryStringParams, willSaveToStore, callback)),
	ajaxRequestInitiated: () => dispatch(ajaxRequestInitiated()),
	ajaxRequestCompleted: () => dispatch(ajaxRequestCompleted()),
	getPriceOrder: (payload, params, response) => dispatch(getPriceOrder(payload, params, response)),
	updateSelectedItems: (payload) => dispatch(updateSelectedItems(payload)),
	resetBrochurePayload: (accountNumber) => dispatch(resetBrochurePayload(accountNumber)),
	selectBrochureCreateOption: (data) => dispatch(selectBrochureCreateOption(data)),
	/*new brochure single change*/
	selectFeatureCreateOption: (data) => dispatch(selectFeatureCreateOption(data)),
	saveAvailabilityToList: (data) => dispatch(saveAvailabilityToList(data)),
	saveBackupCartItem: (data) => dispatch(saveBackupCartItem(data)),
	saveAllJobSiteAddressList: (data) => dispatch(saveAllJobSiteAddressList(data)),
	checkServicePrices: (payload, params, response) => dispatch(checkServicePrices(payload, params, response)),
	saveProductResultAvailability: (data) => dispatch(saveProductResultAvailability(data)),
    getSavedBrochures: (queryStringParams, callback) => dispatch(getSavedBrochures(queryStringParams, callback)),
	saveSelectedAccountsAllPriceSourcesWithoutFilter: (data) => dispatch(saveSelectedAccountsAllPriceSourcesWithoutFilter(data)),
	postPunchOutData: (data,postUrl,callback) => dispatch(postPunchOutData(data,postUrl,callback)),
	getFileURL: (path, queryString, callback) => dispatch(getFileURL(path, queryString, callback)),
	checkForPartsPrices: (payload, showLoader, saveToStore, cartOrOrder, callback) => dispatch(checkForPartsPrices(payload, showLoader, saveToStore, cartOrOrder, callback)),
	checkPricesForPartsSearchResult: (data, showLoader, saveToStore, callback) => dispatch(checkPricesForPartsSearchResult(data, showLoader, saveToStore, callback)),
	clearPartsSearchResult: () => dispatch(clearPartsSearchResult()),
	saveSelectedAccountASMDetails: data => dispatch(saveSelectedAccountASMDetails(data)),
	setIsDpmAccount: data => dispatch(setIsDpmAccount(data))
});

App = connect(mapStateToProps, mapDispatchToProps)(App);
export default App;



// WEBPACK FOOTER //
// ./src/App/components/PostLogin/App.js